// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * Emoji data based on the data available from https://github.com/iamcal/emoji-data.
 *
 * @module core/emoji/data
 * @copyright  2019 Ryan Wyllie <ryan@moodle.com>
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

export const byCategory = [
    {
        "name": "Smileys & People",
        "emojis": [
            {
                "unified": "1F600",
                "shortnames": [
                    "grinning"
                ]
            },
            {
                "unified": "1F601",
                "shortnames": [
                    "grin"
                ]
            },
            {
                "unified": "1F602",
                "shortnames": [
                    "joy"
                ]
            },
            {
                "unified": "1F923",
                "shortnames": [
                    "rolling_on_the_floor_laughing"
                ]
            },
            {
                "unified": "1F603",
                "shortnames": [
                    "smiley"
                ]
            },
            {
                "unified": "1F604",
                "shortnames": [
                    "smile"
                ]
            },
            {
                "unified": "1F605",
                "shortnames": [
                    "sweat_smile"
                ]
            },
            {
                "unified": "1F606",
                "shortnames": [
                    "laughing"
                ]
            },
            {
                "unified": "1F609",
                "shortnames": [
                    "wink"
                ]
            },
            {
                "unified": "1F60A",
                "shortnames": [
                    "blush"
                ]
            },
            {
                "unified": "1F60B",
                "shortnames": [
                    "yum"
                ]
            },
            {
                "unified": "1F60E",
                "shortnames": [
                    "sunglasses"
                ]
            },
            {
                "unified": "1F60D",
                "shortnames": [
                    "heart_eyes"
                ]
            },
            {
                "unified": "1F618",
                "shortnames": [
                    "kissing_heart"
                ]
            },
            {
                "unified": "1F617",
                "shortnames": [
                    "kissing"
                ]
            },
            {
                "unified": "1F619",
                "shortnames": [
                    "kissing_smiling_eyes"
                ]
            },
            {
                "unified": "1F61A",
                "shortnames": [
                    "kissing_closed_eyes"
                ]
            },
            {
                "unified": "263A-FE0F",
                "shortnames": [
                    "relaxed"
                ]
            },
            {
                "unified": "1F642",
                "shortnames": [
                    "slightly_smiling_face"
                ]
            },
            {
                "unified": "1F917",
                "shortnames": [
                    "hugging_face"
                ]
            },
            {
                "unified": "1F929",
                "shortnames": [
                    "star-struck"
                ]
            },
            {
                "unified": "1F914",
                "shortnames": [
                    "thinking_face"
                ]
            },
            {
                "unified": "1F928",
                "shortnames": [
                    "face_with_raised_eyebrow"
                ]
            },
            {
                "unified": "1F610",
                "shortnames": [
                    "neutral_face"
                ]
            },
            {
                "unified": "1F611",
                "shortnames": [
                    "expressionless"
                ]
            },
            {
                "unified": "1F636",
                "shortnames": [
                    "no_mouth"
                ]
            },
            {
                "unified": "1F644",
                "shortnames": [
                    "face_with_rolling_eyes"
                ]
            },
            {
                "unified": "1F60F",
                "shortnames": [
                    "smirk"
                ]
            },
            {
                "unified": "1F623",
                "shortnames": [
                    "persevere"
                ]
            },
            {
                "unified": "1F625",
                "shortnames": [
                    "disappointed_relieved"
                ]
            },
            {
                "unified": "1F62E",
                "shortnames": [
                    "open_mouth"
                ]
            },
            {
                "unified": "1F910",
                "shortnames": [
                    "zipper_mouth_face"
                ]
            },
            {
                "unified": "1F62F",
                "shortnames": [
                    "hushed"
                ]
            },
            {
                "unified": "1F62A",
                "shortnames": [
                    "sleepy"
                ]
            },
            {
                "unified": "1F62B",
                "shortnames": [
                    "tired_face"
                ]
            },
            {
                "unified": "1F634",
                "shortnames": [
                    "sleeping"
                ]
            },
            {
                "unified": "1F60C",
                "shortnames": [
                    "relieved"
                ]
            },
            {
                "unified": "1F61B",
                "shortnames": [
                    "stuck_out_tongue"
                ]
            },
            {
                "unified": "1F61C",
                "shortnames": [
                    "stuck_out_tongue_winking_eye"
                ]
            },
            {
                "unified": "1F61D",
                "shortnames": [
                    "stuck_out_tongue_closed_eyes"
                ]
            },
            {
                "unified": "1F924",
                "shortnames": [
                    "drooling_face"
                ]
            },
            {
                "unified": "1F612",
                "shortnames": [
                    "unamused"
                ]
            },
            {
                "unified": "1F613",
                "shortnames": [
                    "sweat"
                ]
            },
            {
                "unified": "1F614",
                "shortnames": [
                    "pensive"
                ]
            },
            {
                "unified": "1F615",
                "shortnames": [
                    "confused"
                ]
            },
            {
                "unified": "1F643",
                "shortnames": [
                    "upside_down_face"
                ]
            },
            {
                "unified": "1F911",
                "shortnames": [
                    "money_mouth_face"
                ]
            },
            {
                "unified": "1F632",
                "shortnames": [
                    "astonished"
                ]
            },
            {
                "unified": "2639-FE0F",
                "shortnames": [
                    "white_frowning_face"
                ]
            },
            {
                "unified": "1F641",
                "shortnames": [
                    "slightly_frowning_face"
                ]
            },
            {
                "unified": "1F616",
                "shortnames": [
                    "confounded"
                ]
            },
            {
                "unified": "1F61E",
                "shortnames": [
                    "disappointed"
                ]
            },
            {
                "unified": "1F61F",
                "shortnames": [
                    "worried"
                ]
            },
            {
                "unified": "1F624",
                "shortnames": [
                    "triumph"
                ]
            },
            {
                "unified": "1F622",
                "shortnames": [
                    "cry"
                ]
            },
            {
                "unified": "1F62D",
                "shortnames": [
                    "sob"
                ]
            },
            {
                "unified": "1F626",
                "shortnames": [
                    "frowning"
                ]
            },
            {
                "unified": "1F627",
                "shortnames": [
                    "anguished"
                ]
            },
            {
                "unified": "1F628",
                "shortnames": [
                    "fearful"
                ]
            },
            {
                "unified": "1F629",
                "shortnames": [
                    "weary"
                ]
            },
            {
                "unified": "1F92F",
                "shortnames": [
                    "exploding_head"
                ]
            },
            {
                "unified": "1F62C",
                "shortnames": [
                    "grimacing"
                ]
            },
            {
                "unified": "1F630",
                "shortnames": [
                    "cold_sweat"
                ]
            },
            {
                "unified": "1F631",
                "shortnames": [
                    "scream"
                ]
            },
            {
                "unified": "1F633",
                "shortnames": [
                    "flushed"
                ]
            },
            {
                "unified": "1F92A",
                "shortnames": [
                    "zany_face"
                ]
            },
            {
                "unified": "1F635",
                "shortnames": [
                    "dizzy_face"
                ]
            },
            {
                "unified": "1F621",
                "shortnames": [
                    "rage"
                ]
            },
            {
                "unified": "1F620",
                "shortnames": [
                    "angry"
                ]
            },
            {
                "unified": "1F92C",
                "shortnames": [
                    "face_with_symbols_on_mouth"
                ]
            },
            {
                "unified": "1F637",
                "shortnames": [
                    "mask"
                ]
            },
            {
                "unified": "1F912",
                "shortnames": [
                    "face_with_thermometer"
                ]
            },
            {
                "unified": "1F915",
                "shortnames": [
                    "face_with_head_bandage"
                ]
            },
            {
                "unified": "1F922",
                "shortnames": [
                    "nauseated_face"
                ]
            },
            {
                "unified": "1F92E",
                "shortnames": [
                    "face_vomiting"
                ]
            },
            {
                "unified": "1F927",
                "shortnames": [
                    "sneezing_face"
                ]
            },
            {
                "unified": "1F607",
                "shortnames": [
                    "innocent"
                ]
            },
            {
                "unified": "1F920",
                "shortnames": [
                    "face_with_cowboy_hat"
                ]
            },
            {
                "unified": "1F921",
                "shortnames": [
                    "clown_face"
                ]
            },
            {
                "unified": "1F925",
                "shortnames": [
                    "lying_face"
                ]
            },
            {
                "unified": "1F92B",
                "shortnames": [
                    "shushing_face"
                ]
            },
            {
                "unified": "1F92D",
                "shortnames": [
                    "face_with_hand_over_mouth"
                ]
            },
            {
                "unified": "1F9D0",
                "shortnames": [
                    "face_with_monocle"
                ]
            },
            {
                "unified": "1F913",
                "shortnames": [
                    "nerd_face"
                ]
            },
            {
                "unified": "1F608",
                "shortnames": [
                    "smiling_imp"
                ]
            },
            {
                "unified": "1F47F",
                "shortnames": [
                    "imp"
                ]
            },
            {
                "unified": "1F479",
                "shortnames": [
                    "japanese_ogre"
                ]
            },
            {
                "unified": "1F47A",
                "shortnames": [
                    "japanese_goblin"
                ]
            },
            {
                "unified": "1F480",
                "shortnames": [
                    "skull"
                ]
            },
            {
                "unified": "2620-FE0F",
                "shortnames": [
                    "skull_and_crossbones"
                ]
            },
            {
                "unified": "1F47B",
                "shortnames": [
                    "ghost"
                ]
            },
            {
                "unified": "1F47D",
                "shortnames": [
                    "alien"
                ]
            },
            {
                "unified": "1F47E",
                "shortnames": [
                    "space_invader"
                ]
            },
            {
                "unified": "1F916",
                "shortnames": [
                    "robot_face"
                ]
            },
            {
                "unified": "1F4A9",
                "shortnames": [
                    "hankey"
                ]
            },
            {
                "unified": "1F63A",
                "shortnames": [
                    "smiley_cat"
                ]
            },
            {
                "unified": "1F638",
                "shortnames": [
                    "smile_cat"
                ]
            },
            {
                "unified": "1F639",
                "shortnames": [
                    "joy_cat"
                ]
            },
            {
                "unified": "1F63B",
                "shortnames": [
                    "heart_eyes_cat"
                ]
            },
            {
                "unified": "1F63C",
                "shortnames": [
                    "smirk_cat"
                ]
            },
            {
                "unified": "1F63D",
                "shortnames": [
                    "kissing_cat"
                ]
            },
            {
                "unified": "1F640",
                "shortnames": [
                    "scream_cat"
                ]
            },
            {
                "unified": "1F63F",
                "shortnames": [
                    "crying_cat_face"
                ]
            },
            {
                "unified": "1F63E",
                "shortnames": [
                    "pouting_cat"
                ]
            },
            {
                "unified": "1F648",
                "shortnames": [
                    "see_no_evil"
                ]
            },
            {
                "unified": "1F649",
                "shortnames": [
                    "hear_no_evil"
                ]
            },
            {
                "unified": "1F64A",
                "shortnames": [
                    "speak_no_evil"
                ]
            },
            {
                "unified": "1F476",
                "shortnames": [
                    "baby"
                ]
            },
            {
                "unified": "1F9D2",
                "shortnames": [
                    "child"
                ]
            },
            {
                "unified": "1F466",
                "shortnames": [
                    "boy"
                ]
            },
            {
                "unified": "1F467",
                "shortnames": [
                    "girl"
                ]
            },
            {
                "unified": "1F9D1",
                "shortnames": [
                    "adult"
                ]
            },
            {
                "unified": "1F468",
                "shortnames": [
                    "man"
                ]
            },
            {
                "unified": "1F469",
                "shortnames": [
                    "woman"
                ]
            },
            {
                "unified": "1F9D3",
                "shortnames": [
                    "older_adult"
                ]
            },
            {
                "unified": "1F474",
                "shortnames": [
                    "older_man"
                ]
            },
            {
                "unified": "1F475",
                "shortnames": [
                    "older_woman"
                ]
            },
            {
                "unified": "1F468-200D-2695-FE0F",
                "shortnames": [
                    "male-doctor"
                ]
            },
            {
                "unified": "1F469-200D-2695-FE0F",
                "shortnames": [
                    "female-doctor"
                ]
            },
            {
                "unified": "1F468-200D-1F393",
                "shortnames": [
                    "male-student"
                ]
            },
            {
                "unified": "1F469-200D-1F393",
                "shortnames": [
                    "female-student"
                ]
            },
            {
                "unified": "1F468-200D-1F3EB",
                "shortnames": [
                    "male-teacher"
                ]
            },
            {
                "unified": "1F469-200D-1F3EB",
                "shortnames": [
                    "female-teacher"
                ]
            },
            {
                "unified": "1F468-200D-2696-FE0F",
                "shortnames": [
                    "male-judge"
                ]
            },
            {
                "unified": "1F469-200D-2696-FE0F",
                "shortnames": [
                    "female-judge"
                ]
            },
            {
                "unified": "1F468-200D-1F33E",
                "shortnames": [
                    "male-farmer"
                ]
            },
            {
                "unified": "1F469-200D-1F33E",
                "shortnames": [
                    "female-farmer"
                ]
            },
            {
                "unified": "1F468-200D-1F373",
                "shortnames": [
                    "male-cook"
                ]
            },
            {
                "unified": "1F469-200D-1F373",
                "shortnames": [
                    "female-cook"
                ]
            },
            {
                "unified": "1F468-200D-1F527",
                "shortnames": [
                    "male-mechanic"
                ]
            },
            {
                "unified": "1F469-200D-1F527",
                "shortnames": [
                    "female-mechanic"
                ]
            },
            {
                "unified": "1F468-200D-1F3ED",
                "shortnames": [
                    "male-factory-worker"
                ]
            },
            {
                "unified": "1F469-200D-1F3ED",
                "shortnames": [
                    "female-factory-worker"
                ]
            },
            {
                "unified": "1F468-200D-1F4BC",
                "shortnames": [
                    "male-office-worker"
                ]
            },
            {
                "unified": "1F469-200D-1F4BC",
                "shortnames": [
                    "female-office-worker"
                ]
            },
            {
                "unified": "1F468-200D-1F52C",
                "shortnames": [
                    "male-scientist"
                ]
            },
            {
                "unified": "1F469-200D-1F52C",
                "shortnames": [
                    "female-scientist"
                ]
            },
            {
                "unified": "1F468-200D-1F4BB",
                "shortnames": [
                    "male-technologist"
                ]
            },
            {
                "unified": "1F469-200D-1F4BB",
                "shortnames": [
                    "female-technologist"
                ]
            },
            {
                "unified": "1F468-200D-1F3A4",
                "shortnames": [
                    "male-singer"
                ]
            },
            {
                "unified": "1F469-200D-1F3A4",
                "shortnames": [
                    "female-singer"
                ]
            },
            {
                "unified": "1F468-200D-1F3A8",
                "shortnames": [
                    "male-artist"
                ]
            },
            {
                "unified": "1F469-200D-1F3A8",
                "shortnames": [
                    "female-artist"
                ]
            },
            {
                "unified": "1F468-200D-2708-FE0F",
                "shortnames": [
                    "male-pilot"
                ]
            },
            {
                "unified": "1F469-200D-2708-FE0F",
                "shortnames": [
                    "female-pilot"
                ]
            },
            {
                "unified": "1F468-200D-1F680",
                "shortnames": [
                    "male-astronaut"
                ]
            },
            {
                "unified": "1F469-200D-1F680",
                "shortnames": [
                    "female-astronaut"
                ]
            },
            {
                "unified": "1F468-200D-1F692",
                "shortnames": [
                    "male-firefighter"
                ]
            },
            {
                "unified": "1F469-200D-1F692",
                "shortnames": [
                    "female-firefighter"
                ]
            },
            {
                "unified": "1F46E-200D-2642-FE0F",
                "shortnames": [
                    "male-police-officer",
                    "cop"
                ]
            },
            {
                "unified": "1F46E-200D-2640-FE0F",
                "shortnames": [
                    "female-police-officer"
                ]
            },
            {
                "unified": "1F575-FE0F-200D-2642-FE0F",
                "shortnames": [
                    "male-detective",
                    "sleuth_or_spy"
                ]
            },
            {
                "unified": "1F575-FE0F-200D-2640-FE0F",
                "shortnames": [
                    "female-detective"
                ]
            },
            {
                "unified": "1F482-200D-2642-FE0F",
                "shortnames": [
                    "male-guard",
                    "guardsman"
                ]
            },
            {
                "unified": "1F482-200D-2640-FE0F",
                "shortnames": [
                    "female-guard"
                ]
            },
            {
                "unified": "1F477-200D-2642-FE0F",
                "shortnames": [
                    "male-construction-worker",
                    "construction_worker"
                ]
            },
            {
                "unified": "1F477-200D-2640-FE0F",
                "shortnames": [
                    "female-construction-worker"
                ]
            },
            {
                "unified": "1F934",
                "shortnames": [
                    "prince"
                ]
            },
            {
                "unified": "1F478",
                "shortnames": [
                    "princess"
                ]
            },
            {
                "unified": "1F473-200D-2642-FE0F",
                "shortnames": [
                    "man-wearing-turban",
                    "man_with_turban"
                ]
            },
            {
                "unified": "1F473-200D-2640-FE0F",
                "shortnames": [
                    "woman-wearing-turban"
                ]
            },
            {
                "unified": "1F472",
                "shortnames": [
                    "man_with_gua_pi_mao"
                ]
            },
            {
                "unified": "1F9D5",
                "shortnames": [
                    "person_with_headscarf"
                ]
            },
            {
                "unified": "1F9D4",
                "shortnames": [
                    "bearded_person"
                ]
            },
            {
                "unified": "1F471-200D-2642-FE0F",
                "shortnames": [
                    "blond-haired-man",
                    "person_with_blond_hair"
                ]
            },
            {
                "unified": "1F471-200D-2640-FE0F",
                "shortnames": [
                    "blond-haired-woman"
                ]
            },
            {
                "unified": "1F935",
                "shortnames": [
                    "man_in_tuxedo"
                ]
            },
            {
                "unified": "1F470",
                "shortnames": [
                    "bride_with_veil"
                ]
            },
            {
                "unified": "1F930",
                "shortnames": [
                    "pregnant_woman"
                ]
            },
            {
                "unified": "1F931",
                "shortnames": [
                    "breast-feeding"
                ]
            },
            {
                "unified": "1F47C",
                "shortnames": [
                    "angel"
                ]
            },
            {
                "unified": "1F385",
                "shortnames": [
                    "santa"
                ]
            },
            {
                "unified": "1F936",
                "shortnames": [
                    "mrs_claus"
                ]
            },
            {
                "unified": "1F9D9-200D-2640-FE0F",
                "shortnames": [
                    "female_mage",
                    "mage"
                ]
            },
            {
                "unified": "1F9D9-200D-2642-FE0F",
                "shortnames": [
                    "male_mage"
                ]
            },
            {
                "unified": "1F9DA-200D-2640-FE0F",
                "shortnames": [
                    "female_fairy",
                    "fairy"
                ]
            },
            {
                "unified": "1F9DA-200D-2642-FE0F",
                "shortnames": [
                    "male_fairy"
                ]
            },
            {
                "unified": "1F9DB-200D-2640-FE0F",
                "shortnames": [
                    "female_vampire",
                    "vampire"
                ]
            },
            {
                "unified": "1F9DB-200D-2642-FE0F",
                "shortnames": [
                    "male_vampire"
                ]
            },
            {
                "unified": "1F9DC-200D-2640-FE0F",
                "shortnames": [
                    "mermaid"
                ]
            },
            {
                "unified": "1F9DC-200D-2642-FE0F",
                "shortnames": [
                    "merman",
                    "merperson"
                ]
            },
            {
                "unified": "1F9DD-200D-2640-FE0F",
                "shortnames": [
                    "female_elf"
                ]
            },
            {
                "unified": "1F9DD-200D-2642-FE0F",
                "shortnames": [
                    "male_elf",
                    "elf"
                ]
            },
            {
                "unified": "1F9DE-200D-2640-FE0F",
                "shortnames": [
                    "female_genie"
                ]
            },
            {
                "unified": "1F9DE-200D-2642-FE0F",
                "shortnames": [
                    "male_genie",
                    "genie"
                ]
            },
            {
                "unified": "1F9DF-200D-2640-FE0F",
                "shortnames": [
                    "female_zombie"
                ]
            },
            {
                "unified": "1F9DF-200D-2642-FE0F",
                "shortnames": [
                    "male_zombie",
                    "zombie"
                ]
            },
            {
                "unified": "1F64D-200D-2642-FE0F",
                "shortnames": [
                    "man-frowning"
                ]
            },
            {
                "unified": "1F64D-200D-2640-FE0F",
                "shortnames": [
                    "woman-frowning",
                    "person_frowning"
                ]
            },
            {
                "unified": "1F64E-200D-2642-FE0F",
                "shortnames": [
                    "man-pouting"
                ]
            },
            {
                "unified": "1F64E-200D-2640-FE0F",
                "shortnames": [
                    "woman-pouting",
                    "person_with_pouting_face"
                ]
            },
            {
                "unified": "1F645-200D-2642-FE0F",
                "shortnames": [
                    "man-gesturing-no"
                ]
            },
            {
                "unified": "1F645-200D-2640-FE0F",
                "shortnames": [
                    "woman-gesturing-no",
                    "no_good"
                ]
            },
            {
                "unified": "1F646-200D-2642-FE0F",
                "shortnames": [
                    "man-gesturing-ok"
                ]
            },
            {
                "unified": "1F646-200D-2640-FE0F",
                "shortnames": [
                    "woman-gesturing-ok",
                    "ok_woman"
                ]
            },
            {
                "unified": "1F481-200D-2642-FE0F",
                "shortnames": [
                    "man-tipping-hand"
                ]
            },
            {
                "unified": "1F481-200D-2640-FE0F",
                "shortnames": [
                    "woman-tipping-hand",
                    "information_desk_person"
                ]
            },
            {
                "unified": "1F64B-200D-2642-FE0F",
                "shortnames": [
                    "man-raising-hand"
                ]
            },
            {
                "unified": "1F64B-200D-2640-FE0F",
                "shortnames": [
                    "woman-raising-hand",
                    "raising_hand"
                ]
            },
            {
                "unified": "1F647-200D-2642-FE0F",
                "shortnames": [
                    "man-bowing",
                    "bow"
                ]
            },
            {
                "unified": "1F647-200D-2640-FE0F",
                "shortnames": [
                    "woman-bowing"
                ]
            },
            {
                "unified": "1F926",
                "shortnames": [
                    "face_palm"
                ]
            },
            {
                "unified": "1F926-200D-2642-FE0F",
                "shortnames": [
                    "man-facepalming"
                ]
            },
            {
                "unified": "1F926-200D-2640-FE0F",
                "shortnames": [
                    "woman-facepalming"
                ]
            },
            {
                "unified": "1F937",
                "shortnames": [
                    "shrug"
                ]
            },
            {
                "unified": "1F937-200D-2642-FE0F",
                "shortnames": [
                    "man-shrugging"
                ]
            },
            {
                "unified": "1F937-200D-2640-FE0F",
                "shortnames": [
                    "woman-shrugging"
                ]
            },
            {
                "unified": "1F486-200D-2642-FE0F",
                "shortnames": [
                    "man-getting-massage"
                ]
            },
            {
                "unified": "1F486-200D-2640-FE0F",
                "shortnames": [
                    "woman-getting-massage",
                    "massage"
                ]
            },
            {
                "unified": "1F487-200D-2642-FE0F",
                "shortnames": [
                    "man-getting-haircut"
                ]
            },
            {
                "unified": "1F487-200D-2640-FE0F",
                "shortnames": [
                    "woman-getting-haircut",
                    "haircut"
                ]
            },
            {
                "unified": "1F6B6-200D-2642-FE0F",
                "shortnames": [
                    "man-walking",
                    "walking"
                ]
            },
            {
                "unified": "1F6B6-200D-2640-FE0F",
                "shortnames": [
                    "woman-walking"
                ]
            },
            {
                "unified": "1F3C3-200D-2642-FE0F",
                "shortnames": [
                    "man-running",
                    "runner"
                ]
            },
            {
                "unified": "1F3C3-200D-2640-FE0F",
                "shortnames": [
                    "woman-running"
                ]
            },
            {
                "unified": "1F483",
                "shortnames": [
                    "dancer"
                ]
            },
            {
                "unified": "1F57A",
                "shortnames": [
                    "man_dancing"
                ]
            },
            {
                "unified": "1F46F-200D-2642-FE0F",
                "shortnames": [
                    "man-with-bunny-ears-partying"
                ]
            },
            {
                "unified": "1F46F-200D-2640-FE0F",
                "shortnames": [
                    "woman-with-bunny-ears-partying",
                    "dancers"
                ]
            },
            {
                "unified": "1F9D6-200D-2640-FE0F",
                "shortnames": [
                    "woman_in_steamy_room"
                ]
            },
            {
                "unified": "1F9D6-200D-2642-FE0F",
                "shortnames": [
                    "man_in_steamy_room",
                    "person_in_steamy_room"
                ]
            },
            {
                "unified": "1F9D7-200D-2640-FE0F",
                "shortnames": [
                    "woman_climbing",
                    "person_climbing"
                ]
            },
            {
                "unified": "1F9D7-200D-2642-FE0F",
                "shortnames": [
                    "man_climbing"
                ]
            },
            {
                "unified": "1F9D8-200D-2640-FE0F",
                "shortnames": [
                    "woman_in_lotus_position",
                    "person_in_lotus_position"
                ]
            },
            {
                "unified": "1F9D8-200D-2642-FE0F",
                "shortnames": [
                    "man_in_lotus_position"
                ]
            },
            {
                "unified": "1F6C0",
                "shortnames": [
                    "bath"
                ]
            },
            {
                "unified": "1F6CC",
                "shortnames": [
                    "sleeping_accommodation"
                ]
            },
            {
                "unified": "1F574-FE0F",
                "shortnames": [
                    "man_in_business_suit_levitating"
                ]
            },
            {
                "unified": "1F5E3-FE0F",
                "shortnames": [
                    "speaking_head_in_silhouette"
                ]
            },
            {
                "unified": "1F464",
                "shortnames": [
                    "bust_in_silhouette"
                ]
            },
            {
                "unified": "1F465",
                "shortnames": [
                    "busts_in_silhouette"
                ]
            },
            {
                "unified": "1F93A",
                "shortnames": [
                    "fencer"
                ]
            },
            {
                "unified": "1F3C7",
                "shortnames": [
                    "horse_racing"
                ]
            },
            {
                "unified": "26F7-FE0F",
                "shortnames": [
                    "skier"
                ]
            },
            {
                "unified": "1F3C2",
                "shortnames": [
                    "snowboarder"
                ]
            },
            {
                "unified": "1F3CC-FE0F-200D-2642-FE0F",
                "shortnames": [
                    "man-golfing",
                    "golfer"
                ]
            },
            {
                "unified": "1F3CC-FE0F-200D-2640-FE0F",
                "shortnames": [
                    "woman-golfing"
                ]
            },
            {
                "unified": "1F3C4-200D-2642-FE0F",
                "shortnames": [
                    "man-surfing",
                    "surfer"
                ]
            },
            {
                "unified": "1F3C4-200D-2640-FE0F",
                "shortnames": [
                    "woman-surfing"
                ]
            },
            {
                "unified": "1F6A3-200D-2642-FE0F",
                "shortnames": [
                    "man-rowing-boat",
                    "rowboat"
                ]
            },
            {
                "unified": "1F6A3-200D-2640-FE0F",
                "shortnames": [
                    "woman-rowing-boat"
                ]
            },
            {
                "unified": "1F3CA-200D-2642-FE0F",
                "shortnames": [
                    "man-swimming",
                    "swimmer"
                ]
            },
            {
                "unified": "1F3CA-200D-2640-FE0F",
                "shortnames": [
                    "woman-swimming"
                ]
            },
            {
                "unified": "26F9-FE0F-200D-2642-FE0F",
                "shortnames": [
                    "man-bouncing-ball",
                    "person_with_ball"
                ]
            },
            {
                "unified": "26F9-FE0F-200D-2640-FE0F",
                "shortnames": [
                    "woman-bouncing-ball"
                ]
            },
            {
                "unified": "1F3CB-FE0F-200D-2642-FE0F",
                "shortnames": [
                    "man-lifting-weights",
                    "weight_lifter"
                ]
            },
            {
                "unified": "1F3CB-FE0F-200D-2640-FE0F",
                "shortnames": [
                    "woman-lifting-weights"
                ]
            },
            {
                "unified": "1F6B4-200D-2642-FE0F",
                "shortnames": [
                    "man-biking",
                    "bicyclist"
                ]
            },
            {
                "unified": "1F6B4-200D-2640-FE0F",
                "shortnames": [
                    "woman-biking"
                ]
            },
            {
                "unified": "1F6B5-200D-2642-FE0F",
                "shortnames": [
                    "man-mountain-biking",
                    "mountain_bicyclist"
                ]
            },
            {
                "unified": "1F6B5-200D-2640-FE0F",
                "shortnames": [
                    "woman-mountain-biking"
                ]
            },
            {
                "unified": "1F3CE-FE0F",
                "shortnames": [
                    "racing_car"
                ]
            },
            {
                "unified": "1F3CD-FE0F",
                "shortnames": [
                    "racing_motorcycle"
                ]
            },
            {
                "unified": "1F938",
                "shortnames": [
                    "person_doing_cartwheel"
                ]
            },
            {
                "unified": "1F938-200D-2642-FE0F",
                "shortnames": [
                    "man-cartwheeling"
                ]
            },
            {
                "unified": "1F938-200D-2640-FE0F",
                "shortnames": [
                    "woman-cartwheeling"
                ]
            },
            {
                "unified": "1F93C",
                "shortnames": [
                    "wrestlers"
                ]
            },
            {
                "unified": "1F93C-200D-2642-FE0F",
                "shortnames": [
                    "man-wrestling"
                ]
            },
            {
                "unified": "1F93C-200D-2640-FE0F",
                "shortnames": [
                    "woman-wrestling"
                ]
            },
            {
                "unified": "1F93D",
                "shortnames": [
                    "water_polo"
                ]
            },
            {
                "unified": "1F93D-200D-2642-FE0F",
                "shortnames": [
                    "man-playing-water-polo"
                ]
            },
            {
                "unified": "1F93D-200D-2640-FE0F",
                "shortnames": [
                    "woman-playing-water-polo"
                ]
            },
            {
                "unified": "1F93E",
                "shortnames": [
                    "handball"
                ]
            },
            {
                "unified": "1F93E-200D-2642-FE0F",
                "shortnames": [
                    "man-playing-handball"
                ]
            },
            {
                "unified": "1F93E-200D-2640-FE0F",
                "shortnames": [
                    "woman-playing-handball"
                ]
            },
            {
                "unified": "1F939",
                "shortnames": [
                    "juggling"
                ]
            },
            {
                "unified": "1F939-200D-2642-FE0F",
                "shortnames": [
                    "man-juggling"
                ]
            },
            {
                "unified": "1F939-200D-2640-FE0F",
                "shortnames": [
                    "woman-juggling"
                ]
            },
            {
                "unified": "1F46B",
                "shortnames": [
                    "couple"
                ]
            },
            {
                "unified": "1F46C",
                "shortnames": [
                    "two_men_holding_hands"
                ]
            },
            {
                "unified": "1F46D",
                "shortnames": [
                    "two_women_holding_hands"
                ]
            },
            {
                "unified": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
                "shortnames": [
                    "woman-kiss-man",
                    "couplekiss"
                ]
            },
            {
                "unified": "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
                "shortnames": [
                    "man-kiss-man"
                ]
            },
            {
                "unified": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
                "shortnames": [
                    "woman-kiss-woman"
                ]
            },
            {
                "unified": "1F469-200D-2764-FE0F-200D-1F468",
                "shortnames": [
                    "woman-heart-man",
                    "couple_with_heart"
                ]
            },
            {
                "unified": "1F468-200D-2764-FE0F-200D-1F468",
                "shortnames": [
                    "man-heart-man"
                ]
            },
            {
                "unified": "1F469-200D-2764-FE0F-200D-1F469",
                "shortnames": [
                    "woman-heart-woman"
                ]
            },
            {
                "unified": "1F468-200D-1F469-200D-1F466",
                "shortnames": [
                    "man-woman-boy",
                    "family"
                ]
            },
            {
                "unified": "1F468-200D-1F469-200D-1F467",
                "shortnames": [
                    "man-woman-girl"
                ]
            },
            {
                "unified": "1F468-200D-1F469-200D-1F467-200D-1F466",
                "shortnames": [
                    "man-woman-girl-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F469-200D-1F466-200D-1F466",
                "shortnames": [
                    "man-woman-boy-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F469-200D-1F467-200D-1F467",
                "shortnames": [
                    "man-woman-girl-girl"
                ]
            },
            {
                "unified": "1F468-200D-1F468-200D-1F466",
                "shortnames": [
                    "man-man-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F468-200D-1F467",
                "shortnames": [
                    "man-man-girl"
                ]
            },
            {
                "unified": "1F468-200D-1F468-200D-1F467-200D-1F466",
                "shortnames": [
                    "man-man-girl-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F468-200D-1F466-200D-1F466",
                "shortnames": [
                    "man-man-boy-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F468-200D-1F467-200D-1F467",
                "shortnames": [
                    "man-man-girl-girl"
                ]
            },
            {
                "unified": "1F469-200D-1F469-200D-1F466",
                "shortnames": [
                    "woman-woman-boy"
                ]
            },
            {
                "unified": "1F469-200D-1F469-200D-1F467",
                "shortnames": [
                    "woman-woman-girl"
                ]
            },
            {
                "unified": "1F469-200D-1F469-200D-1F467-200D-1F466",
                "shortnames": [
                    "woman-woman-girl-boy"
                ]
            },
            {
                "unified": "1F469-200D-1F469-200D-1F466-200D-1F466",
                "shortnames": [
                    "woman-woman-boy-boy"
                ]
            },
            {
                "unified": "1F469-200D-1F469-200D-1F467-200D-1F467",
                "shortnames": [
                    "woman-woman-girl-girl"
                ]
            },
            {
                "unified": "1F468-200D-1F466",
                "shortnames": [
                    "man-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F466-200D-1F466",
                "shortnames": [
                    "man-boy-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F467",
                "shortnames": [
                    "man-girl"
                ]
            },
            {
                "unified": "1F468-200D-1F467-200D-1F466",
                "shortnames": [
                    "man-girl-boy"
                ]
            },
            {
                "unified": "1F468-200D-1F467-200D-1F467",
                "shortnames": [
                    "man-girl-girl"
                ]
            },
            {
                "unified": "1F469-200D-1F466",
                "shortnames": [
                    "woman-boy"
                ]
            },
            {
                "unified": "1F469-200D-1F466-200D-1F466",
                "shortnames": [
                    "woman-boy-boy"
                ]
            },
            {
                "unified": "1F469-200D-1F467",
                "shortnames": [
                    "woman-girl"
                ]
            },
            {
                "unified": "1F469-200D-1F467-200D-1F466",
                "shortnames": [
                    "woman-girl-boy"
                ]
            },
            {
                "unified": "1F469-200D-1F467-200D-1F467",
                "shortnames": [
                    "woman-girl-girl"
                ]
            },
            {
                "unified": "1F933",
                "shortnames": [
                    "selfie"
                ]
            },
            {
                "unified": "1F4AA",
                "shortnames": [
                    "muscle"
                ]
            },
            {
                "unified": "1F448",
                "shortnames": [
                    "point_left"
                ]
            },
            {
                "unified": "1F449",
                "shortnames": [
                    "point_right"
                ]
            },
            {
                "unified": "261D-FE0F",
                "shortnames": [
                    "point_up"
                ]
            },
            {
                "unified": "1F446",
                "shortnames": [
                    "point_up_2"
                ]
            },
            {
                "unified": "1F595",
                "shortnames": [
                    "middle_finger"
                ]
            },
            {
                "unified": "1F447",
                "shortnames": [
                    "point_down"
                ]
            },
            {
                "unified": "270C-FE0F",
                "shortnames": [
                    "v"
                ]
            },
            {
                "unified": "1F91E",
                "shortnames": [
                    "crossed_fingers"
                ]
            },
            {
                "unified": "1F596",
                "shortnames": [
                    "spock-hand"
                ]
            },
            {
                "unified": "1F918",
                "shortnames": [
                    "the_horns"
                ]
            },
            {
                "unified": "1F919",
                "shortnames": [
                    "call_me_hand"
                ]
            },
            {
                "unified": "1F590-FE0F",
                "shortnames": [
                    "raised_hand_with_fingers_splayed"
                ]
            },
            {
                "unified": "270B",
                "shortnames": [
                    "hand"
                ]
            },
            {
                "unified": "1F44C",
                "shortnames": [
                    "ok_hand"
                ]
            },
            {
                "unified": "1F44D",
                "shortnames": [
                    "+1"
                ]
            },
            {
                "unified": "1F44E",
                "shortnames": [
                    "-1"
                ]
            },
            {
                "unified": "270A",
                "shortnames": [
                    "fist"
                ]
            },
            {
                "unified": "1F44A",
                "shortnames": [
                    "facepunch"
                ]
            },
            {
                "unified": "1F91B",
                "shortnames": [
                    "left-facing_fist"
                ]
            },
            {
                "unified": "1F91C",
                "shortnames": [
                    "right-facing_fist"
                ]
            },
            {
                "unified": "1F91A",
                "shortnames": [
                    "raised_back_of_hand"
                ]
            },
            {
                "unified": "1F44B",
                "shortnames": [
                    "wave"
                ]
            },
            {
                "unified": "1F91F",
                "shortnames": [
                    "i_love_you_hand_sign"
                ]
            },
            {
                "unified": "270D-FE0F",
                "shortnames": [
                    "writing_hand"
                ]
            },
            {
                "unified": "1F44F",
                "shortnames": [
                    "clap"
                ]
            },
            {
                "unified": "1F450",
                "shortnames": [
                    "open_hands"
                ]
            },
            {
                "unified": "1F64C",
                "shortnames": [
                    "raised_hands"
                ]
            },
            {
                "unified": "1F932",
                "shortnames": [
                    "palms_up_together"
                ]
            },
            {
                "unified": "1F64F",
                "shortnames": [
                    "pray"
                ]
            },
            {
                "unified": "1F91D",
                "shortnames": [
                    "handshake"
                ]
            },
            {
                "unified": "1F485",
                "shortnames": [
                    "nail_care"
                ]
            },
            {
                "unified": "1F442",
                "shortnames": [
                    "ear"
                ]
            },
            {
                "unified": "1F443",
                "shortnames": [
                    "nose"
                ]
            },
            {
                "unified": "1F463",
                "shortnames": [
                    "footprints"
                ]
            },
            {
                "unified": "1F440",
                "shortnames": [
                    "eyes"
                ]
            },
            {
                "unified": "1F441-FE0F",
                "shortnames": [
                    "eye"
                ]
            },
            {
                "unified": "1F441-FE0F-200D-1F5E8-FE0F",
                "shortnames": [
                    "eye-in-speech-bubble"
                ]
            },
            {
                "unified": "1F9E0",
                "shortnames": [
                    "brain"
                ]
            },
            {
                "unified": "1F445",
                "shortnames": [
                    "tongue"
                ]
            },
            {
                "unified": "1F444",
                "shortnames": [
                    "lips"
                ]
            },
            {
                "unified": "1F48B",
                "shortnames": [
                    "kiss"
                ]
            },
            {
                "unified": "1F498",
                "shortnames": [
                    "cupid"
                ]
            },
            {
                "unified": "2764-FE0F",
                "shortnames": [
                    "heart"
                ]
            },
            {
                "unified": "1F493",
                "shortnames": [
                    "heartbeat"
                ]
            },
            {
                "unified": "1F494",
                "shortnames": [
                    "broken_heart"
                ]
            },
            {
                "unified": "1F495",
                "shortnames": [
                    "two_hearts"
                ]
            },
            {
                "unified": "1F496",
                "shortnames": [
                    "sparkling_heart"
                ]
            },
            {
                "unified": "1F497",
                "shortnames": [
                    "heartpulse"
                ]
            },
            {
                "unified": "1F499",
                "shortnames": [
                    "blue_heart"
                ]
            },
            {
                "unified": "1F49A",
                "shortnames": [
                    "green_heart"
                ]
            },
            {
                "unified": "1F49B",
                "shortnames": [
                    "yellow_heart"
                ]
            },
            {
                "unified": "1F9E1",
                "shortnames": [
                    "orange_heart"
                ]
            },
            {
                "unified": "1F49C",
                "shortnames": [
                    "purple_heart"
                ]
            },
            {
                "unified": "1F5A4",
                "shortnames": [
                    "black_heart"
                ]
            },
            {
                "unified": "1F49D",
                "shortnames": [
                    "gift_heart"
                ]
            },
            {
                "unified": "1F49E",
                "shortnames": [
                    "revolving_hearts"
                ]
            },
            {
                "unified": "1F49F",
                "shortnames": [
                    "heart_decoration"
                ]
            },
            {
                "unified": "2763-FE0F",
                "shortnames": [
                    "heavy_heart_exclamation_mark_ornament"
                ]
            },
            {
                "unified": "1F48C",
                "shortnames": [
                    "love_letter"
                ]
            },
            {
                "unified": "1F4A4",
                "shortnames": [
                    "zzz"
                ]
            },
            {
                "unified": "1F4A2",
                "shortnames": [
                    "anger"
                ]
            },
            {
                "unified": "1F4A3",
                "shortnames": [
                    "bomb"
                ]
            },
            {
                "unified": "1F4A5",
                "shortnames": [
                    "boom"
                ]
            },
            {
                "unified": "1F4A6",
                "shortnames": [
                    "sweat_drops"
                ]
            },
            {
                "unified": "1F4A8",
                "shortnames": [
                    "dash"
                ]
            },
            {
                "unified": "1F4AB",
                "shortnames": [
                    "dizzy"
                ]
            },
            {
                "unified": "1F4AC",
                "shortnames": [
                    "speech_balloon"
                ]
            },
            {
                "unified": "1F5E8-FE0F",
                "shortnames": [
                    "left_speech_bubble"
                ]
            },
            {
                "unified": "1F5EF-FE0F",
                "shortnames": [
                    "right_anger_bubble"
                ]
            },
            {
                "unified": "1F4AD",
                "shortnames": [
                    "thought_balloon"
                ]
            },
            {
                "unified": "1F573-FE0F",
                "shortnames": [
                    "hole"
                ]
            },
            {
                "unified": "1F453",
                "shortnames": [
                    "eyeglasses"
                ]
            },
            {
                "unified": "1F576-FE0F",
                "shortnames": [
                    "dark_sunglasses"
                ]
            },
            {
                "unified": "1F454",
                "shortnames": [
                    "necktie"
                ]
            },
            {
                "unified": "1F455",
                "shortnames": [
                    "shirt"
                ]
            },
            {
                "unified": "1F456",
                "shortnames": [
                    "jeans"
                ]
            },
            {
                "unified": "1F9E3",
                "shortnames": [
                    "scarf"
                ]
            },
            {
                "unified": "1F9E4",
                "shortnames": [
                    "gloves"
                ]
            },
            {
                "unified": "1F9E5",
                "shortnames": [
                    "coat"
                ]
            },
            {
                "unified": "1F9E6",
                "shortnames": [
                    "socks"
                ]
            },
            {
                "unified": "1F457",
                "shortnames": [
                    "dress"
                ]
            },
            {
                "unified": "1F458",
                "shortnames": [
                    "kimono"
                ]
            },
            {
                "unified": "1F459",
                "shortnames": [
                    "bikini"
                ]
            },
            {
                "unified": "1F45A",
                "shortnames": [
                    "womans_clothes"
                ]
            },
            {
                "unified": "1F45B",
                "shortnames": [
                    "purse"
                ]
            },
            {
                "unified": "1F45C",
                "shortnames": [
                    "handbag"
                ]
            },
            {
                "unified": "1F45D",
                "shortnames": [
                    "pouch"
                ]
            },
            {
                "unified": "1F6CD-FE0F",
                "shortnames": [
                    "shopping_bags"
                ]
            },
            {
                "unified": "1F392",
                "shortnames": [
                    "school_satchel"
                ]
            },
            {
                "unified": "1F45E",
                "shortnames": [
                    "mans_shoe"
                ]
            },
            {
                "unified": "1F45F",
                "shortnames": [
                    "athletic_shoe"
                ]
            },
            {
                "unified": "1F460",
                "shortnames": [
                    "high_heel"
                ]
            },
            {
                "unified": "1F461",
                "shortnames": [
                    "sandal"
                ]
            },
            {
                "unified": "1F462",
                "shortnames": [
                    "boot"
                ]
            },
            {
                "unified": "1F451",
                "shortnames": [
                    "crown"
                ]
            },
            {
                "unified": "1F452",
                "shortnames": [
                    "womans_hat"
                ]
            },
            {
                "unified": "1F3A9",
                "shortnames": [
                    "tophat"
                ]
            },
            {
                "unified": "1F393",
                "shortnames": [
                    "mortar_board"
                ]
            },
            {
                "unified": "1F9E2",
                "shortnames": [
                    "billed_cap"
                ]
            },
            {
                "unified": "26D1-FE0F",
                "shortnames": [
                    "helmet_with_white_cross"
                ]
            },
            {
                "unified": "1F4FF",
                "shortnames": [
                    "prayer_beads"
                ]
            },
            {
                "unified": "1F484",
                "shortnames": [
                    "lipstick"
                ]
            },
            {
                "unified": "1F48D",
                "shortnames": [
                    "ring"
                ]
            },
            {
                "unified": "1F48E",
                "shortnames": [
                    "gem"
                ]
            }
        ]
    },
    {
        "name": "Animals & Nature",
        "emojis": [
            {
                "unified": "1F435",
                "shortnames": [
                    "monkey_face"
                ]
            },
            {
                "unified": "1F412",
                "shortnames": [
                    "monkey"
                ]
            },
            {
                "unified": "1F98D",
                "shortnames": [
                    "gorilla"
                ]
            },
            {
                "unified": "1F436",
                "shortnames": [
                    "dog"
                ]
            },
            {
                "unified": "1F415",
                "shortnames": [
                    "dog2"
                ]
            },
            {
                "unified": "1F429",
                "shortnames": [
                    "poodle"
                ]
            },
            {
                "unified": "1F43A",
                "shortnames": [
                    "wolf"
                ]
            },
            {
                "unified": "1F98A",
                "shortnames": [
                    "fox_face"
                ]
            },
            {
                "unified": "1F431",
                "shortnames": [
                    "cat"
                ]
            },
            {
                "unified": "1F408",
                "shortnames": [
                    "cat2"
                ]
            },
            {
                "unified": "1F981",
                "shortnames": [
                    "lion_face"
                ]
            },
            {
                "unified": "1F42F",
                "shortnames": [
                    "tiger"
                ]
            },
            {
                "unified": "1F405",
                "shortnames": [
                    "tiger2"
                ]
            },
            {
                "unified": "1F406",
                "shortnames": [
                    "leopard"
                ]
            },
            {
                "unified": "1F434",
                "shortnames": [
                    "horse"
                ]
            },
            {
                "unified": "1F40E",
                "shortnames": [
                    "racehorse"
                ]
            },
            {
                "unified": "1F984",
                "shortnames": [
                    "unicorn_face"
                ]
            },
            {
                "unified": "1F993",
                "shortnames": [
                    "zebra_face"
                ]
            },
            {
                "unified": "1F98C",
                "shortnames": [
                    "deer"
                ]
            },
            {
                "unified": "1F42E",
                "shortnames": [
                    "cow"
                ]
            },
            {
                "unified": "1F402",
                "shortnames": [
                    "ox"
                ]
            },
            {
                "unified": "1F403",
                "shortnames": [
                    "water_buffalo"
                ]
            },
            {
                "unified": "1F404",
                "shortnames": [
                    "cow2"
                ]
            },
            {
                "unified": "1F437",
                "shortnames": [
                    "pig"
                ]
            },
            {
                "unified": "1F416",
                "shortnames": [
                    "pig2"
                ]
            },
            {
                "unified": "1F417",
                "shortnames": [
                    "boar"
                ]
            },
            {
                "unified": "1F43D",
                "shortnames": [
                    "pig_nose"
                ]
            },
            {
                "unified": "1F40F",
                "shortnames": [
                    "ram"
                ]
            },
            {
                "unified": "1F411",
                "shortnames": [
                    "sheep"
                ]
            },
            {
                "unified": "1F410",
                "shortnames": [
                    "goat"
                ]
            },
            {
                "unified": "1F42A",
                "shortnames": [
                    "dromedary_camel"
                ]
            },
            {
                "unified": "1F42B",
                "shortnames": [
                    "camel"
                ]
            },
            {
                "unified": "1F992",
                "shortnames": [
                    "giraffe_face"
                ]
            },
            {
                "unified": "1F418",
                "shortnames": [
                    "elephant"
                ]
            },
            {
                "unified": "1F98F",
                "shortnames": [
                    "rhinoceros"
                ]
            },
            {
                "unified": "1F42D",
                "shortnames": [
                    "mouse"
                ]
            },
            {
                "unified": "1F401",
                "shortnames": [
                    "mouse2"
                ]
            },
            {
                "unified": "1F400",
                "shortnames": [
                    "rat"
                ]
            },
            {
                "unified": "1F439",
                "shortnames": [
                    "hamster"
                ]
            },
            {
                "unified": "1F430",
                "shortnames": [
                    "rabbit"
                ]
            },
            {
                "unified": "1F407",
                "shortnames": [
                    "rabbit2"
                ]
            },
            {
                "unified": "1F43F-FE0F",
                "shortnames": [
                    "chipmunk"
                ]
            },
            {
                "unified": "1F994",
                "shortnames": [
                    "hedgehog"
                ]
            },
            {
                "unified": "1F987",
                "shortnames": [
                    "bat"
                ]
            },
            {
                "unified": "1F43B",
                "shortnames": [
                    "bear"
                ]
            },
            {
                "unified": "1F428",
                "shortnames": [
                    "koala"
                ]
            },
            {
                "unified": "1F43C",
                "shortnames": [
                    "panda_face"
                ]
            },
            {
                "unified": "1F43E",
                "shortnames": [
                    "feet"
                ]
            },
            {
                "unified": "1F983",
                "shortnames": [
                    "turkey"
                ]
            },
            {
                "unified": "1F414",
                "shortnames": [
                    "chicken"
                ]
            },
            {
                "unified": "1F413",
                "shortnames": [
                    "rooster"
                ]
            },
            {
                "unified": "1F423",
                "shortnames": [
                    "hatching_chick"
                ]
            },
            {
                "unified": "1F424",
                "shortnames": [
                    "baby_chick"
                ]
            },
            {
                "unified": "1F425",
                "shortnames": [
                    "hatched_chick"
                ]
            },
            {
                "unified": "1F426",
                "shortnames": [
                    "bird"
                ]
            },
            {
                "unified": "1F427",
                "shortnames": [
                    "penguin"
                ]
            },
            {
                "unified": "1F54A-FE0F",
                "shortnames": [
                    "dove_of_peace"
                ]
            },
            {
                "unified": "1F985",
                "shortnames": [
                    "eagle"
                ]
            },
            {
                "unified": "1F986",
                "shortnames": [
                    "duck"
                ]
            },
            {
                "unified": "1F989",
                "shortnames": [
                    "owl"
                ]
            },
            {
                "unified": "1F438",
                "shortnames": [
                    "frog"
                ]
            },
            {
                "unified": "1F40A",
                "shortnames": [
                    "crocodile"
                ]
            },
            {
                "unified": "1F422",
                "shortnames": [
                    "turtle"
                ]
            },
            {
                "unified": "1F98E",
                "shortnames": [
                    "lizard"
                ]
            },
            {
                "unified": "1F40D",
                "shortnames": [
                    "snake"
                ]
            },
            {
                "unified": "1F432",
                "shortnames": [
                    "dragon_face"
                ]
            },
            {
                "unified": "1F409",
                "shortnames": [
                    "dragon"
                ]
            },
            {
                "unified": "1F995",
                "shortnames": [
                    "sauropod"
                ]
            },
            {
                "unified": "1F996",
                "shortnames": [
                    "t-rex"
                ]
            },
            {
                "unified": "1F433",
                "shortnames": [
                    "whale"
                ]
            },
            {
                "unified": "1F40B",
                "shortnames": [
                    "whale2"
                ]
            },
            {
                "unified": "1F42C",
                "shortnames": [
                    "dolphin"
                ]
            },
            {
                "unified": "1F41F",
                "shortnames": [
                    "fish"
                ]
            },
            {
                "unified": "1F420",
                "shortnames": [
                    "tropical_fish"
                ]
            },
            {
                "unified": "1F421",
                "shortnames": [
                    "blowfish"
                ]
            },
            {
                "unified": "1F988",
                "shortnames": [
                    "shark"
                ]
            },
            {
                "unified": "1F419",
                "shortnames": [
                    "octopus"
                ]
            },
            {
                "unified": "1F41A",
                "shortnames": [
                    "shell"
                ]
            },
            {
                "unified": "1F980",
                "shortnames": [
                    "crab"
                ]
            },
            {
                "unified": "1F990",
                "shortnames": [
                    "shrimp"
                ]
            },
            {
                "unified": "1F991",
                "shortnames": [
                    "squid"
                ]
            },
            {
                "unified": "1F40C",
                "shortnames": [
                    "snail"
                ]
            },
            {
                "unified": "1F98B",
                "shortnames": [
                    "butterfly"
                ]
            },
            {
                "unified": "1F41B",
                "shortnames": [
                    "bug"
                ]
            },
            {
                "unified": "1F41C",
                "shortnames": [
                    "ant"
                ]
            },
            {
                "unified": "1F41D",
                "shortnames": [
                    "bee"
                ]
            },
            {
                "unified": "1F41E",
                "shortnames": [
                    "beetle"
                ]
            },
            {
                "unified": "1F997",
                "shortnames": [
                    "cricket"
                ]
            },
            {
                "unified": "1F577-FE0F",
                "shortnames": [
                    "spider"
                ]
            },
            {
                "unified": "1F578-FE0F",
                "shortnames": [
                    "spider_web"
                ]
            },
            {
                "unified": "1F982",
                "shortnames": [
                    "scorpion"
                ]
            },
            {
                "unified": "1F490",
                "shortnames": [
                    "bouquet"
                ]
            },
            {
                "unified": "1F338",
                "shortnames": [
                    "cherry_blossom"
                ]
            },
            {
                "unified": "1F4AE",
                "shortnames": [
                    "white_flower"
                ]
            },
            {
                "unified": "1F3F5-FE0F",
                "shortnames": [
                    "rosette"
                ]
            },
            {
                "unified": "1F339",
                "shortnames": [
                    "rose"
                ]
            },
            {
                "unified": "1F940",
                "shortnames": [
                    "wilted_flower"
                ]
            },
            {
                "unified": "1F33A",
                "shortnames": [
                    "hibiscus"
                ]
            },
            {
                "unified": "1F33B",
                "shortnames": [
                    "sunflower"
                ]
            },
            {
                "unified": "1F33C",
                "shortnames": [
                    "blossom"
                ]
            },
            {
                "unified": "1F337",
                "shortnames": [
                    "tulip"
                ]
            },
            {
                "unified": "1F331",
                "shortnames": [
                    "seedling"
                ]
            },
            {
                "unified": "1F332",
                "shortnames": [
                    "evergreen_tree"
                ]
            },
            {
                "unified": "1F333",
                "shortnames": [
                    "deciduous_tree"
                ]
            },
            {
                "unified": "1F334",
                "shortnames": [
                    "palm_tree"
                ]
            },
            {
                "unified": "1F335",
                "shortnames": [
                    "cactus"
                ]
            },
            {
                "unified": "1F33E",
                "shortnames": [
                    "ear_of_rice"
                ]
            },
            {
                "unified": "1F33F",
                "shortnames": [
                    "herb"
                ]
            },
            {
                "unified": "2618-FE0F",
                "shortnames": [
                    "shamrock"
                ]
            },
            {
                "unified": "1F340",
                "shortnames": [
                    "four_leaf_clover"
                ]
            },
            {
                "unified": "1F341",
                "shortnames": [
                    "maple_leaf"
                ]
            },
            {
                "unified": "1F342",
                "shortnames": [
                    "fallen_leaf"
                ]
            },
            {
                "unified": "1F343",
                "shortnames": [
                    "leaves"
                ]
            }
        ]
    },
    {
        "name": "Food & Drink",
        "emojis": [
            {
                "unified": "1F347",
                "shortnames": [
                    "grapes"
                ]
            },
            {
                "unified": "1F348",
                "shortnames": [
                    "melon"
                ]
            },
            {
                "unified": "1F349",
                "shortnames": [
                    "watermelon"
                ]
            },
            {
                "unified": "1F34A",
                "shortnames": [
                    "tangerine"
                ]
            },
            {
                "unified": "1F34B",
                "shortnames": [
                    "lemon"
                ]
            },
            {
                "unified": "1F34C",
                "shortnames": [
                    "banana"
                ]
            },
            {
                "unified": "1F34D",
                "shortnames": [
                    "pineapple"
                ]
            },
            {
                "unified": "1F34E",
                "shortnames": [
                    "apple"
                ]
            },
            {
                "unified": "1F34F",
                "shortnames": [
                    "green_apple"
                ]
            },
            {
                "unified": "1F350",
                "shortnames": [
                    "pear"
                ]
            },
            {
                "unified": "1F351",
                "shortnames": [
                    "peach"
                ]
            },
            {
                "unified": "1F352",
                "shortnames": [
                    "cherries"
                ]
            },
            {
                "unified": "1F353",
                "shortnames": [
                    "strawberry"
                ]
            },
            {
                "unified": "1F95D",
                "shortnames": [
                    "kiwifruit"
                ]
            },
            {
                "unified": "1F345",
                "shortnames": [
                    "tomato"
                ]
            },
            {
                "unified": "1F965",
                "shortnames": [
                    "coconut"
                ]
            },
            {
                "unified": "1F951",
                "shortnames": [
                    "avocado"
                ]
            },
            {
                "unified": "1F346",
                "shortnames": [
                    "eggplant"
                ]
            },
            {
                "unified": "1F954",
                "shortnames": [
                    "potato"
                ]
            },
            {
                "unified": "1F955",
                "shortnames": [
                    "carrot"
                ]
            },
            {
                "unified": "1F33D",
                "shortnames": [
                    "corn"
                ]
            },
            {
                "unified": "1F336-FE0F",
                "shortnames": [
                    "hot_pepper"
                ]
            },
            {
                "unified": "1F952",
                "shortnames": [
                    "cucumber"
                ]
            },
            {
                "unified": "1F966",
                "shortnames": [
                    "broccoli"
                ]
            },
            {
                "unified": "1F344",
                "shortnames": [
                    "mushroom"
                ]
            },
            {
                "unified": "1F95C",
                "shortnames": [
                    "peanuts"
                ]
            },
            {
                "unified": "1F330",
                "shortnames": [
                    "chestnut"
                ]
            },
            {
                "unified": "1F35E",
                "shortnames": [
                    "bread"
                ]
            },
            {
                "unified": "1F950",
                "shortnames": [
                    "croissant"
                ]
            },
            {
                "unified": "1F956",
                "shortnames": [
                    "baguette_bread"
                ]
            },
            {
                "unified": "1F968",
                "shortnames": [
                    "pretzel"
                ]
            },
            {
                "unified": "1F95E",
                "shortnames": [
                    "pancakes"
                ]
            },
            {
                "unified": "1F9C0",
                "shortnames": [
                    "cheese_wedge"
                ]
            },
            {
                "unified": "1F356",
                "shortnames": [
                    "meat_on_bone"
                ]
            },
            {
                "unified": "1F357",
                "shortnames": [
                    "poultry_leg"
                ]
            },
            {
                "unified": "1F969",
                "shortnames": [
                    "cut_of_meat"
                ]
            },
            {
                "unified": "1F953",
                "shortnames": [
                    "bacon"
                ]
            },
            {
                "unified": "1F354",
                "shortnames": [
                    "hamburger"
                ]
            },
            {
                "unified": "1F35F",
                "shortnames": [
                    "fries"
                ]
            },
            {
                "unified": "1F355",
                "shortnames": [
                    "pizza"
                ]
            },
            {
                "unified": "1F32D",
                "shortnames": [
                    "hotdog"
                ]
            },
            {
                "unified": "1F96A",
                "shortnames": [
                    "sandwich"
                ]
            },
            {
                "unified": "1F32E",
                "shortnames": [
                    "taco"
                ]
            },
            {
                "unified": "1F32F",
                "shortnames": [
                    "burrito"
                ]
            },
            {
                "unified": "1F959",
                "shortnames": [
                    "stuffed_flatbread"
                ]
            },
            {
                "unified": "1F95A",
                "shortnames": [
                    "egg"
                ]
            },
            {
                "unified": "1F373",
                "shortnames": [
                    "fried_egg"
                ]
            },
            {
                "unified": "1F958",
                "shortnames": [
                    "shallow_pan_of_food"
                ]
            },
            {
                "unified": "1F372",
                "shortnames": [
                    "stew"
                ]
            },
            {
                "unified": "1F963",
                "shortnames": [
                    "bowl_with_spoon"
                ]
            },
            {
                "unified": "1F957",
                "shortnames": [
                    "green_salad"
                ]
            },
            {
                "unified": "1F37F",
                "shortnames": [
                    "popcorn"
                ]
            },
            {
                "unified": "1F96B",
                "shortnames": [
                    "canned_food"
                ]
            },
            {
                "unified": "1F371",
                "shortnames": [
                    "bento"
                ]
            },
            {
                "unified": "1F358",
                "shortnames": [
                    "rice_cracker"
                ]
            },
            {
                "unified": "1F359",
                "shortnames": [
                    "rice_ball"
                ]
            },
            {
                "unified": "1F35A",
                "shortnames": [
                    "rice"
                ]
            },
            {
                "unified": "1F35B",
                "shortnames": [
                    "curry"
                ]
            },
            {
                "unified": "1F35C",
                "shortnames": [
                    "ramen"
                ]
            },
            {
                "unified": "1F35D",
                "shortnames": [
                    "spaghetti"
                ]
            },
            {
                "unified": "1F360",
                "shortnames": [
                    "sweet_potato"
                ]
            },
            {
                "unified": "1F362",
                "shortnames": [
                    "oden"
                ]
            },
            {
                "unified": "1F363",
                "shortnames": [
                    "sushi"
                ]
            },
            {
                "unified": "1F364",
                "shortnames": [
                    "fried_shrimp"
                ]
            },
            {
                "unified": "1F365",
                "shortnames": [
                    "fish_cake"
                ]
            },
            {
                "unified": "1F361",
                "shortnames": [
                    "dango"
                ]
            },
            {
                "unified": "1F95F",
                "shortnames": [
                    "dumpling"
                ]
            },
            {
                "unified": "1F960",
                "shortnames": [
                    "fortune_cookie"
                ]
            },
            {
                "unified": "1F961",
                "shortnames": [
                    "takeout_box"
                ]
            },
            {
                "unified": "1F366",
                "shortnames": [
                    "icecream"
                ]
            },
            {
                "unified": "1F367",
                "shortnames": [
                    "shaved_ice"
                ]
            },
            {
                "unified": "1F368",
                "shortnames": [
                    "ice_cream"
                ]
            },
            {
                "unified": "1F369",
                "shortnames": [
                    "doughnut"
                ]
            },
            {
                "unified": "1F36A",
                "shortnames": [
                    "cookie"
                ]
            },
            {
                "unified": "1F382",
                "shortnames": [
                    "birthday"
                ]
            },
            {
                "unified": "1F370",
                "shortnames": [
                    "cake"
                ]
            },
            {
                "unified": "1F967",
                "shortnames": [
                    "pie"
                ]
            },
            {
                "unified": "1F36B",
                "shortnames": [
                    "chocolate_bar"
                ]
            },
            {
                "unified": "1F36C",
                "shortnames": [
                    "candy"
                ]
            },
            {
                "unified": "1F36D",
                "shortnames": [
                    "lollipop"
                ]
            },
            {
                "unified": "1F36E",
                "shortnames": [
                    "custard"
                ]
            },
            {
                "unified": "1F36F",
                "shortnames": [
                    "honey_pot"
                ]
            },
            {
                "unified": "1F37C",
                "shortnames": [
                    "baby_bottle"
                ]
            },
            {
                "unified": "1F95B",
                "shortnames": [
                    "glass_of_milk"
                ]
            },
            {
                "unified": "2615",
                "shortnames": [
                    "coffee"
                ]
            },
            {
                "unified": "1F375",
                "shortnames": [
                    "tea"
                ]
            },
            {
                "unified": "1F376",
                "shortnames": [
                    "sake"
                ]
            },
            {
                "unified": "1F37E",
                "shortnames": [
                    "champagne"
                ]
            },
            {
                "unified": "1F377",
                "shortnames": [
                    "wine_glass"
                ]
            },
            {
                "unified": "1F378",
                "shortnames": [
                    "cocktail"
                ]
            },
            {
                "unified": "1F379",
                "shortnames": [
                    "tropical_drink"
                ]
            },
            {
                "unified": "1F37A",
                "shortnames": [
                    "beer"
                ]
            },
            {
                "unified": "1F37B",
                "shortnames": [
                    "beers"
                ]
            },
            {
                "unified": "1F942",
                "shortnames": [
                    "clinking_glasses"
                ]
            },
            {
                "unified": "1F943",
                "shortnames": [
                    "tumbler_glass"
                ]
            },
            {
                "unified": "1F964",
                "shortnames": [
                    "cup_with_straw"
                ]
            },
            {
                "unified": "1F962",
                "shortnames": [
                    "chopsticks"
                ]
            },
            {
                "unified": "1F37D-FE0F",
                "shortnames": [
                    "knife_fork_plate"
                ]
            },
            {
                "unified": "1F374",
                "shortnames": [
                    "fork_and_knife"
                ]
            },
            {
                "unified": "1F944",
                "shortnames": [
                    "spoon"
                ]
            },
            {
                "unified": "1F52A",
                "shortnames": [
                    "hocho"
                ]
            },
            {
                "unified": "1F3FA",
                "shortnames": [
                    "amphora"
                ]
            }
        ]
    },
    {
        "name": "Travel & Places",
        "emojis": [
            {
                "unified": "1F30D",
                "shortnames": [
                    "earth_africa"
                ]
            },
            {
                "unified": "1F30E",
                "shortnames": [
                    "earth_americas"
                ]
            },
            {
                "unified": "1F30F",
                "shortnames": [
                    "earth_asia"
                ]
            },
            {
                "unified": "1F310",
                "shortnames": [
                    "globe_with_meridians"
                ]
            },
            {
                "unified": "1F5FA-FE0F",
                "shortnames": [
                    "world_map"
                ]
            },
            {
                "unified": "1F5FE",
                "shortnames": [
                    "japan"
                ]
            },
            {
                "unified": "1F3D4-FE0F",
                "shortnames": [
                    "snow_capped_mountain"
                ]
            },
            {
                "unified": "26F0-FE0F",
                "shortnames": [
                    "mountain"
                ]
            },
            {
                "unified": "1F30B",
                "shortnames": [
                    "volcano"
                ]
            },
            {
                "unified": "1F5FB",
                "shortnames": [
                    "mount_fuji"
                ]
            },
            {
                "unified": "1F3D5-FE0F",
                "shortnames": [
                    "camping"
                ]
            },
            {
                "unified": "1F3D6-FE0F",
                "shortnames": [
                    "beach_with_umbrella"
                ]
            },
            {
                "unified": "1F3DC-FE0F",
                "shortnames": [
                    "desert"
                ]
            },
            {
                "unified": "1F3DD-FE0F",
                "shortnames": [
                    "desert_island"
                ]
            },
            {
                "unified": "1F3DE-FE0F",
                "shortnames": [
                    "national_park"
                ]
            },
            {
                "unified": "1F3DF-FE0F",
                "shortnames": [
                    "stadium"
                ]
            },
            {
                "unified": "1F3DB-FE0F",
                "shortnames": [
                    "classical_building"
                ]
            },
            {
                "unified": "1F3D7-FE0F",
                "shortnames": [
                    "building_construction"
                ]
            },
            {
                "unified": "1F3D8-FE0F",
                "shortnames": [
                    "house_buildings"
                ]
            },
            {
                "unified": "1F3D9-FE0F",
                "shortnames": [
                    "cityscape"
                ]
            },
            {
                "unified": "1F3DA-FE0F",
                "shortnames": [
                    "derelict_house_building"
                ]
            },
            {
                "unified": "1F3E0",
                "shortnames": [
                    "house"
                ]
            },
            {
                "unified": "1F3E1",
                "shortnames": [
                    "house_with_garden"
                ]
            },
            {
                "unified": "1F3E2",
                "shortnames": [
                    "office"
                ]
            },
            {
                "unified": "1F3E3",
                "shortnames": [
                    "post_office"
                ]
            },
            {
                "unified": "1F3E4",
                "shortnames": [
                    "european_post_office"
                ]
            },
            {
                "unified": "1F3E5",
                "shortnames": [
                    "hospital"
                ]
            },
            {
                "unified": "1F3E6",
                "shortnames": [
                    "bank"
                ]
            },
            {
                "unified": "1F3E8",
                "shortnames": [
                    "hotel"
                ]
            },
            {
                "unified": "1F3E9",
                "shortnames": [
                    "love_hotel"
                ]
            },
            {
                "unified": "1F3EA",
                "shortnames": [
                    "convenience_store"
                ]
            },
            {
                "unified": "1F3EB",
                "shortnames": [
                    "school"
                ]
            },
            {
                "unified": "1F3EC",
                "shortnames": [
                    "department_store"
                ]
            },
            {
                "unified": "1F3ED",
                "shortnames": [
                    "factory"
                ]
            },
            {
                "unified": "1F3EF",
                "shortnames": [
                    "japanese_castle"
                ]
            },
            {
                "unified": "1F3F0",
                "shortnames": [
                    "european_castle"
                ]
            },
            {
                "unified": "1F492",
                "shortnames": [
                    "wedding"
                ]
            },
            {
                "unified": "1F5FC",
                "shortnames": [
                    "tokyo_tower"
                ]
            },
            {
                "unified": "1F5FD",
                "shortnames": [
                    "statue_of_liberty"
                ]
            },
            {
                "unified": "26EA",
                "shortnames": [
                    "church"
                ]
            },
            {
                "unified": "1F54C",
                "shortnames": [
                    "mosque"
                ]
            },
            {
                "unified": "1F54D",
                "shortnames": [
                    "synagogue"
                ]
            },
            {
                "unified": "26E9-FE0F",
                "shortnames": [
                    "shinto_shrine"
                ]
            },
            {
                "unified": "1F54B",
                "shortnames": [
                    "kaaba"
                ]
            },
            {
                "unified": "26F2",
                "shortnames": [
                    "fountain"
                ]
            },
            {
                "unified": "26FA",
                "shortnames": [
                    "tent"
                ]
            },
            {
                "unified": "1F301",
                "shortnames": [
                    "foggy"
                ]
            },
            {
                "unified": "1F303",
                "shortnames": [
                    "night_with_stars"
                ]
            },
            {
                "unified": "1F304",
                "shortnames": [
                    "sunrise_over_mountains"
                ]
            },
            {
                "unified": "1F305",
                "shortnames": [
                    "sunrise"
                ]
            },
            {
                "unified": "1F306",
                "shortnames": [
                    "city_sunset"
                ]
            },
            {
                "unified": "1F307",
                "shortnames": [
                    "city_sunrise"
                ]
            },
            {
                "unified": "1F309",
                "shortnames": [
                    "bridge_at_night"
                ]
            },
            {
                "unified": "2668-FE0F",
                "shortnames": [
                    "hotsprings"
                ]
            },
            {
                "unified": "1F30C",
                "shortnames": [
                    "milky_way"
                ]
            },
            {
                "unified": "1F3A0",
                "shortnames": [
                    "carousel_horse"
                ]
            },
            {
                "unified": "1F3A1",
                "shortnames": [
                    "ferris_wheel"
                ]
            },
            {
                "unified": "1F3A2",
                "shortnames": [
                    "roller_coaster"
                ]
            },
            {
                "unified": "1F488",
                "shortnames": [
                    "barber"
                ]
            },
            {
                "unified": "1F3AA",
                "shortnames": [
                    "circus_tent"
                ]
            },
            {
                "unified": "1F3AD",
                "shortnames": [
                    "performing_arts"
                ]
            },
            {
                "unified": "1F5BC-FE0F",
                "shortnames": [
                    "frame_with_picture"
                ]
            },
            {
                "unified": "1F3A8",
                "shortnames": [
                    "art"
                ]
            },
            {
                "unified": "1F3B0",
                "shortnames": [
                    "slot_machine"
                ]
            },
            {
                "unified": "1F682",
                "shortnames": [
                    "steam_locomotive"
                ]
            },
            {
                "unified": "1F683",
                "shortnames": [
                    "railway_car"
                ]
            },
            {
                "unified": "1F684",
                "shortnames": [
                    "bullettrain_side"
                ]
            },
            {
                "unified": "1F685",
                "shortnames": [
                    "bullettrain_front"
                ]
            },
            {
                "unified": "1F686",
                "shortnames": [
                    "train2"
                ]
            },
            {
                "unified": "1F687",
                "shortnames": [
                    "metro"
                ]
            },
            {
                "unified": "1F688",
                "shortnames": [
                    "light_rail"
                ]
            },
            {
                "unified": "1F689",
                "shortnames": [
                    "station"
                ]
            },
            {
                "unified": "1F68A",
                "shortnames": [
                    "tram"
                ]
            },
            {
                "unified": "1F69D",
                "shortnames": [
                    "monorail"
                ]
            },
            {
                "unified": "1F69E",
                "shortnames": [
                    "mountain_railway"
                ]
            },
            {
                "unified": "1F68B",
                "shortnames": [
                    "train"
                ]
            },
            {
                "unified": "1F68C",
                "shortnames": [
                    "bus"
                ]
            },
            {
                "unified": "1F68D",
                "shortnames": [
                    "oncoming_bus"
                ]
            },
            {
                "unified": "1F68E",
                "shortnames": [
                    "trolleybus"
                ]
            },
            {
                "unified": "1F690",
                "shortnames": [
                    "minibus"
                ]
            },
            {
                "unified": "1F691",
                "shortnames": [
                    "ambulance"
                ]
            },
            {
                "unified": "1F692",
                "shortnames": [
                    "fire_engine"
                ]
            },
            {
                "unified": "1F693",
                "shortnames": [
                    "police_car"
                ]
            },
            {
                "unified": "1F694",
                "shortnames": [
                    "oncoming_police_car"
                ]
            },
            {
                "unified": "1F695",
                "shortnames": [
                    "taxi"
                ]
            },
            {
                "unified": "1F696",
                "shortnames": [
                    "oncoming_taxi"
                ]
            },
            {
                "unified": "1F697",
                "shortnames": [
                    "car"
                ]
            },
            {
                "unified": "1F698",
                "shortnames": [
                    "oncoming_automobile"
                ]
            },
            {
                "unified": "1F699",
                "shortnames": [
                    "blue_car"
                ]
            },
            {
                "unified": "1F69A",
                "shortnames": [
                    "truck"
                ]
            },
            {
                "unified": "1F69B",
                "shortnames": [
                    "articulated_lorry"
                ]
            },
            {
                "unified": "1F69C",
                "shortnames": [
                    "tractor"
                ]
            },
            {
                "unified": "1F6B2",
                "shortnames": [
                    "bike"
                ]
            },
            {
                "unified": "1F6F4",
                "shortnames": [
                    "scooter"
                ]
            },
            {
                "unified": "1F6F5",
                "shortnames": [
                    "motor_scooter"
                ]
            },
            {
                "unified": "1F68F",
                "shortnames": [
                    "busstop"
                ]
            },
            {
                "unified": "1F6E3-FE0F",
                "shortnames": [
                    "motorway"
                ]
            },
            {
                "unified": "1F6E4-FE0F",
                "shortnames": [
                    "railway_track"
                ]
            },
            {
                "unified": "26FD",
                "shortnames": [
                    "fuelpump"
                ]
            },
            {
                "unified": "1F6A8",
                "shortnames": [
                    "rotating_light"
                ]
            },
            {
                "unified": "1F6A5",
                "shortnames": [
                    "traffic_light"
                ]
            },
            {
                "unified": "1F6A6",
                "shortnames": [
                    "vertical_traffic_light"
                ]
            },
            {
                "unified": "1F6A7",
                "shortnames": [
                    "construction"
                ]
            },
            {
                "unified": "1F6D1",
                "shortnames": [
                    "octagonal_sign"
                ]
            },
            {
                "unified": "2693",
                "shortnames": [
                    "anchor"
                ]
            },
            {
                "unified": "26F5",
                "shortnames": [
                    "boat"
                ]
            },
            {
                "unified": "1F6F6",
                "shortnames": [
                    "canoe"
                ]
            },
            {
                "unified": "1F6A4",
                "shortnames": [
                    "speedboat"
                ]
            },
            {
                "unified": "1F6F3-FE0F",
                "shortnames": [
                    "passenger_ship"
                ]
            },
            {
                "unified": "26F4-FE0F",
                "shortnames": [
                    "ferry"
                ]
            },
            {
                "unified": "1F6E5-FE0F",
                "shortnames": [
                    "motor_boat"
                ]
            },
            {
                "unified": "1F6A2",
                "shortnames": [
                    "ship"
                ]
            },
            {
                "unified": "2708-FE0F",
                "shortnames": [
                    "airplane"
                ]
            },
            {
                "unified": "1F6E9-FE0F",
                "shortnames": [
                    "small_airplane"
                ]
            },
            {
                "unified": "1F6EB",
                "shortnames": [
                    "airplane_departure"
                ]
            },
            {
                "unified": "1F6EC",
                "shortnames": [
                    "airplane_arriving"
                ]
            },
            {
                "unified": "1F4BA",
                "shortnames": [
                    "seat"
                ]
            },
            {
                "unified": "1F681",
                "shortnames": [
                    "helicopter"
                ]
            },
            {
                "unified": "1F69F",
                "shortnames": [
                    "suspension_railway"
                ]
            },
            {
                "unified": "1F6A0",
                "shortnames": [
                    "mountain_cableway"
                ]
            },
            {
                "unified": "1F6A1",
                "shortnames": [
                    "aerial_tramway"
                ]
            },
            {
                "unified": "1F6F0-FE0F",
                "shortnames": [
                    "satellite"
                ]
            },
            {
                "unified": "1F680",
                "shortnames": [
                    "rocket"
                ]
            },
            {
                "unified": "1F6F8",
                "shortnames": [
                    "flying_saucer"
                ]
            },
            {
                "unified": "1F6CE-FE0F",
                "shortnames": [
                    "bellhop_bell"
                ]
            },
            {
                "unified": "1F6AA",
                "shortnames": [
                    "door"
                ]
            },
            {
                "unified": "1F6CF-FE0F",
                "shortnames": [
                    "bed"
                ]
            },
            {
                "unified": "1F6CB-FE0F",
                "shortnames": [
                    "couch_and_lamp"
                ]
            },
            {
                "unified": "1F6BD",
                "shortnames": [
                    "toilet"
                ]
            },
            {
                "unified": "1F6BF",
                "shortnames": [
                    "shower"
                ]
            },
            {
                "unified": "1F6C1",
                "shortnames": [
                    "bathtub"
                ]
            },
            {
                "unified": "231B",
                "shortnames": [
                    "hourglass"
                ]
            },
            {
                "unified": "23F3",
                "shortnames": [
                    "hourglass_flowing_sand"
                ]
            },
            {
                "unified": "231A",
                "shortnames": [
                    "watch"
                ]
            },
            {
                "unified": "23F0",
                "shortnames": [
                    "alarm_clock"
                ]
            },
            {
                "unified": "23F1-FE0F",
                "shortnames": [
                    "stopwatch"
                ]
            },
            {
                "unified": "23F2-FE0F",
                "shortnames": [
                    "timer_clock"
                ]
            },
            {
                "unified": "1F570-FE0F",
                "shortnames": [
                    "mantelpiece_clock"
                ]
            },
            {
                "unified": "1F55B",
                "shortnames": [
                    "clock12"
                ]
            },
            {
                "unified": "1F567",
                "shortnames": [
                    "clock1230"
                ]
            },
            {
                "unified": "1F550",
                "shortnames": [
                    "clock1"
                ]
            },
            {
                "unified": "1F55C",
                "shortnames": [
                    "clock130"
                ]
            },
            {
                "unified": "1F551",
                "shortnames": [
                    "clock2"
                ]
            },
            {
                "unified": "1F55D",
                "shortnames": [
                    "clock230"
                ]
            },
            {
                "unified": "1F552",
                "shortnames": [
                    "clock3"
                ]
            },
            {
                "unified": "1F55E",
                "shortnames": [
                    "clock330"
                ]
            },
            {
                "unified": "1F553",
                "shortnames": [
                    "clock4"
                ]
            },
            {
                "unified": "1F55F",
                "shortnames": [
                    "clock430"
                ]
            },
            {
                "unified": "1F554",
                "shortnames": [
                    "clock5"
                ]
            },
            {
                "unified": "1F560",
                "shortnames": [
                    "clock530"
                ]
            },
            {
                "unified": "1F555",
                "shortnames": [
                    "clock6"
                ]
            },
            {
                "unified": "1F561",
                "shortnames": [
                    "clock630"
                ]
            },
            {
                "unified": "1F556",
                "shortnames": [
                    "clock7"
                ]
            },
            {
                "unified": "1F562",
                "shortnames": [
                    "clock730"
                ]
            },
            {
                "unified": "1F557",
                "shortnames": [
                    "clock8"
                ]
            },
            {
                "unified": "1F563",
                "shortnames": [
                    "clock830"
                ]
            },
            {
                "unified": "1F558",
                "shortnames": [
                    "clock9"
                ]
            },
            {
                "unified": "1F564",
                "shortnames": [
                    "clock930"
                ]
            },
            {
                "unified": "1F559",
                "shortnames": [
                    "clock10"
                ]
            },
            {
                "unified": "1F565",
                "shortnames": [
                    "clock1030"
                ]
            },
            {
                "unified": "1F55A",
                "shortnames": [
                    "clock11"
                ]
            },
            {
                "unified": "1F566",
                "shortnames": [
                    "clock1130"
                ]
            },
            {
                "unified": "1F311",
                "shortnames": [
                    "new_moon"
                ]
            },
            {
                "unified": "1F312",
                "shortnames": [
                    "waxing_crescent_moon"
                ]
            },
            {
                "unified": "1F313",
                "shortnames": [
                    "first_quarter_moon"
                ]
            },
            {
                "unified": "1F314",
                "shortnames": [
                    "moon"
                ]
            },
            {
                "unified": "1F315",
                "shortnames": [
                    "full_moon"
                ]
            },
            {
                "unified": "1F316",
                "shortnames": [
                    "waning_gibbous_moon"
                ]
            },
            {
                "unified": "1F317",
                "shortnames": [
                    "last_quarter_moon"
                ]
            },
            {
                "unified": "1F318",
                "shortnames": [
                    "waning_crescent_moon"
                ]
            },
            {
                "unified": "1F319",
                "shortnames": [
                    "crescent_moon"
                ]
            },
            {
                "unified": "1F31A",
                "shortnames": [
                    "new_moon_with_face"
                ]
            },
            {
                "unified": "1F31B",
                "shortnames": [
                    "first_quarter_moon_with_face"
                ]
            },
            {
                "unified": "1F31C",
                "shortnames": [
                    "last_quarter_moon_with_face"
                ]
            },
            {
                "unified": "1F321-FE0F",
                "shortnames": [
                    "thermometer"
                ]
            },
            {
                "unified": "2600-FE0F",
                "shortnames": [
                    "sunny"
                ]
            },
            {
                "unified": "1F31D",
                "shortnames": [
                    "full_moon_with_face"
                ]
            },
            {
                "unified": "1F31E",
                "shortnames": [
                    "sun_with_face"
                ]
            },
            {
                "unified": "2B50",
                "shortnames": [
                    "star"
                ]
            },
            {
                "unified": "1F31F",
                "shortnames": [
                    "star2"
                ]
            },
            {
                "unified": "1F320",
                "shortnames": [
                    "stars"
                ]
            },
            {
                "unified": "2601-FE0F",
                "shortnames": [
                    "cloud"
                ]
            },
            {
                "unified": "26C5",
                "shortnames": [
                    "partly_sunny"
                ]
            },
            {
                "unified": "26C8-FE0F",
                "shortnames": [
                    "thunder_cloud_and_rain"
                ]
            },
            {
                "unified": "1F324-FE0F",
                "shortnames": [
                    "mostly_sunny"
                ]
            },
            {
                "unified": "1F325-FE0F",
                "shortnames": [
                    "barely_sunny"
                ]
            },
            {
                "unified": "1F326-FE0F",
                "shortnames": [
                    "partly_sunny_rain"
                ]
            },
            {
                "unified": "1F327-FE0F",
                "shortnames": [
                    "rain_cloud"
                ]
            },
            {
                "unified": "1F328-FE0F",
                "shortnames": [
                    "snow_cloud"
                ]
            },
            {
                "unified": "1F329-FE0F",
                "shortnames": [
                    "lightning"
                ]
            },
            {
                "unified": "1F32A-FE0F",
                "shortnames": [
                    "tornado"
                ]
            },
            {
                "unified": "1F32B-FE0F",
                "shortnames": [
                    "fog"
                ]
            },
            {
                "unified": "1F32C-FE0F",
                "shortnames": [
                    "wind_blowing_face"
                ]
            },
            {
                "unified": "1F300",
                "shortnames": [
                    "cyclone"
                ]
            },
            {
                "unified": "1F308",
                "shortnames": [
                    "rainbow"
                ]
            },
            {
                "unified": "1F302",
                "shortnames": [
                    "closed_umbrella"
                ]
            },
            {
                "unified": "2602-FE0F",
                "shortnames": [
                    "umbrella"
                ]
            },
            {
                "unified": "2614",
                "shortnames": [
                    "umbrella_with_rain_drops"
                ]
            },
            {
                "unified": "26F1-FE0F",
                "shortnames": [
                    "umbrella_on_ground"
                ]
            },
            {
                "unified": "26A1",
                "shortnames": [
                    "zap"
                ]
            },
            {
                "unified": "2744-FE0F",
                "shortnames": [
                    "snowflake"
                ]
            },
            {
                "unified": "2603-FE0F",
                "shortnames": [
                    "snowman"
                ]
            },
            {
                "unified": "26C4",
                "shortnames": [
                    "snowman_without_snow"
                ]
            },
            {
                "unified": "2604-FE0F",
                "shortnames": [
                    "comet"
                ]
            },
            {
                "unified": "1F525",
                "shortnames": [
                    "fire"
                ]
            },
            {
                "unified": "1F4A7",
                "shortnames": [
                    "droplet"
                ]
            },
            {
                "unified": "1F30A",
                "shortnames": [
                    "ocean"
                ]
            }
        ]
    },
    {
        "name": "Activities",
        "emojis": [
            {
                "unified": "1F383",
                "shortnames": [
                    "jack_o_lantern"
                ]
            },
            {
                "unified": "1F384",
                "shortnames": [
                    "christmas_tree"
                ]
            },
            {
                "unified": "1F386",
                "shortnames": [
                    "fireworks"
                ]
            },
            {
                "unified": "1F387",
                "shortnames": [
                    "sparkler"
                ]
            },
            {
                "unified": "2728",
                "shortnames": [
                    "sparkles"
                ]
            },
            {
                "unified": "1F388",
                "shortnames": [
                    "balloon"
                ]
            },
            {
                "unified": "1F389",
                "shortnames": [
                    "tada"
                ]
            },
            {
                "unified": "1F38A",
                "shortnames": [
                    "confetti_ball"
                ]
            },
            {
                "unified": "1F38B",
                "shortnames": [
                    "tanabata_tree"
                ]
            },
            {
                "unified": "1F38D",
                "shortnames": [
                    "bamboo"
                ]
            },
            {
                "unified": "1F38E",
                "shortnames": [
                    "dolls"
                ]
            },
            {
                "unified": "1F38F",
                "shortnames": [
                    "flags"
                ]
            },
            {
                "unified": "1F390",
                "shortnames": [
                    "wind_chime"
                ]
            },
            {
                "unified": "1F391",
                "shortnames": [
                    "rice_scene"
                ]
            },
            {
                "unified": "1F380",
                "shortnames": [
                    "ribbon"
                ]
            },
            {
                "unified": "1F381",
                "shortnames": [
                    "gift"
                ]
            },
            {
                "unified": "1F397-FE0F",
                "shortnames": [
                    "reminder_ribbon"
                ]
            },
            {
                "unified": "1F39F-FE0F",
                "shortnames": [
                    "admission_tickets"
                ]
            },
            {
                "unified": "1F3AB",
                "shortnames": [
                    "ticket"
                ]
            },
            {
                "unified": "1F396-FE0F",
                "shortnames": [
                    "medal"
                ]
            },
            {
                "unified": "1F3C6",
                "shortnames": [
                    "trophy"
                ]
            },
            {
                "unified": "1F3C5",
                "shortnames": [
                    "sports_medal"
                ]
            },
            {
                "unified": "1F947",
                "shortnames": [
                    "first_place_medal"
                ]
            },
            {
                "unified": "1F948",
                "shortnames": [
                    "second_place_medal"
                ]
            },
            {
                "unified": "1F949",
                "shortnames": [
                    "third_place_medal"
                ]
            },
            {
                "unified": "26BD",
                "shortnames": [
                    "soccer"
                ]
            },
            {
                "unified": "26BE",
                "shortnames": [
                    "baseball"
                ]
            },
            {
                "unified": "1F3C0",
                "shortnames": [
                    "basketball"
                ]
            },
            {
                "unified": "1F3D0",
                "shortnames": [
                    "volleyball"
                ]
            },
            {
                "unified": "1F3C8",
                "shortnames": [
                    "football"
                ]
            },
            {
                "unified": "1F3C9",
                "shortnames": [
                    "rugby_football"
                ]
            },
            {
                "unified": "1F3BE",
                "shortnames": [
                    "tennis"
                ]
            },
            {
                "unified": "1F3B1",
                "shortnames": [
                    "8ball"
                ]
            },
            {
                "unified": "1F3B3",
                "shortnames": [
                    "bowling"
                ]
            },
            {
                "unified": "1F3CF",
                "shortnames": [
                    "cricket_bat_and_ball"
                ]
            },
            {
                "unified": "1F3D1",
                "shortnames": [
                    "field_hockey_stick_and_ball"
                ]
            },
            {
                "unified": "1F3D2",
                "shortnames": [
                    "ice_hockey_stick_and_puck"
                ]
            },
            {
                "unified": "1F3D3",
                "shortnames": [
                    "table_tennis_paddle_and_ball"
                ]
            },
            {
                "unified": "1F3F8",
                "shortnames": [
                    "badminton_racquet_and_shuttlecock"
                ]
            },
            {
                "unified": "1F94A",
                "shortnames": [
                    "boxing_glove"
                ]
            },
            {
                "unified": "1F94B",
                "shortnames": [
                    "martial_arts_uniform"
                ]
            },
            {
                "unified": "1F945",
                "shortnames": [
                    "goal_net"
                ]
            },
            {
                "unified": "1F3AF",
                "shortnames": [
                    "dart"
                ]
            },
            {
                "unified": "26F3",
                "shortnames": [
                    "golf"
                ]
            },
            {
                "unified": "26F8-FE0F",
                "shortnames": [
                    "ice_skate"
                ]
            },
            {
                "unified": "1F3A3",
                "shortnames": [
                    "fishing_pole_and_fish"
                ]
            },
            {
                "unified": "1F3BD",
                "shortnames": [
                    "running_shirt_with_sash"
                ]
            },
            {
                "unified": "1F3BF",
                "shortnames": [
                    "ski"
                ]
            },
            {
                "unified": "1F6F7",
                "shortnames": [
                    "sled"
                ]
            },
            {
                "unified": "1F94C",
                "shortnames": [
                    "curling_stone"
                ]
            },
            {
                "unified": "1F3AE",
                "shortnames": [
                    "video_game"
                ]
            },
            {
                "unified": "1F579-FE0F",
                "shortnames": [
                    "joystick"
                ]
            },
            {
                "unified": "1F3B2",
                "shortnames": [
                    "game_die"
                ]
            },
            {
                "unified": "2660-FE0F",
                "shortnames": [
                    "spades"
                ]
            },
            {
                "unified": "2665-FE0F",
                "shortnames": [
                    "hearts"
                ]
            },
            {
                "unified": "2666-FE0F",
                "shortnames": [
                    "diamonds"
                ]
            },
            {
                "unified": "2663-FE0F",
                "shortnames": [
                    "clubs"
                ]
            },
            {
                "unified": "1F0CF",
                "shortnames": [
                    "black_joker"
                ]
            },
            {
                "unified": "1F004",
                "shortnames": [
                    "mahjong"
                ]
            },
            {
                "unified": "1F3B4",
                "shortnames": [
                    "flower_playing_cards"
                ]
            }
        ]
    },
    {
        "name": "Objects",
        "emojis": [
            {
                "unified": "1F507",
                "shortnames": [
                    "mute"
                ]
            },
            {
                "unified": "1F508",
                "shortnames": [
                    "speaker"
                ]
            },
            {
                "unified": "1F509",
                "shortnames": [
                    "sound"
                ]
            },
            {
                "unified": "1F50A",
                "shortnames": [
                    "loud_sound"
                ]
            },
            {
                "unified": "1F4E2",
                "shortnames": [
                    "loudspeaker"
                ]
            },
            {
                "unified": "1F4E3",
                "shortnames": [
                    "mega"
                ]
            },
            {
                "unified": "1F4EF",
                "shortnames": [
                    "postal_horn"
                ]
            },
            {
                "unified": "1F514",
                "shortnames": [
                    "bell"
                ]
            },
            {
                "unified": "1F515",
                "shortnames": [
                    "no_bell"
                ]
            },
            {
                "unified": "1F3BC",
                "shortnames": [
                    "musical_score"
                ]
            },
            {
                "unified": "1F3B5",
                "shortnames": [
                    "musical_note"
                ]
            },
            {
                "unified": "1F3B6",
                "shortnames": [
                    "notes"
                ]
            },
            {
                "unified": "1F399-FE0F",
                "shortnames": [
                    "studio_microphone"
                ]
            },
            {
                "unified": "1F39A-FE0F",
                "shortnames": [
                    "level_slider"
                ]
            },
            {
                "unified": "1F39B-FE0F",
                "shortnames": [
                    "control_knobs"
                ]
            },
            {
                "unified": "1F3A4",
                "shortnames": [
                    "microphone"
                ]
            },
            {
                "unified": "1F3A7",
                "shortnames": [
                    "headphones"
                ]
            },
            {
                "unified": "1F4FB",
                "shortnames": [
                    "radio"
                ]
            },
            {
                "unified": "1F3B7",
                "shortnames": [
                    "saxophone"
                ]
            },
            {
                "unified": "1F3B8",
                "shortnames": [
                    "guitar"
                ]
            },
            {
                "unified": "1F3B9",
                "shortnames": [
                    "musical_keyboard"
                ]
            },
            {
                "unified": "1F3BA",
                "shortnames": [
                    "trumpet"
                ]
            },
            {
                "unified": "1F3BB",
                "shortnames": [
                    "violin"
                ]
            },
            {
                "unified": "1F941",
                "shortnames": [
                    "drum_with_drumsticks"
                ]
            },
            {
                "unified": "1F4F1",
                "shortnames": [
                    "iphone"
                ]
            },
            {
                "unified": "1F4F2",
                "shortnames": [
                    "calling"
                ]
            },
            {
                "unified": "260E-FE0F",
                "shortnames": [
                    "phone"
                ]
            },
            {
                "unified": "1F4DE",
                "shortnames": [
                    "telephone_receiver"
                ]
            },
            {
                "unified": "1F4DF",
                "shortnames": [
                    "pager"
                ]
            },
            {
                "unified": "1F4E0",
                "shortnames": [
                    "fax"
                ]
            },
            {
                "unified": "1F50B",
                "shortnames": [
                    "battery"
                ]
            },
            {
                "unified": "1F50C",
                "shortnames": [
                    "electric_plug"
                ]
            },
            {
                "unified": "1F4BB",
                "shortnames": [
                    "computer"
                ]
            },
            {
                "unified": "1F5A5-FE0F",
                "shortnames": [
                    "desktop_computer"
                ]
            },
            {
                "unified": "1F5A8-FE0F",
                "shortnames": [
                    "printer"
                ]
            },
            {
                "unified": "2328-FE0F",
                "shortnames": [
                    "keyboard"
                ]
            },
            {
                "unified": "1F5B1-FE0F",
                "shortnames": [
                    "three_button_mouse"
                ]
            },
            {
                "unified": "1F5B2-FE0F",
                "shortnames": [
                    "trackball"
                ]
            },
            {
                "unified": "1F4BD",
                "shortnames": [
                    "minidisc"
                ]
            },
            {
                "unified": "1F4BE",
                "shortnames": [
                    "floppy_disk"
                ]
            },
            {
                "unified": "1F4BF",
                "shortnames": [
                    "cd"
                ]
            },
            {
                "unified": "1F4C0",
                "shortnames": [
                    "dvd"
                ]
            },
            {
                "unified": "1F3A5",
                "shortnames": [
                    "movie_camera"
                ]
            },
            {
                "unified": "1F39E-FE0F",
                "shortnames": [
                    "film_frames"
                ]
            },
            {
                "unified": "1F4FD-FE0F",
                "shortnames": [
                    "film_projector"
                ]
            },
            {
                "unified": "1F3AC",
                "shortnames": [
                    "clapper"
                ]
            },
            {
                "unified": "1F4FA",
                "shortnames": [
                    "tv"
                ]
            },
            {
                "unified": "1F4F7",
                "shortnames": [
                    "camera"
                ]
            },
            {
                "unified": "1F4F8",
                "shortnames": [
                    "camera_with_flash"
                ]
            },
            {
                "unified": "1F4F9",
                "shortnames": [
                    "video_camera"
                ]
            },
            {
                "unified": "1F4FC",
                "shortnames": [
                    "vhs"
                ]
            },
            {
                "unified": "1F50D",
                "shortnames": [
                    "mag"
                ]
            },
            {
                "unified": "1F50E",
                "shortnames": [
                    "mag_right"
                ]
            },
            {
                "unified": "1F52C",
                "shortnames": [
                    "microscope"
                ]
            },
            {
                "unified": "1F52D",
                "shortnames": [
                    "telescope"
                ]
            },
            {
                "unified": "1F4E1",
                "shortnames": [
                    "satellite_antenna"
                ]
            },
            {
                "unified": "1F56F-FE0F",
                "shortnames": [
                    "candle"
                ]
            },
            {
                "unified": "1F4A1",
                "shortnames": [
                    "bulb"
                ]
            },
            {
                "unified": "1F526",
                "shortnames": [
                    "flashlight"
                ]
            },
            {
                "unified": "1F3EE",
                "shortnames": [
                    "izakaya_lantern"
                ]
            },
            {
                "unified": "1F4D4",
                "shortnames": [
                    "notebook_with_decorative_cover"
                ]
            },
            {
                "unified": "1F4D5",
                "shortnames": [
                    "closed_book"
                ]
            },
            {
                "unified": "1F4D6",
                "shortnames": [
                    "book"
                ]
            },
            {
                "unified": "1F4D7",
                "shortnames": [
                    "green_book"
                ]
            },
            {
                "unified": "1F4D8",
                "shortnames": [
                    "blue_book"
                ]
            },
            {
                "unified": "1F4D9",
                "shortnames": [
                    "orange_book"
                ]
            },
            {
                "unified": "1F4DA",
                "shortnames": [
                    "books"
                ]
            },
            {
                "unified": "1F4D3",
                "shortnames": [
                    "notebook"
                ]
            },
            {
                "unified": "1F4D2",
                "shortnames": [
                    "ledger"
                ]
            },
            {
                "unified": "1F4C3",
                "shortnames": [
                    "page_with_curl"
                ]
            },
            {
                "unified": "1F4DC",
                "shortnames": [
                    "scroll"
                ]
            },
            {
                "unified": "1F4C4",
                "shortnames": [
                    "page_facing_up"
                ]
            },
            {
                "unified": "1F4F0",
                "shortnames": [
                    "newspaper"
                ]
            },
            {
                "unified": "1F5DE-FE0F",
                "shortnames": [
                    "rolled_up_newspaper"
                ]
            },
            {
                "unified": "1F4D1",
                "shortnames": [
                    "bookmark_tabs"
                ]
            },
            {
                "unified": "1F516",
                "shortnames": [
                    "bookmark"
                ]
            },
            {
                "unified": "1F3F7-FE0F",
                "shortnames": [
                    "label"
                ]
            },
            {
                "unified": "1F4B0",
                "shortnames": [
                    "moneybag"
                ]
            },
            {
                "unified": "1F4B4",
                "shortnames": [
                    "yen"
                ]
            },
            {
                "unified": "1F4B5",
                "shortnames": [
                    "dollar"
                ]
            },
            {
                "unified": "1F4B6",
                "shortnames": [
                    "euro"
                ]
            },
            {
                "unified": "1F4B7",
                "shortnames": [
                    "pound"
                ]
            },
            {
                "unified": "1F4B8",
                "shortnames": [
                    "money_with_wings"
                ]
            },
            {
                "unified": "1F4B3",
                "shortnames": [
                    "credit_card"
                ]
            },
            {
                "unified": "1F4B9",
                "shortnames": [
                    "chart"
                ]
            },
            {
                "unified": "1F4B1",
                "shortnames": [
                    "currency_exchange"
                ]
            },
            {
                "unified": "1F4B2",
                "shortnames": [
                    "heavy_dollar_sign"
                ]
            },
            {
                "unified": "2709-FE0F",
                "shortnames": [
                    "email"
                ]
            },
            {
                "unified": "1F4E7",
                "shortnames": [
                    "e-mail"
                ]
            },
            {
                "unified": "1F4E8",
                "shortnames": [
                    "incoming_envelope"
                ]
            },
            {
                "unified": "1F4E9",
                "shortnames": [
                    "envelope_with_arrow"
                ]
            },
            {
                "unified": "1F4E4",
                "shortnames": [
                    "outbox_tray"
                ]
            },
            {
                "unified": "1F4E5",
                "shortnames": [
                    "inbox_tray"
                ]
            },
            {
                "unified": "1F4E6",
                "shortnames": [
                    "package"
                ]
            },
            {
                "unified": "1F4EB",
                "shortnames": [
                    "mailbox"
                ]
            },
            {
                "unified": "1F4EA",
                "shortnames": [
                    "mailbox_closed"
                ]
            },
            {
                "unified": "1F4EC",
                "shortnames": [
                    "mailbox_with_mail"
                ]
            },
            {
                "unified": "1F4ED",
                "shortnames": [
                    "mailbox_with_no_mail"
                ]
            },
            {
                "unified": "1F4EE",
                "shortnames": [
                    "postbox"
                ]
            },
            {
                "unified": "1F5F3-FE0F",
                "shortnames": [
                    "ballot_box_with_ballot"
                ]
            },
            {
                "unified": "270F-FE0F",
                "shortnames": [
                    "pencil2"
                ]
            },
            {
                "unified": "2712-FE0F",
                "shortnames": [
                    "black_nib"
                ]
            },
            {
                "unified": "1F58B-FE0F",
                "shortnames": [
                    "lower_left_fountain_pen"
                ]
            },
            {
                "unified": "1F58A-FE0F",
                "shortnames": [
                    "lower_left_ballpoint_pen"
                ]
            },
            {
                "unified": "1F58C-FE0F",
                "shortnames": [
                    "lower_left_paintbrush"
                ]
            },
            {
                "unified": "1F58D-FE0F",
                "shortnames": [
                    "lower_left_crayon"
                ]
            },
            {
                "unified": "1F4DD",
                "shortnames": [
                    "memo"
                ]
            },
            {
                "unified": "1F4BC",
                "shortnames": [
                    "briefcase"
                ]
            },
            {
                "unified": "1F4C1",
                "shortnames": [
                    "file_folder"
                ]
            },
            {
                "unified": "1F4C2",
                "shortnames": [
                    "open_file_folder"
                ]
            },
            {
                "unified": "1F5C2-FE0F",
                "shortnames": [
                    "card_index_dividers"
                ]
            },
            {
                "unified": "1F4C5",
                "shortnames": [
                    "date"
                ]
            },
            {
                "unified": "1F4C6",
                "shortnames": [
                    "calendar"
                ]
            },
            {
                "unified": "1F5D2-FE0F",
                "shortnames": [
                    "spiral_note_pad"
                ]
            },
            {
                "unified": "1F5D3-FE0F",
                "shortnames": [
                    "spiral_calendar_pad"
                ]
            },
            {
                "unified": "1F4C7",
                "shortnames": [
                    "card_index"
                ]
            },
            {
                "unified": "1F4C8",
                "shortnames": [
                    "chart_with_upwards_trend"
                ]
            },
            {
                "unified": "1F4C9",
                "shortnames": [
                    "chart_with_downwards_trend"
                ]
            },
            {
                "unified": "1F4CA",
                "shortnames": [
                    "bar_chart"
                ]
            },
            {
                "unified": "1F4CB",
                "shortnames": [
                    "clipboard"
                ]
            },
            {
                "unified": "1F4CC",
                "shortnames": [
                    "pushpin"
                ]
            },
            {
                "unified": "1F4CD",
                "shortnames": [
                    "round_pushpin"
                ]
            },
            {
                "unified": "1F4CE",
                "shortnames": [
                    "paperclip"
                ]
            },
            {
                "unified": "1F587-FE0F",
                "shortnames": [
                    "linked_paperclips"
                ]
            },
            {
                "unified": "1F4CF",
                "shortnames": [
                    "straight_ruler"
                ]
            },
            {
                "unified": "1F4D0",
                "shortnames": [
                    "triangular_ruler"
                ]
            },
            {
                "unified": "2702-FE0F",
                "shortnames": [
                    "scissors"
                ]
            },
            {
                "unified": "1F5C3-FE0F",
                "shortnames": [
                    "card_file_box"
                ]
            },
            {
                "unified": "1F5C4-FE0F",
                "shortnames": [
                    "file_cabinet"
                ]
            },
            {
                "unified": "1F5D1-FE0F",
                "shortnames": [
                    "wastebasket"
                ]
            },
            {
                "unified": "1F512",
                "shortnames": [
                    "lock"
                ]
            },
            {
                "unified": "1F513",
                "shortnames": [
                    "unlock"
                ]
            },
            {
                "unified": "1F50F",
                "shortnames": [
                    "lock_with_ink_pen"
                ]
            },
            {
                "unified": "1F510",
                "shortnames": [
                    "closed_lock_with_key"
                ]
            },
            {
                "unified": "1F511",
                "shortnames": [
                    "key"
                ]
            },
            {
                "unified": "1F5DD-FE0F",
                "shortnames": [
                    "old_key"
                ]
            },
            {
                "unified": "1F528",
                "shortnames": [
                    "hammer"
                ]
            },
            {
                "unified": "26CF-FE0F",
                "shortnames": [
                    "pick"
                ]
            },
            {
                "unified": "2692-FE0F",
                "shortnames": [
                    "hammer_and_pick"
                ]
            },
            {
                "unified": "1F6E0-FE0F",
                "shortnames": [
                    "hammer_and_wrench"
                ]
            },
            {
                "unified": "1F5E1-FE0F",
                "shortnames": [
                    "dagger_knife"
                ]
            },
            {
                "unified": "2694-FE0F",
                "shortnames": [
                    "crossed_swords"
                ]
            },
            {
                "unified": "1F52B",
                "shortnames": [
                    "gun"
                ]
            },
            {
                "unified": "1F3F9",
                "shortnames": [
                    "bow_and_arrow"
                ]
            },
            {
                "unified": "1F6E1-FE0F",
                "shortnames": [
                    "shield"
                ]
            },
            {
                "unified": "1F527",
                "shortnames": [
                    "wrench"
                ]
            },
            {
                "unified": "1F529",
                "shortnames": [
                    "nut_and_bolt"
                ]
            },
            {
                "unified": "2699-FE0F",
                "shortnames": [
                    "gear"
                ]
            },
            {
                "unified": "1F5DC-FE0F",
                "shortnames": [
                    "compression"
                ]
            },
            {
                "unified": "2697-FE0F",
                "shortnames": [
                    "alembic"
                ]
            },
            {
                "unified": "2696-FE0F",
                "shortnames": [
                    "scales"
                ]
            },
            {
                "unified": "1F517",
                "shortnames": [
                    "link"
                ]
            },
            {
                "unified": "26D3-FE0F",
                "shortnames": [
                    "chains"
                ]
            },
            {
                "unified": "1F489",
                "shortnames": [
                    "syringe"
                ]
            },
            {
                "unified": "1F48A",
                "shortnames": [
                    "pill"
                ]
            },
            {
                "unified": "1F6AC",
                "shortnames": [
                    "smoking"
                ]
            },
            {
                "unified": "26B0-FE0F",
                "shortnames": [
                    "coffin"
                ]
            },
            {
                "unified": "26B1-FE0F",
                "shortnames": [
                    "funeral_urn"
                ]
            },
            {
                "unified": "1F5FF",
                "shortnames": [
                    "moyai"
                ]
            },
            {
                "unified": "1F6E2-FE0F",
                "shortnames": [
                    "oil_drum"
                ]
            },
            {
                "unified": "1F52E",
                "shortnames": [
                    "crystal_ball"
                ]
            },
            {
                "unified": "1F6D2",
                "shortnames": [
                    "shopping_trolley"
                ]
            }
        ]
    },
    {
        "name": "Symbols",
        "emojis": [
            {
                "unified": "1F3E7",
                "shortnames": [
                    "atm"
                ]
            },
            {
                "unified": "1F6AE",
                "shortnames": [
                    "put_litter_in_its_place"
                ]
            },
            {
                "unified": "1F6B0",
                "shortnames": [
                    "potable_water"
                ]
            },
            {
                "unified": "267F",
                "shortnames": [
                    "wheelchair"
                ]
            },
            {
                "unified": "1F6B9",
                "shortnames": [
                    "mens"
                ]
            },
            {
                "unified": "1F6BA",
                "shortnames": [
                    "womens"
                ]
            },
            {
                "unified": "1F6BB",
                "shortnames": [
                    "restroom"
                ]
            },
            {
                "unified": "1F6BC",
                "shortnames": [
                    "baby_symbol"
                ]
            },
            {
                "unified": "1F6BE",
                "shortnames": [
                    "wc"
                ]
            },
            {
                "unified": "1F6C2",
                "shortnames": [
                    "passport_control"
                ]
            },
            {
                "unified": "1F6C3",
                "shortnames": [
                    "customs"
                ]
            },
            {
                "unified": "1F6C4",
                "shortnames": [
                    "baggage_claim"
                ]
            },
            {
                "unified": "1F6C5",
                "shortnames": [
                    "left_luggage"
                ]
            },
            {
                "unified": "26A0-FE0F",
                "shortnames": [
                    "warning"
                ]
            },
            {
                "unified": "1F6B8",
                "shortnames": [
                    "children_crossing"
                ]
            },
            {
                "unified": "26D4",
                "shortnames": [
                    "no_entry"
                ]
            },
            {
                "unified": "1F6AB",
                "shortnames": [
                    "no_entry_sign"
                ]
            },
            {
                "unified": "1F6B3",
                "shortnames": [
                    "no_bicycles"
                ]
            },
            {
                "unified": "1F6AD",
                "shortnames": [
                    "no_smoking"
                ]
            },
            {
                "unified": "1F6AF",
                "shortnames": [
                    "do_not_litter"
                ]
            },
            {
                "unified": "1F6B1",
                "shortnames": [
                    "non-potable_water"
                ]
            },
            {
                "unified": "1F6B7",
                "shortnames": [
                    "no_pedestrians"
                ]
            },
            {
                "unified": "1F4F5",
                "shortnames": [
                    "no_mobile_phones"
                ]
            },
            {
                "unified": "1F51E",
                "shortnames": [
                    "underage"
                ]
            },
            {
                "unified": "2622-FE0F",
                "shortnames": [
                    "radioactive_sign"
                ]
            },
            {
                "unified": "2623-FE0F",
                "shortnames": [
                    "biohazard_sign"
                ]
            },
            {
                "unified": "2B06-FE0F",
                "shortnames": [
                    "arrow_up"
                ]
            },
            {
                "unified": "2197-FE0F",
                "shortnames": [
                    "arrow_upper_right"
                ]
            },
            {
                "unified": "27A1-FE0F",
                "shortnames": [
                    "arrow_right"
                ]
            },
            {
                "unified": "2198-FE0F",
                "shortnames": [
                    "arrow_lower_right"
                ]
            },
            {
                "unified": "2B07-FE0F",
                "shortnames": [
                    "arrow_down"
                ]
            },
            {
                "unified": "2199-FE0F",
                "shortnames": [
                    "arrow_lower_left"
                ]
            },
            {
                "unified": "2B05-FE0F",
                "shortnames": [
                    "arrow_left"
                ]
            },
            {
                "unified": "2196-FE0F",
                "shortnames": [
                    "arrow_upper_left"
                ]
            },
            {
                "unified": "2195-FE0F",
                "shortnames": [
                    "arrow_up_down"
                ]
            },
            {
                "unified": "2194-FE0F",
                "shortnames": [
                    "left_right_arrow"
                ]
            },
            {
                "unified": "21A9-FE0F",
                "shortnames": [
                    "leftwards_arrow_with_hook"
                ]
            },
            {
                "unified": "21AA-FE0F",
                "shortnames": [
                    "arrow_right_hook"
                ]
            },
            {
                "unified": "2934-FE0F",
                "shortnames": [
                    "arrow_heading_up"
                ]
            },
            {
                "unified": "2935-FE0F",
                "shortnames": [
                    "arrow_heading_down"
                ]
            },
            {
                "unified": "1F503",
                "shortnames": [
                    "arrows_clockwise"
                ]
            },
            {
                "unified": "1F504",
                "shortnames": [
                    "arrows_counterclockwise"
                ]
            },
            {
                "unified": "1F519",
                "shortnames": [
                    "back"
                ]
            },
            {
                "unified": "1F51A",
                "shortnames": [
                    "end"
                ]
            },
            {
                "unified": "1F51B",
                "shortnames": [
                    "on"
                ]
            },
            {
                "unified": "1F51C",
                "shortnames": [
                    "soon"
                ]
            },
            {
                "unified": "1F51D",
                "shortnames": [
                    "top"
                ]
            },
            {
                "unified": "1F6D0",
                "shortnames": [
                    "place_of_worship"
                ]
            },
            {
                "unified": "269B-FE0F",
                "shortnames": [
                    "atom_symbol"
                ]
            },
            {
                "unified": "1F549-FE0F",
                "shortnames": [
                    "om_symbol"
                ]
            },
            {
                "unified": "2721-FE0F",
                "shortnames": [
                    "star_of_david"
                ]
            },
            {
                "unified": "2638-FE0F",
                "shortnames": [
                    "wheel_of_dharma"
                ]
            },
            {
                "unified": "262F-FE0F",
                "shortnames": [
                    "yin_yang"
                ]
            },
            {
                "unified": "271D-FE0F",
                "shortnames": [
                    "latin_cross"
                ]
            },
            {
                "unified": "2626-FE0F",
                "shortnames": [
                    "orthodox_cross"
                ]
            },
            {
                "unified": "262A-FE0F",
                "shortnames": [
                    "star_and_crescent"
                ]
            },
            {
                "unified": "262E-FE0F",
                "shortnames": [
                    "peace_symbol"
                ]
            },
            {
                "unified": "1F54E",
                "shortnames": [
                    "menorah_with_nine_branches"
                ]
            },
            {
                "unified": "1F52F",
                "shortnames": [
                    "six_pointed_star"
                ]
            },
            {
                "unified": "2648",
                "shortnames": [
                    "aries"
                ]
            },
            {
                "unified": "2649",
                "shortnames": [
                    "taurus"
                ]
            },
            {
                "unified": "264A",
                "shortnames": [
                    "gemini"
                ]
            },
            {
                "unified": "264B",
                "shortnames": [
                    "cancer"
                ]
            },
            {
                "unified": "264C",
                "shortnames": [
                    "leo"
                ]
            },
            {
                "unified": "264D",
                "shortnames": [
                    "virgo"
                ]
            },
            {
                "unified": "264E",
                "shortnames": [
                    "libra"
                ]
            },
            {
                "unified": "264F",
                "shortnames": [
                    "scorpius"
                ]
            },
            {
                "unified": "2650",
                "shortnames": [
                    "sagittarius"
                ]
            },
            {
                "unified": "2651",
                "shortnames": [
                    "capricorn"
                ]
            },
            {
                "unified": "2652",
                "shortnames": [
                    "aquarius"
                ]
            },
            {
                "unified": "2653",
                "shortnames": [
                    "pisces"
                ]
            },
            {
                "unified": "26CE",
                "shortnames": [
                    "ophiuchus"
                ]
            },
            {
                "unified": "1F500",
                "shortnames": [
                    "twisted_rightwards_arrows"
                ]
            },
            {
                "unified": "1F501",
                "shortnames": [
                    "repeat"
                ]
            },
            {
                "unified": "1F502",
                "shortnames": [
                    "repeat_one"
                ]
            },
            {
                "unified": "25B6-FE0F",
                "shortnames": [
                    "arrow_forward"
                ]
            },
            {
                "unified": "23E9",
                "shortnames": [
                    "fast_forward"
                ]
            },
            {
                "unified": "23ED-FE0F",
                "shortnames": [
                    "black_right_pointing_double_triangle_with_vertical_bar"
                ]
            },
            {
                "unified": "23EF-FE0F",
                "shortnames": [
                    "black_right_pointing_triangle_with_double_vertical_bar"
                ]
            },
            {
                "unified": "25C0-FE0F",
                "shortnames": [
                    "arrow_backward"
                ]
            },
            {
                "unified": "23EA",
                "shortnames": [
                    "rewind"
                ]
            },
            {
                "unified": "23EE-FE0F",
                "shortnames": [
                    "black_left_pointing_double_triangle_with_vertical_bar"
                ]
            },
            {
                "unified": "1F53C",
                "shortnames": [
                    "arrow_up_small"
                ]
            },
            {
                "unified": "23EB",
                "shortnames": [
                    "arrow_double_up"
                ]
            },
            {
                "unified": "1F53D",
                "shortnames": [
                    "arrow_down_small"
                ]
            },
            {
                "unified": "23EC",
                "shortnames": [
                    "arrow_double_down"
                ]
            },
            {
                "unified": "23F8-FE0F",
                "shortnames": [
                    "double_vertical_bar"
                ]
            },
            {
                "unified": "23F9-FE0F",
                "shortnames": [
                    "black_square_for_stop"
                ]
            },
            {
                "unified": "23FA-FE0F",
                "shortnames": [
                    "black_circle_for_record"
                ]
            },
            {
                "unified": "23CF-FE0F",
                "shortnames": [
                    "eject"
                ]
            },
            {
                "unified": "1F3A6",
                "shortnames": [
                    "cinema"
                ]
            },
            {
                "unified": "1F505",
                "shortnames": [
                    "low_brightness"
                ]
            },
            {
                "unified": "1F506",
                "shortnames": [
                    "high_brightness"
                ]
            },
            {
                "unified": "1F4F6",
                "shortnames": [
                    "signal_strength"
                ]
            },
            {
                "unified": "1F4F3",
                "shortnames": [
                    "vibration_mode"
                ]
            },
            {
                "unified": "1F4F4",
                "shortnames": [
                    "mobile_phone_off"
                ]
            },
            {
                "unified": "2640-FE0F",
                "shortnames": [
                    "female_sign"
                ]
            },
            {
                "unified": "2642-FE0F",
                "shortnames": [
                    "male_sign"
                ]
            },
            {
                "unified": "2695-FE0F",
                "shortnames": [
                    "medical_symbol"
                ]
            },
            {
                "unified": "267B-FE0F",
                "shortnames": [
                    "recycle"
                ]
            },
            {
                "unified": "269C-FE0F",
                "shortnames": [
                    "fleur_de_lis"
                ]
            },
            {
                "unified": "1F531",
                "shortnames": [
                    "trident"
                ]
            },
            {
                "unified": "1F4DB",
                "shortnames": [
                    "name_badge"
                ]
            },
            {
                "unified": "1F530",
                "shortnames": [
                    "beginner"
                ]
            },
            {
                "unified": "2B55",
                "shortnames": [
                    "o"
                ]
            },
            {
                "unified": "2705",
                "shortnames": [
                    "white_check_mark"
                ]
            },
            {
                "unified": "2611-FE0F",
                "shortnames": [
                    "ballot_box_with_check"
                ]
            },
            {
                "unified": "2714-FE0F",
                "shortnames": [
                    "heavy_check_mark"
                ]
            },
            {
                "unified": "2716-FE0F",
                "shortnames": [
                    "heavy_multiplication_x"
                ]
            },
            {
                "unified": "274C",
                "shortnames": [
                    "x"
                ]
            },
            {
                "unified": "274E",
                "shortnames": [
                    "negative_squared_cross_mark"
                ]
            },
            {
                "unified": "2795",
                "shortnames": [
                    "heavy_plus_sign"
                ]
            },
            {
                "unified": "2796",
                "shortnames": [
                    "heavy_minus_sign"
                ]
            },
            {
                "unified": "2797",
                "shortnames": [
                    "heavy_division_sign"
                ]
            },
            {
                "unified": "27B0",
                "shortnames": [
                    "curly_loop"
                ]
            },
            {
                "unified": "27BF",
                "shortnames": [
                    "loop"
                ]
            },
            {
                "unified": "303D-FE0F",
                "shortnames": [
                    "part_alternation_mark"
                ]
            },
            {
                "unified": "2733-FE0F",
                "shortnames": [
                    "eight_spoked_asterisk"
                ]
            },
            {
                "unified": "2734-FE0F",
                "shortnames": [
                    "eight_pointed_black_star"
                ]
            },
            {
                "unified": "2747-FE0F",
                "shortnames": [
                    "sparkle"
                ]
            },
            {
                "unified": "203C-FE0F",
                "shortnames": [
                    "bangbang"
                ]
            },
            {
                "unified": "2049-FE0F",
                "shortnames": [
                    "interrobang"
                ]
            },
            {
                "unified": "2753",
                "shortnames": [
                    "question"
                ]
            },
            {
                "unified": "2754",
                "shortnames": [
                    "grey_question"
                ]
            },
            {
                "unified": "2755",
                "shortnames": [
                    "grey_exclamation"
                ]
            },
            {
                "unified": "2757",
                "shortnames": [
                    "exclamation"
                ]
            },
            {
                "unified": "3030-FE0F",
                "shortnames": [
                    "wavy_dash"
                ]
            },
            {
                "unified": "00A9-FE0F",
                "shortnames": [
                    "copyright"
                ]
            },
            {
                "unified": "00AE-FE0F",
                "shortnames": [
                    "registered"
                ]
            },
            {
                "unified": "2122-FE0F",
                "shortnames": [
                    "tm"
                ]
            },
            {
                "unified": "0023-FE0F-20E3",
                "shortnames": [
                    "hash"
                ]
            },
            {
                "unified": "002A-FE0F-20E3",
                "shortnames": [
                    "keycap_star"
                ]
            },
            {
                "unified": "0030-FE0F-20E3",
                "shortnames": [
                    "zero"
                ]
            },
            {
                "unified": "0031-FE0F-20E3",
                "shortnames": [
                    "one"
                ]
            },
            {
                "unified": "0032-FE0F-20E3",
                "shortnames": [
                    "two"
                ]
            },
            {
                "unified": "0033-FE0F-20E3",
                "shortnames": [
                    "three"
                ]
            },
            {
                "unified": "0034-FE0F-20E3",
                "shortnames": [
                    "four"
                ]
            },
            {
                "unified": "0035-FE0F-20E3",
                "shortnames": [
                    "five"
                ]
            },
            {
                "unified": "0036-FE0F-20E3",
                "shortnames": [
                    "six"
                ]
            },
            {
                "unified": "0037-FE0F-20E3",
                "shortnames": [
                    "seven"
                ]
            },
            {
                "unified": "0038-FE0F-20E3",
                "shortnames": [
                    "eight"
                ]
            },
            {
                "unified": "0039-FE0F-20E3",
                "shortnames": [
                    "nine"
                ]
            },
            {
                "unified": "1F51F",
                "shortnames": [
                    "keycap_ten"
                ]
            },
            {
                "unified": "1F4AF",
                "shortnames": [
                    "100"
                ]
            },
            {
                "unified": "1F520",
                "shortnames": [
                    "capital_abcd"
                ]
            },
            {
                "unified": "1F521",
                "shortnames": [
                    "abcd"
                ]
            },
            {
                "unified": "1F522",
                "shortnames": [
                    "1234"
                ]
            },
            {
                "unified": "1F523",
                "shortnames": [
                    "symbols"
                ]
            },
            {
                "unified": "1F524",
                "shortnames": [
                    "abc"
                ]
            },
            {
                "unified": "1F170-FE0F",
                "shortnames": [
                    "a"
                ]
            },
            {
                "unified": "1F18E",
                "shortnames": [
                    "ab"
                ]
            },
            {
                "unified": "1F171-FE0F",
                "shortnames": [
                    "b"
                ]
            },
            {
                "unified": "1F191",
                "shortnames": [
                    "cl"
                ]
            },
            {
                "unified": "1F192",
                "shortnames": [
                    "cool"
                ]
            },
            {
                "unified": "1F193",
                "shortnames": [
                    "free"
                ]
            },
            {
                "unified": "2139-FE0F",
                "shortnames": [
                    "information_source"
                ]
            },
            {
                "unified": "1F194",
                "shortnames": [
                    "id"
                ]
            },
            {
                "unified": "24C2-FE0F",
                "shortnames": [
                    "m"
                ]
            },
            {
                "unified": "1F195",
                "shortnames": [
                    "new"
                ]
            },
            {
                "unified": "1F196",
                "shortnames": [
                    "ng"
                ]
            },
            {
                "unified": "1F17E-FE0F",
                "shortnames": [
                    "o2"
                ]
            },
            {
                "unified": "1F197",
                "shortnames": [
                    "ok"
                ]
            },
            {
                "unified": "1F17F-FE0F",
                "shortnames": [
                    "parking"
                ]
            },
            {
                "unified": "1F198",
                "shortnames": [
                    "sos"
                ]
            },
            {
                "unified": "1F199",
                "shortnames": [
                    "up"
                ]
            },
            {
                "unified": "1F19A",
                "shortnames": [
                    "vs"
                ]
            },
            {
                "unified": "1F201",
                "shortnames": [
                    "koko"
                ]
            },
            {
                "unified": "1F202-FE0F",
                "shortnames": [
                    "sa"
                ]
            },
            {
                "unified": "1F237-FE0F",
                "shortnames": [
                    "u6708"
                ]
            },
            {
                "unified": "1F236",
                "shortnames": [
                    "u6709"
                ]
            },
            {
                "unified": "1F22F",
                "shortnames": [
                    "u6307"
                ]
            },
            {
                "unified": "1F250",
                "shortnames": [
                    "ideograph_advantage"
                ]
            },
            {
                "unified": "1F239",
                "shortnames": [
                    "u5272"
                ]
            },
            {
                "unified": "1F21A",
                "shortnames": [
                    "u7121"
                ]
            },
            {
                "unified": "1F232",
                "shortnames": [
                    "u7981"
                ]
            },
            {
                "unified": "1F251",
                "shortnames": [
                    "accept"
                ]
            },
            {
                "unified": "1F238",
                "shortnames": [
                    "u7533"
                ]
            },
            {
                "unified": "1F234",
                "shortnames": [
                    "u5408"
                ]
            },
            {
                "unified": "1F233",
                "shortnames": [
                    "u7a7a"
                ]
            },
            {
                "unified": "3297-FE0F",
                "shortnames": [
                    "congratulations"
                ]
            },
            {
                "unified": "3299-FE0F",
                "shortnames": [
                    "secret"
                ]
            },
            {
                "unified": "1F23A",
                "shortnames": [
                    "u55b6"
                ]
            },
            {
                "unified": "1F235",
                "shortnames": [
                    "u6e80"
                ]
            },
            {
                "unified": "25AA-FE0F",
                "shortnames": [
                    "black_small_square"
                ]
            },
            {
                "unified": "25AB-FE0F",
                "shortnames": [
                    "white_small_square"
                ]
            },
            {
                "unified": "25FB-FE0F",
                "shortnames": [
                    "white_medium_square"
                ]
            },
            {
                "unified": "25FC-FE0F",
                "shortnames": [
                    "black_medium_square"
                ]
            },
            {
                "unified": "25FD",
                "shortnames": [
                    "white_medium_small_square"
                ]
            },
            {
                "unified": "25FE",
                "shortnames": [
                    "black_medium_small_square"
                ]
            },
            {
                "unified": "2B1B",
                "shortnames": [
                    "black_large_square"
                ]
            },
            {
                "unified": "2B1C",
                "shortnames": [
                    "white_large_square"
                ]
            },
            {
                "unified": "1F536",
                "shortnames": [
                    "large_orange_diamond"
                ]
            },
            {
                "unified": "1F537",
                "shortnames": [
                    "large_blue_diamond"
                ]
            },
            {
                "unified": "1F538",
                "shortnames": [
                    "small_orange_diamond"
                ]
            },
            {
                "unified": "1F539",
                "shortnames": [
                    "small_blue_diamond"
                ]
            },
            {
                "unified": "1F53A",
                "shortnames": [
                    "small_red_triangle"
                ]
            },
            {
                "unified": "1F53B",
                "shortnames": [
                    "small_red_triangle_down"
                ]
            },
            {
                "unified": "1F4A0",
                "shortnames": [
                    "diamond_shape_with_a_dot_inside"
                ]
            },
            {
                "unified": "1F518",
                "shortnames": [
                    "radio_button"
                ]
            },
            {
                "unified": "1F532",
                "shortnames": [
                    "black_square_button"
                ]
            },
            {
                "unified": "1F533",
                "shortnames": [
                    "white_square_button"
                ]
            },
            {
                "unified": "26AA",
                "shortnames": [
                    "white_circle"
                ]
            },
            {
                "unified": "26AB",
                "shortnames": [
                    "black_circle"
                ]
            },
            {
                "unified": "1F534",
                "shortnames": [
                    "red_circle"
                ]
            },
            {
                "unified": "1F535",
                "shortnames": [
                    "large_blue_circle"
                ]
            }
        ]
    },
    {
        "name": "Flags",
        "emojis": [
            {
                "unified": "1F3C1",
                "shortnames": [
                    "checkered_flag"
                ]
            },
            {
                "unified": "1F6A9",
                "shortnames": [
                    "triangular_flag_on_post"
                ]
            },
            {
                "unified": "1F38C",
                "shortnames": [
                    "crossed_flags"
                ]
            },
            {
                "unified": "1F3F4",
                "shortnames": [
                    "waving_black_flag"
                ]
            },
            {
                "unified": "1F3F3-FE0F",
                "shortnames": [
                    "waving_white_flag"
                ]
            },
            {
                "unified": "1F3F3-FE0F-200D-1F308",
                "shortnames": [
                    "rainbow-flag"
                ]
            },
            {
                "unified": "1F1E6-1F1E8",
                "shortnames": [
                    "flag-ac"
                ]
            },
            {
                "unified": "1F1E6-1F1E9",
                "shortnames": [
                    "flag-ad"
                ]
            },
            {
                "unified": "1F1E6-1F1EA",
                "shortnames": [
                    "flag-ae"
                ]
            },
            {
                "unified": "1F1E6-1F1EB",
                "shortnames": [
                    "flag-af"
                ]
            },
            {
                "unified": "1F1E6-1F1EC",
                "shortnames": [
                    "flag-ag"
                ]
            },
            {
                "unified": "1F1E6-1F1EE",
                "shortnames": [
                    "flag-ai"
                ]
            },
            {
                "unified": "1F1E6-1F1F1",
                "shortnames": [
                    "flag-al"
                ]
            },
            {
                "unified": "1F1E6-1F1F2",
                "shortnames": [
                    "flag-am"
                ]
            },
            {
                "unified": "1F1E6-1F1F4",
                "shortnames": [
                    "flag-ao"
                ]
            },
            {
                "unified": "1F1E6-1F1F6",
                "shortnames": [
                    "flag-aq"
                ]
            },
            {
                "unified": "1F1E6-1F1F7",
                "shortnames": [
                    "flag-ar"
                ]
            },
            {
                "unified": "1F1E6-1F1F8",
                "shortnames": [
                    "flag-as"
                ]
            },
            {
                "unified": "1F1E6-1F1F9",
                "shortnames": [
                    "flag-at"
                ]
            },
            {
                "unified": "1F1E6-1F1FA",
                "shortnames": [
                    "flag-au"
                ]
            },
            {
                "unified": "1F1E6-1F1FC",
                "shortnames": [
                    "flag-aw"
                ]
            },
            {
                "unified": "1F1E6-1F1FD",
                "shortnames": [
                    "flag-ax"
                ]
            },
            {
                "unified": "1F1E6-1F1FF",
                "shortnames": [
                    "flag-az"
                ]
            },
            {
                "unified": "1F1E7-1F1E6",
                "shortnames": [
                    "flag-ba"
                ]
            },
            {
                "unified": "1F1E7-1F1E7",
                "shortnames": [
                    "flag-bb"
                ]
            },
            {
                "unified": "1F1E7-1F1E9",
                "shortnames": [
                    "flag-bd"
                ]
            },
            {
                "unified": "1F1E7-1F1EA",
                "shortnames": [
                    "flag-be"
                ]
            },
            {
                "unified": "1F1E7-1F1EB",
                "shortnames": [
                    "flag-bf"
                ]
            },
            {
                "unified": "1F1E7-1F1EC",
                "shortnames": [
                    "flag-bg"
                ]
            },
            {
                "unified": "1F1E7-1F1ED",
                "shortnames": [
                    "flag-bh"
                ]
            },
            {
                "unified": "1F1E7-1F1EE",
                "shortnames": [
                    "flag-bi"
                ]
            },
            {
                "unified": "1F1E7-1F1EF",
                "shortnames": [
                    "flag-bj"
                ]
            },
            {
                "unified": "1F1E7-1F1F1",
                "shortnames": [
                    "flag-bl"
                ]
            },
            {
                "unified": "1F1E7-1F1F2",
                "shortnames": [
                    "flag-bm"
                ]
            },
            {
                "unified": "1F1E7-1F1F3",
                "shortnames": [
                    "flag-bn"
                ]
            },
            {
                "unified": "1F1E7-1F1F4",
                "shortnames": [
                    "flag-bo"
                ]
            },
            {
                "unified": "1F1E7-1F1F6",
                "shortnames": [
                    "flag-bq"
                ]
            },
            {
                "unified": "1F1E7-1F1F7",
                "shortnames": [
                    "flag-br"
                ]
            },
            {
                "unified": "1F1E7-1F1F8",
                "shortnames": [
                    "flag-bs"
                ]
            },
            {
                "unified": "1F1E7-1F1F9",
                "shortnames": [
                    "flag-bt"
                ]
            },
            {
                "unified": "1F1E7-1F1FB",
                "shortnames": [
                    "flag-bv"
                ]
            },
            {
                "unified": "1F1E7-1F1FC",
                "shortnames": [
                    "flag-bw"
                ]
            },
            {
                "unified": "1F1E7-1F1FE",
                "shortnames": [
                    "flag-by"
                ]
            },
            {
                "unified": "1F1E7-1F1FF",
                "shortnames": [
                    "flag-bz"
                ]
            },
            {
                "unified": "1F1E8-1F1E6",
                "shortnames": [
                    "flag-ca"
                ]
            },
            {
                "unified": "1F1E8-1F1E8",
                "shortnames": [
                    "flag-cc"
                ]
            },
            {
                "unified": "1F1E8-1F1E9",
                "shortnames": [
                    "flag-cd"
                ]
            },
            {
                "unified": "1F1E8-1F1EB",
                "shortnames": [
                    "flag-cf"
                ]
            },
            {
                "unified": "1F1E8-1F1EC",
                "shortnames": [
                    "flag-cg"
                ]
            },
            {
                "unified": "1F1E8-1F1ED",
                "shortnames": [
                    "flag-ch"
                ]
            },
            {
                "unified": "1F1E8-1F1EE",
                "shortnames": [
                    "flag-ci"
                ]
            },
            {
                "unified": "1F1E8-1F1F0",
                "shortnames": [
                    "flag-ck"
                ]
            },
            {
                "unified": "1F1E8-1F1F1",
                "shortnames": [
                    "flag-cl"
                ]
            },
            {
                "unified": "1F1E8-1F1F2",
                "shortnames": [
                    "flag-cm"
                ]
            },
            {
                "unified": "1F1E8-1F1F3",
                "shortnames": [
                    "cn"
                ]
            },
            {
                "unified": "1F1E8-1F1F4",
                "shortnames": [
                    "flag-co"
                ]
            },
            {
                "unified": "1F1E8-1F1F5",
                "shortnames": [
                    "flag-cp"
                ]
            },
            {
                "unified": "1F1E8-1F1F7",
                "shortnames": [
                    "flag-cr"
                ]
            },
            {
                "unified": "1F1E8-1F1FA",
                "shortnames": [
                    "flag-cu"
                ]
            },
            {
                "unified": "1F1E8-1F1FB",
                "shortnames": [
                    "flag-cv"
                ]
            },
            {
                "unified": "1F1E8-1F1FC",
                "shortnames": [
                    "flag-cw"
                ]
            },
            {
                "unified": "1F1E8-1F1FD",
                "shortnames": [
                    "flag-cx"
                ]
            },
            {
                "unified": "1F1E8-1F1FE",
                "shortnames": [
                    "flag-cy"
                ]
            },
            {
                "unified": "1F1E8-1F1FF",
                "shortnames": [
                    "flag-cz"
                ]
            },
            {
                "unified": "1F1E9-1F1EA",
                "shortnames": [
                    "de"
                ]
            },
            {
                "unified": "1F1E9-1F1EC",
                "shortnames": [
                    "flag-dg"
                ]
            },
            {
                "unified": "1F1E9-1F1EF",
                "shortnames": [
                    "flag-dj"
                ]
            },
            {
                "unified": "1F1E9-1F1F0",
                "shortnames": [
                    "flag-dk"
                ]
            },
            {
                "unified": "1F1E9-1F1F2",
                "shortnames": [
                    "flag-dm"
                ]
            },
            {
                "unified": "1F1E9-1F1F4",
                "shortnames": [
                    "flag-do"
                ]
            },
            {
                "unified": "1F1E9-1F1FF",
                "shortnames": [
                    "flag-dz"
                ]
            },
            {
                "unified": "1F1EA-1F1E6",
                "shortnames": [
                    "flag-ea"
                ]
            },
            {
                "unified": "1F1EA-1F1E8",
                "shortnames": [
                    "flag-ec"
                ]
            },
            {
                "unified": "1F1EA-1F1EA",
                "shortnames": [
                    "flag-ee"
                ]
            },
            {
                "unified": "1F1EA-1F1EC",
                "shortnames": [
                    "flag-eg"
                ]
            },
            {
                "unified": "1F1EA-1F1ED",
                "shortnames": [
                    "flag-eh"
                ]
            },
            {
                "unified": "1F1EA-1F1F7",
                "shortnames": [
                    "flag-er"
                ]
            },
            {
                "unified": "1F1EA-1F1F8",
                "shortnames": [
                    "es"
                ]
            },
            {
                "unified": "1F1EA-1F1F9",
                "shortnames": [
                    "flag-et"
                ]
            },
            {
                "unified": "1F1EA-1F1FA",
                "shortnames": [
                    "flag-eu"
                ]
            },
            {
                "unified": "1F1EB-1F1EE",
                "shortnames": [
                    "flag-fi"
                ]
            },
            {
                "unified": "1F1EB-1F1EF",
                "shortnames": [
                    "flag-fj"
                ]
            },
            {
                "unified": "1F1EB-1F1F0",
                "shortnames": [
                    "flag-fk"
                ]
            },
            {
                "unified": "1F1EB-1F1F2",
                "shortnames": [
                    "flag-fm"
                ]
            },
            {
                "unified": "1F1EB-1F1F4",
                "shortnames": [
                    "flag-fo"
                ]
            },
            {
                "unified": "1F1EB-1F1F7",
                "shortnames": [
                    "fr"
                ]
            },
            {
                "unified": "1F1EC-1F1E6",
                "shortnames": [
                    "flag-ga"
                ]
            },
            {
                "unified": "1F1EC-1F1E7",
                "shortnames": [
                    "gb"
                ]
            },
            {
                "unified": "1F1EC-1F1E9",
                "shortnames": [
                    "flag-gd"
                ]
            },
            {
                "unified": "1F1EC-1F1EA",
                "shortnames": [
                    "flag-ge"
                ]
            },
            {
                "unified": "1F1EC-1F1EB",
                "shortnames": [
                    "flag-gf"
                ]
            },
            {
                "unified": "1F1EC-1F1EC",
                "shortnames": [
                    "flag-gg"
                ]
            },
            {
                "unified": "1F1EC-1F1ED",
                "shortnames": [
                    "flag-gh"
                ]
            },
            {
                "unified": "1F1EC-1F1EE",
                "shortnames": [
                    "flag-gi"
                ]
            },
            {
                "unified": "1F1EC-1F1F1",
                "shortnames": [
                    "flag-gl"
                ]
            },
            {
                "unified": "1F1EC-1F1F2",
                "shortnames": [
                    "flag-gm"
                ]
            },
            {
                "unified": "1F1EC-1F1F3",
                "shortnames": [
                    "flag-gn"
                ]
            },
            {
                "unified": "1F1EC-1F1F5",
                "shortnames": [
                    "flag-gp"
                ]
            },
            {
                "unified": "1F1EC-1F1F6",
                "shortnames": [
                    "flag-gq"
                ]
            },
            {
                "unified": "1F1EC-1F1F7",
                "shortnames": [
                    "flag-gr"
                ]
            },
            {
                "unified": "1F1EC-1F1F8",
                "shortnames": [
                    "flag-gs"
                ]
            },
            {
                "unified": "1F1EC-1F1F9",
                "shortnames": [
                    "flag-gt"
                ]
            },
            {
                "unified": "1F1EC-1F1FA",
                "shortnames": [
                    "flag-gu"
                ]
            },
            {
                "unified": "1F1EC-1F1FC",
                "shortnames": [
                    "flag-gw"
                ]
            },
            {
                "unified": "1F1EC-1F1FE",
                "shortnames": [
                    "flag-gy"
                ]
            },
            {
                "unified": "1F1ED-1F1F0",
                "shortnames": [
                    "flag-hk"
                ]
            },
            {
                "unified": "1F1ED-1F1F2",
                "shortnames": [
                    "flag-hm"
                ]
            },
            {
                "unified": "1F1ED-1F1F3",
                "shortnames": [
                    "flag-hn"
                ]
            },
            {
                "unified": "1F1ED-1F1F7",
                "shortnames": [
                    "flag-hr"
                ]
            },
            {
                "unified": "1F1ED-1F1F9",
                "shortnames": [
                    "flag-ht"
                ]
            },
            {
                "unified": "1F1ED-1F1FA",
                "shortnames": [
                    "flag-hu"
                ]
            },
            {
                "unified": "1F1EE-1F1E8",
                "shortnames": [
                    "flag-ic"
                ]
            },
            {
                "unified": "1F1EE-1F1E9",
                "shortnames": [
                    "flag-id"
                ]
            },
            {
                "unified": "1F1EE-1F1EA",
                "shortnames": [
                    "flag-ie"
                ]
            },
            {
                "unified": "1F1EE-1F1F1",
                "shortnames": [
                    "flag-il"
                ]
            },
            {
                "unified": "1F1EE-1F1F2",
                "shortnames": [
                    "flag-im"
                ]
            },
            {
                "unified": "1F1EE-1F1F3",
                "shortnames": [
                    "flag-in"
                ]
            },
            {
                "unified": "1F1EE-1F1F4",
                "shortnames": [
                    "flag-io"
                ]
            },
            {
                "unified": "1F1EE-1F1F6",
                "shortnames": [
                    "flag-iq"
                ]
            },
            {
                "unified": "1F1EE-1F1F7",
                "shortnames": [
                    "flag-ir"
                ]
            },
            {
                "unified": "1F1EE-1F1F8",
                "shortnames": [
                    "flag-is"
                ]
            },
            {
                "unified": "1F1EE-1F1F9",
                "shortnames": [
                    "it"
                ]
            },
            {
                "unified": "1F1EF-1F1EA",
                "shortnames": [
                    "flag-je"
                ]
            },
            {
                "unified": "1F1EF-1F1F2",
                "shortnames": [
                    "flag-jm"
                ]
            },
            {
                "unified": "1F1EF-1F1F4",
                "shortnames": [
                    "flag-jo"
                ]
            },
            {
                "unified": "1F1EF-1F1F5",
                "shortnames": [
                    "jp"
                ]
            },
            {
                "unified": "1F1F0-1F1EA",
                "shortnames": [
                    "flag-ke"
                ]
            },
            {
                "unified": "1F1F0-1F1EC",
                "shortnames": [
                    "flag-kg"
                ]
            },
            {
                "unified": "1F1F0-1F1ED",
                "shortnames": [
                    "flag-kh"
                ]
            },
            {
                "unified": "1F1F0-1F1EE",
                "shortnames": [
                    "flag-ki"
                ]
            },
            {
                "unified": "1F1F0-1F1F2",
                "shortnames": [
                    "flag-km"
                ]
            },
            {
                "unified": "1F1F0-1F1F3",
                "shortnames": [
                    "flag-kn"
                ]
            },
            {
                "unified": "1F1F0-1F1F5",
                "shortnames": [
                    "flag-kp"
                ]
            },
            {
                "unified": "1F1F0-1F1F7",
                "shortnames": [
                    "kr"
                ]
            },
            {
                "unified": "1F1F0-1F1FC",
                "shortnames": [
                    "flag-kw"
                ]
            },
            {
                "unified": "1F1F0-1F1FE",
                "shortnames": [
                    "flag-ky"
                ]
            },
            {
                "unified": "1F1F0-1F1FF",
                "shortnames": [
                    "flag-kz"
                ]
            },
            {
                "unified": "1F1F1-1F1E6",
                "shortnames": [
                    "flag-la"
                ]
            },
            {
                "unified": "1F1F1-1F1E7",
                "shortnames": [
                    "flag-lb"
                ]
            },
            {
                "unified": "1F1F1-1F1E8",
                "shortnames": [
                    "flag-lc"
                ]
            },
            {
                "unified": "1F1F1-1F1EE",
                "shortnames": [
                    "flag-li"
                ]
            },
            {
                "unified": "1F1F1-1F1F0",
                "shortnames": [
                    "flag-lk"
                ]
            },
            {
                "unified": "1F1F1-1F1F7",
                "shortnames": [
                    "flag-lr"
                ]
            },
            {
                "unified": "1F1F1-1F1F8",
                "shortnames": [
                    "flag-ls"
                ]
            },
            {
                "unified": "1F1F1-1F1F9",
                "shortnames": [
                    "flag-lt"
                ]
            },
            {
                "unified": "1F1F1-1F1FA",
                "shortnames": [
                    "flag-lu"
                ]
            },
            {
                "unified": "1F1F1-1F1FB",
                "shortnames": [
                    "flag-lv"
                ]
            },
            {
                "unified": "1F1F1-1F1FE",
                "shortnames": [
                    "flag-ly"
                ]
            },
            {
                "unified": "1F1F2-1F1E6",
                "shortnames": [
                    "flag-ma"
                ]
            },
            {
                "unified": "1F1F2-1F1E8",
                "shortnames": [
                    "flag-mc"
                ]
            },
            {
                "unified": "1F1F2-1F1E9",
                "shortnames": [
                    "flag-md"
                ]
            },
            {
                "unified": "1F1F2-1F1EA",
                "shortnames": [
                    "flag-me"
                ]
            },
            {
                "unified": "1F1F2-1F1EB",
                "shortnames": [
                    "flag-mf"
                ]
            },
            {
                "unified": "1F1F2-1F1EC",
                "shortnames": [
                    "flag-mg"
                ]
            },
            {
                "unified": "1F1F2-1F1ED",
                "shortnames": [
                    "flag-mh"
                ]
            },
            {
                "unified": "1F1F2-1F1F0",
                "shortnames": [
                    "flag-mk"
                ]
            },
            {
                "unified": "1F1F2-1F1F1",
                "shortnames": [
                    "flag-ml"
                ]
            },
            {
                "unified": "1F1F2-1F1F2",
                "shortnames": [
                    "flag-mm"
                ]
            },
            {
                "unified": "1F1F2-1F1F3",
                "shortnames": [
                    "flag-mn"
                ]
            },
            {
                "unified": "1F1F2-1F1F4",
                "shortnames": [
                    "flag-mo"
                ]
            },
            {
                "unified": "1F1F2-1F1F5",
                "shortnames": [
                    "flag-mp"
                ]
            },
            {
                "unified": "1F1F2-1F1F6",
                "shortnames": [
                    "flag-mq"
                ]
            },
            {
                "unified": "1F1F2-1F1F7",
                "shortnames": [
                    "flag-mr"
                ]
            },
            {
                "unified": "1F1F2-1F1F8",
                "shortnames": [
                    "flag-ms"
                ]
            },
            {
                "unified": "1F1F2-1F1F9",
                "shortnames": [
                    "flag-mt"
                ]
            },
            {
                "unified": "1F1F2-1F1FA",
                "shortnames": [
                    "flag-mu"
                ]
            },
            {
                "unified": "1F1F2-1F1FB",
                "shortnames": [
                    "flag-mv"
                ]
            },
            {
                "unified": "1F1F2-1F1FC",
                "shortnames": [
                    "flag-mw"
                ]
            },
            {
                "unified": "1F1F2-1F1FD",
                "shortnames": [
                    "flag-mx"
                ]
            },
            {
                "unified": "1F1F2-1F1FE",
                "shortnames": [
                    "flag-my"
                ]
            },
            {
                "unified": "1F1F2-1F1FF",
                "shortnames": [
                    "flag-mz"
                ]
            },
            {
                "unified": "1F1F3-1F1E6",
                "shortnames": [
                    "flag-na"
                ]
            },
            {
                "unified": "1F1F3-1F1E8",
                "shortnames": [
                    "flag-nc"
                ]
            },
            {
                "unified": "1F1F3-1F1EA",
                "shortnames": [
                    "flag-ne"
                ]
            },
            {
                "unified": "1F1F3-1F1EB",
                "shortnames": [
                    "flag-nf"
                ]
            },
            {
                "unified": "1F1F3-1F1EC",
                "shortnames": [
                    "flag-ng"
                ]
            },
            {
                "unified": "1F1F3-1F1EE",
                "shortnames": [
                    "flag-ni"
                ]
            },
            {
                "unified": "1F1F3-1F1F1",
                "shortnames": [
                    "flag-nl"
                ]
            },
            {
                "unified": "1F1F3-1F1F4",
                "shortnames": [
                    "flag-no"
                ]
            },
            {
                "unified": "1F1F3-1F1F5",
                "shortnames": [
                    "flag-np"
                ]
            },
            {
                "unified": "1F1F3-1F1F7",
                "shortnames": [
                    "flag-nr"
                ]
            },
            {
                "unified": "1F1F3-1F1FA",
                "shortnames": [
                    "flag-nu"
                ]
            },
            {
                "unified": "1F1F3-1F1FF",
                "shortnames": [
                    "flag-nz"
                ]
            },
            {
                "unified": "1F1F4-1F1F2",
                "shortnames": [
                    "flag-om"
                ]
            },
            {
                "unified": "1F1F5-1F1E6",
                "shortnames": [
                    "flag-pa"
                ]
            },
            {
                "unified": "1F1F5-1F1EA",
                "shortnames": [
                    "flag-pe"
                ]
            },
            {
                "unified": "1F1F5-1F1EB",
                "shortnames": [
                    "flag-pf"
                ]
            },
            {
                "unified": "1F1F5-1F1EC",
                "shortnames": [
                    "flag-pg"
                ]
            },
            {
                "unified": "1F1F5-1F1ED",
                "shortnames": [
                    "flag-ph"
                ]
            },
            {
                "unified": "1F1F5-1F1F0",
                "shortnames": [
                    "flag-pk"
                ]
            },
            {
                "unified": "1F1F5-1F1F1",
                "shortnames": [
                    "flag-pl"
                ]
            },
            {
                "unified": "1F1F5-1F1F2",
                "shortnames": [
                    "flag-pm"
                ]
            },
            {
                "unified": "1F1F5-1F1F3",
                "shortnames": [
                    "flag-pn"
                ]
            },
            {
                "unified": "1F1F5-1F1F7",
                "shortnames": [
                    "flag-pr"
                ]
            },
            {
                "unified": "1F1F5-1F1F8",
                "shortnames": [
                    "flag-ps"
                ]
            },
            {
                "unified": "1F1F5-1F1F9",
                "shortnames": [
                    "flag-pt"
                ]
            },
            {
                "unified": "1F1F5-1F1FC",
                "shortnames": [
                    "flag-pw"
                ]
            },
            {
                "unified": "1F1F5-1F1FE",
                "shortnames": [
                    "flag-py"
                ]
            },
            {
                "unified": "1F1F6-1F1E6",
                "shortnames": [
                    "flag-qa"
                ]
            },
            {
                "unified": "1F1F7-1F1EA",
                "shortnames": [
                    "flag-re"
                ]
            },
            {
                "unified": "1F1F7-1F1F4",
                "shortnames": [
                    "flag-ro"
                ]
            },
            {
                "unified": "1F1F7-1F1F8",
                "shortnames": [
                    "flag-rs"
                ]
            },
            {
                "unified": "1F1F7-1F1FA",
                "shortnames": [
                    "ru"
                ]
            },
            {
                "unified": "1F1F7-1F1FC",
                "shortnames": [
                    "flag-rw"
                ]
            },
            {
                "unified": "1F1F8-1F1E6",
                "shortnames": [
                    "flag-sa"
                ]
            },
            {
                "unified": "1F1F8-1F1E7",
                "shortnames": [
                    "flag-sb"
                ]
            },
            {
                "unified": "1F1F8-1F1E8",
                "shortnames": [
                    "flag-sc"
                ]
            },
            {
                "unified": "1F1F8-1F1E9",
                "shortnames": [
                    "flag-sd"
                ]
            },
            {
                "unified": "1F1F8-1F1EA",
                "shortnames": [
                    "flag-se"
                ]
            },
            {
                "unified": "1F1F8-1F1EC",
                "shortnames": [
                    "flag-sg"
                ]
            },
            {
                "unified": "1F1F8-1F1ED",
                "shortnames": [
                    "flag-sh"
                ]
            },
            {
                "unified": "1F1F8-1F1EE",
                "shortnames": [
                    "flag-si"
                ]
            },
            {
                "unified": "1F1F8-1F1EF",
                "shortnames": [
                    "flag-sj"
                ]
            },
            {
                "unified": "1F1F8-1F1F0",
                "shortnames": [
                    "flag-sk"
                ]
            },
            {
                "unified": "1F1F8-1F1F1",
                "shortnames": [
                    "flag-sl"
                ]
            },
            {
                "unified": "1F1F8-1F1F2",
                "shortnames": [
                    "flag-sm"
                ]
            },
            {
                "unified": "1F1F8-1F1F3",
                "shortnames": [
                    "flag-sn"
                ]
            },
            {
                "unified": "1F1F8-1F1F4",
                "shortnames": [
                    "flag-so"
                ]
            },
            {
                "unified": "1F1F8-1F1F7",
                "shortnames": [
                    "flag-sr"
                ]
            },
            {
                "unified": "1F1F8-1F1F8",
                "shortnames": [
                    "flag-ss"
                ]
            },
            {
                "unified": "1F1F8-1F1F9",
                "shortnames": [
                    "flag-st"
                ]
            },
            {
                "unified": "1F1F8-1F1FB",
                "shortnames": [
                    "flag-sv"
                ]
            },
            {
                "unified": "1F1F8-1F1FD",
                "shortnames": [
                    "flag-sx"
                ]
            },
            {
                "unified": "1F1F8-1F1FE",
                "shortnames": [
                    "flag-sy"
                ]
            },
            {
                "unified": "1F1F8-1F1FF",
                "shortnames": [
                    "flag-sz"
                ]
            },
            {
                "unified": "1F1F9-1F1E6",
                "shortnames": [
                    "flag-ta"
                ]
            },
            {
                "unified": "1F1F9-1F1E8",
                "shortnames": [
                    "flag-tc"
                ]
            },
            {
                "unified": "1F1F9-1F1E9",
                "shortnames": [
                    "flag-td"
                ]
            },
            {
                "unified": "1F1F9-1F1EB",
                "shortnames": [
                    "flag-tf"
                ]
            },
            {
                "unified": "1F1F9-1F1EC",
                "shortnames": [
                    "flag-tg"
                ]
            },
            {
                "unified": "1F1F9-1F1ED",
                "shortnames": [
                    "flag-th"
                ]
            },
            {
                "unified": "1F1F9-1F1EF",
                "shortnames": [
                    "flag-tj"
                ]
            },
            {
                "unified": "1F1F9-1F1F0",
                "shortnames": [
                    "flag-tk"
                ]
            },
            {
                "unified": "1F1F9-1F1F1",
                "shortnames": [
                    "flag-tl"
                ]
            },
            {
                "unified": "1F1F9-1F1F2",
                "shortnames": [
                    "flag-tm"
                ]
            },
            {
                "unified": "1F1F9-1F1F3",
                "shortnames": [
                    "flag-tn"
                ]
            },
            {
                "unified": "1F1F9-1F1F4",
                "shortnames": [
                    "flag-to"
                ]
            },
            {
                "unified": "1F1F9-1F1F7",
                "shortnames": [
                    "flag-tr"
                ]
            },
            {
                "unified": "1F1F9-1F1F9",
                "shortnames": [
                    "flag-tt"
                ]
            },
            {
                "unified": "1F1F9-1F1FB",
                "shortnames": [
                    "flag-tv"
                ]
            },
            {
                "unified": "1F1F9-1F1FC",
                "shortnames": [
                    "flag-tw"
                ]
            },
            {
                "unified": "1F1F9-1F1FF",
                "shortnames": [
                    "flag-tz"
                ]
            },
            {
                "unified": "1F1FA-1F1E6",
                "shortnames": [
                    "flag-ua"
                ]
            },
            {
                "unified": "1F1FA-1F1EC",
                "shortnames": [
                    "flag-ug"
                ]
            },
            {
                "unified": "1F1FA-1F1F2",
                "shortnames": [
                    "flag-um"
                ]
            },
            {
                "unified": "1F1FA-1F1F3",
                "shortnames": [
                    "flag-un"
                ]
            },
            {
                "unified": "1F1FA-1F1F8",
                "shortnames": [
                    "us"
                ]
            },
            {
                "unified": "1F1FA-1F1FE",
                "shortnames": [
                    "flag-uy"
                ]
            },
            {
                "unified": "1F1FA-1F1FF",
                "shortnames": [
                    "flag-uz"
                ]
            },
            {
                "unified": "1F1FB-1F1E6",
                "shortnames": [
                    "flag-va"
                ]
            },
            {
                "unified": "1F1FB-1F1E8",
                "shortnames": [
                    "flag-vc"
                ]
            },
            {
                "unified": "1F1FB-1F1EA",
                "shortnames": [
                    "flag-ve"
                ]
            },
            {
                "unified": "1F1FB-1F1EC",
                "shortnames": [
                    "flag-vg"
                ]
            },
            {
                "unified": "1F1FB-1F1EE",
                "shortnames": [
                    "flag-vi"
                ]
            },
            {
                "unified": "1F1FB-1F1F3",
                "shortnames": [
                    "flag-vn"
                ]
            },
            {
                "unified": "1F1FB-1F1FA",
                "shortnames": [
                    "flag-vu"
                ]
            },
            {
                "unified": "1F1FC-1F1EB",
                "shortnames": [
                    "flag-wf"
                ]
            },
            {
                "unified": "1F1FC-1F1F8",
                "shortnames": [
                    "flag-ws"
                ]
            },
            {
                "unified": "1F1FD-1F1F0",
                "shortnames": [
                    "flag-xk"
                ]
            },
            {
                "unified": "1F1FE-1F1EA",
                "shortnames": [
                    "flag-ye"
                ]
            },
            {
                "unified": "1F1FE-1F1F9",
                "shortnames": [
                    "flag-yt"
                ]
            },
            {
                "unified": "1F1FF-1F1E6",
                "shortnames": [
                    "flag-za"
                ]
            },
            {
                "unified": "1F1FF-1F1F2",
                "shortnames": [
                    "flag-zm"
                ]
            },
            {
                "unified": "1F1FF-1F1FC",
                "shortnames": [
                    "flag-zw"
                ]
            },
            {
                "unified": "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
                "shortnames": [
                    "flag-england"
                ]
            },
            {
                "unified": "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
                "shortnames": [
                    "flag-scotland"
                ]
            },
            {
                "unified": "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
                "shortnames": [
                    "flag-wales"
                ]
            }
        ]
    }
];

export const byShortName = {
    "hash": "0023-FE0F-20E3",
    "keycap_star": "002A-FE0F-20E3",
    "zero": "0030-FE0F-20E3",
    "one": "0031-FE0F-20E3",
    "two": "0032-FE0F-20E3",
    "three": "0033-FE0F-20E3",
    "four": "0034-FE0F-20E3",
    "five": "0035-FE0F-20E3",
    "six": "0036-FE0F-20E3",
    "seven": "0037-FE0F-20E3",
    "eight": "0038-FE0F-20E3",
    "nine": "0039-FE0F-20E3",
    "copyright": "00A9-FE0F",
    "registered": "00AE-FE0F",
    "mahjong": "1F004",
    "black_joker": "1F0CF",
    "a": "1F170-FE0F",
    "b": "1F171-FE0F",
    "o2": "1F17E-FE0F",
    "parking": "1F17F-FE0F",
    "ab": "1F18E",
    "cl": "1F191",
    "cool": "1F192",
    "free": "1F193",
    "id": "1F194",
    "new": "1F195",
    "ng": "1F196",
    "ok": "1F197",
    "sos": "1F198",
    "up": "1F199",
    "vs": "1F19A",
    "flag-ac": "1F1E6-1F1E8",
    "flag-ad": "1F1E6-1F1E9",
    "flag-ae": "1F1E6-1F1EA",
    "flag-af": "1F1E6-1F1EB",
    "flag-ag": "1F1E6-1F1EC",
    "flag-ai": "1F1E6-1F1EE",
    "flag-al": "1F1E6-1F1F1",
    "flag-am": "1F1E6-1F1F2",
    "flag-ao": "1F1E6-1F1F4",
    "flag-aq": "1F1E6-1F1F6",
    "flag-ar": "1F1E6-1F1F7",
    "flag-as": "1F1E6-1F1F8",
    "flag-at": "1F1E6-1F1F9",
    "flag-au": "1F1E6-1F1FA",
    "flag-aw": "1F1E6-1F1FC",
    "flag-ax": "1F1E6-1F1FD",
    "flag-az": "1F1E6-1F1FF",
    "flag-ba": "1F1E7-1F1E6",
    "flag-bb": "1F1E7-1F1E7",
    "flag-bd": "1F1E7-1F1E9",
    "flag-be": "1F1E7-1F1EA",
    "flag-bf": "1F1E7-1F1EB",
    "flag-bg": "1F1E7-1F1EC",
    "flag-bh": "1F1E7-1F1ED",
    "flag-bi": "1F1E7-1F1EE",
    "flag-bj": "1F1E7-1F1EF",
    "flag-bl": "1F1E7-1F1F1",
    "flag-bm": "1F1E7-1F1F2",
    "flag-bn": "1F1E7-1F1F3",
    "flag-bo": "1F1E7-1F1F4",
    "flag-bq": "1F1E7-1F1F6",
    "flag-br": "1F1E7-1F1F7",
    "flag-bs": "1F1E7-1F1F8",
    "flag-bt": "1F1E7-1F1F9",
    "flag-bv": "1F1E7-1F1FB",
    "flag-bw": "1F1E7-1F1FC",
    "flag-by": "1F1E7-1F1FE",
    "flag-bz": "1F1E7-1F1FF",
    "flag-ca": "1F1E8-1F1E6",
    "flag-cc": "1F1E8-1F1E8",
    "flag-cd": "1F1E8-1F1E9",
    "flag-cf": "1F1E8-1F1EB",
    "flag-cg": "1F1E8-1F1EC",
    "flag-ch": "1F1E8-1F1ED",
    "flag-ci": "1F1E8-1F1EE",
    "flag-ck": "1F1E8-1F1F0",
    "flag-cl": "1F1E8-1F1F1",
    "flag-cm": "1F1E8-1F1F2",
    "cn": "1F1E8-1F1F3",
    "flag-co": "1F1E8-1F1F4",
    "flag-cp": "1F1E8-1F1F5",
    "flag-cr": "1F1E8-1F1F7",
    "flag-cu": "1F1E8-1F1FA",
    "flag-cv": "1F1E8-1F1FB",
    "flag-cw": "1F1E8-1F1FC",
    "flag-cx": "1F1E8-1F1FD",
    "flag-cy": "1F1E8-1F1FE",
    "flag-cz": "1F1E8-1F1FF",
    "de": "1F1E9-1F1EA",
    "flag-dg": "1F1E9-1F1EC",
    "flag-dj": "1F1E9-1F1EF",
    "flag-dk": "1F1E9-1F1F0",
    "flag-dm": "1F1E9-1F1F2",
    "flag-do": "1F1E9-1F1F4",
    "flag-dz": "1F1E9-1F1FF",
    "flag-ea": "1F1EA-1F1E6",
    "flag-ec": "1F1EA-1F1E8",
    "flag-ee": "1F1EA-1F1EA",
    "flag-eg": "1F1EA-1F1EC",
    "flag-eh": "1F1EA-1F1ED",
    "flag-er": "1F1EA-1F1F7",
    "es": "1F1EA-1F1F8",
    "flag-et": "1F1EA-1F1F9",
    "flag-eu": "1F1EA-1F1FA",
    "flag-fi": "1F1EB-1F1EE",
    "flag-fj": "1F1EB-1F1EF",
    "flag-fk": "1F1EB-1F1F0",
    "flag-fm": "1F1EB-1F1F2",
    "flag-fo": "1F1EB-1F1F4",
    "fr": "1F1EB-1F1F7",
    "flag-ga": "1F1EC-1F1E6",
    "gb": "1F1EC-1F1E7",
    "flag-gd": "1F1EC-1F1E9",
    "flag-ge": "1F1EC-1F1EA",
    "flag-gf": "1F1EC-1F1EB",
    "flag-gg": "1F1EC-1F1EC",
    "flag-gh": "1F1EC-1F1ED",
    "flag-gi": "1F1EC-1F1EE",
    "flag-gl": "1F1EC-1F1F1",
    "flag-gm": "1F1EC-1F1F2",
    "flag-gn": "1F1EC-1F1F3",
    "flag-gp": "1F1EC-1F1F5",
    "flag-gq": "1F1EC-1F1F6",
    "flag-gr": "1F1EC-1F1F7",
    "flag-gs": "1F1EC-1F1F8",
    "flag-gt": "1F1EC-1F1F9",
    "flag-gu": "1F1EC-1F1FA",
    "flag-gw": "1F1EC-1F1FC",
    "flag-gy": "1F1EC-1F1FE",
    "flag-hk": "1F1ED-1F1F0",
    "flag-hm": "1F1ED-1F1F2",
    "flag-hn": "1F1ED-1F1F3",
    "flag-hr": "1F1ED-1F1F7",
    "flag-ht": "1F1ED-1F1F9",
    "flag-hu": "1F1ED-1F1FA",
    "flag-ic": "1F1EE-1F1E8",
    "flag-id": "1F1EE-1F1E9",
    "flag-ie": "1F1EE-1F1EA",
    "flag-il": "1F1EE-1F1F1",
    "flag-im": "1F1EE-1F1F2",
    "flag-in": "1F1EE-1F1F3",
    "flag-io": "1F1EE-1F1F4",
    "flag-iq": "1F1EE-1F1F6",
    "flag-ir": "1F1EE-1F1F7",
    "flag-is": "1F1EE-1F1F8",
    "it": "1F1EE-1F1F9",
    "flag-je": "1F1EF-1F1EA",
    "flag-jm": "1F1EF-1F1F2",
    "flag-jo": "1F1EF-1F1F4",
    "jp": "1F1EF-1F1F5",
    "flag-ke": "1F1F0-1F1EA",
    "flag-kg": "1F1F0-1F1EC",
    "flag-kh": "1F1F0-1F1ED",
    "flag-ki": "1F1F0-1F1EE",
    "flag-km": "1F1F0-1F1F2",
    "flag-kn": "1F1F0-1F1F3",
    "flag-kp": "1F1F0-1F1F5",
    "kr": "1F1F0-1F1F7",
    "flag-kw": "1F1F0-1F1FC",
    "flag-ky": "1F1F0-1F1FE",
    "flag-kz": "1F1F0-1F1FF",
    "flag-la": "1F1F1-1F1E6",
    "flag-lb": "1F1F1-1F1E7",
    "flag-lc": "1F1F1-1F1E8",
    "flag-li": "1F1F1-1F1EE",
    "flag-lk": "1F1F1-1F1F0",
    "flag-lr": "1F1F1-1F1F7",
    "flag-ls": "1F1F1-1F1F8",
    "flag-lt": "1F1F1-1F1F9",
    "flag-lu": "1F1F1-1F1FA",
    "flag-lv": "1F1F1-1F1FB",
    "flag-ly": "1F1F1-1F1FE",
    "flag-ma": "1F1F2-1F1E6",
    "flag-mc": "1F1F2-1F1E8",
    "flag-md": "1F1F2-1F1E9",
    "flag-me": "1F1F2-1F1EA",
    "flag-mf": "1F1F2-1F1EB",
    "flag-mg": "1F1F2-1F1EC",
    "flag-mh": "1F1F2-1F1ED",
    "flag-mk": "1F1F2-1F1F0",
    "flag-ml": "1F1F2-1F1F1",
    "flag-mm": "1F1F2-1F1F2",
    "flag-mn": "1F1F2-1F1F3",
    "flag-mo": "1F1F2-1F1F4",
    "flag-mp": "1F1F2-1F1F5",
    "flag-mq": "1F1F2-1F1F6",
    "flag-mr": "1F1F2-1F1F7",
    "flag-ms": "1F1F2-1F1F8",
    "flag-mt": "1F1F2-1F1F9",
    "flag-mu": "1F1F2-1F1FA",
    "flag-mv": "1F1F2-1F1FB",
    "flag-mw": "1F1F2-1F1FC",
    "flag-mx": "1F1F2-1F1FD",
    "flag-my": "1F1F2-1F1FE",
    "flag-mz": "1F1F2-1F1FF",
    "flag-na": "1F1F3-1F1E6",
    "flag-nc": "1F1F3-1F1E8",
    "flag-ne": "1F1F3-1F1EA",
    "flag-nf": "1F1F3-1F1EB",
    "flag-ng": "1F1F3-1F1EC",
    "flag-ni": "1F1F3-1F1EE",
    "flag-nl": "1F1F3-1F1F1",
    "flag-no": "1F1F3-1F1F4",
    "flag-np": "1F1F3-1F1F5",
    "flag-nr": "1F1F3-1F1F7",
    "flag-nu": "1F1F3-1F1FA",
    "flag-nz": "1F1F3-1F1FF",
    "flag-om": "1F1F4-1F1F2",
    "flag-pa": "1F1F5-1F1E6",
    "flag-pe": "1F1F5-1F1EA",
    "flag-pf": "1F1F5-1F1EB",
    "flag-pg": "1F1F5-1F1EC",
    "flag-ph": "1F1F5-1F1ED",
    "flag-pk": "1F1F5-1F1F0",
    "flag-pl": "1F1F5-1F1F1",
    "flag-pm": "1F1F5-1F1F2",
    "flag-pn": "1F1F5-1F1F3",
    "flag-pr": "1F1F5-1F1F7",
    "flag-ps": "1F1F5-1F1F8",
    "flag-pt": "1F1F5-1F1F9",
    "flag-pw": "1F1F5-1F1FC",
    "flag-py": "1F1F5-1F1FE",
    "flag-qa": "1F1F6-1F1E6",
    "flag-re": "1F1F7-1F1EA",
    "flag-ro": "1F1F7-1F1F4",
    "flag-rs": "1F1F7-1F1F8",
    "ru": "1F1F7-1F1FA",
    "flag-rw": "1F1F7-1F1FC",
    "flag-sa": "1F1F8-1F1E6",
    "flag-sb": "1F1F8-1F1E7",
    "flag-sc": "1F1F8-1F1E8",
    "flag-sd": "1F1F8-1F1E9",
    "flag-se": "1F1F8-1F1EA",
    "flag-sg": "1F1F8-1F1EC",
    "flag-sh": "1F1F8-1F1ED",
    "flag-si": "1F1F8-1F1EE",
    "flag-sj": "1F1F8-1F1EF",
    "flag-sk": "1F1F8-1F1F0",
    "flag-sl": "1F1F8-1F1F1",
    "flag-sm": "1F1F8-1F1F2",
    "flag-sn": "1F1F8-1F1F3",
    "flag-so": "1F1F8-1F1F4",
    "flag-sr": "1F1F8-1F1F7",
    "flag-ss": "1F1F8-1F1F8",
    "flag-st": "1F1F8-1F1F9",
    "flag-sv": "1F1F8-1F1FB",
    "flag-sx": "1F1F8-1F1FD",
    "flag-sy": "1F1F8-1F1FE",
    "flag-sz": "1F1F8-1F1FF",
    "flag-ta": "1F1F9-1F1E6",
    "flag-tc": "1F1F9-1F1E8",
    "flag-td": "1F1F9-1F1E9",
    "flag-tf": "1F1F9-1F1EB",
    "flag-tg": "1F1F9-1F1EC",
    "flag-th": "1F1F9-1F1ED",
    "flag-tj": "1F1F9-1F1EF",
    "flag-tk": "1F1F9-1F1F0",
    "flag-tl": "1F1F9-1F1F1",
    "flag-tm": "1F1F9-1F1F2",
    "flag-tn": "1F1F9-1F1F3",
    "flag-to": "1F1F9-1F1F4",
    "flag-tr": "1F1F9-1F1F7",
    "flag-tt": "1F1F9-1F1F9",
    "flag-tv": "1F1F9-1F1FB",
    "flag-tw": "1F1F9-1F1FC",
    "flag-tz": "1F1F9-1F1FF",
    "flag-ua": "1F1FA-1F1E6",
    "flag-ug": "1F1FA-1F1EC",
    "flag-um": "1F1FA-1F1F2",
    "flag-un": "1F1FA-1F1F3",
    "us": "1F1FA-1F1F8",
    "flag-uy": "1F1FA-1F1FE",
    "flag-uz": "1F1FA-1F1FF",
    "flag-va": "1F1FB-1F1E6",
    "flag-vc": "1F1FB-1F1E8",
    "flag-ve": "1F1FB-1F1EA",
    "flag-vg": "1F1FB-1F1EC",
    "flag-vi": "1F1FB-1F1EE",
    "flag-vn": "1F1FB-1F1F3",
    "flag-vu": "1F1FB-1F1FA",
    "flag-wf": "1F1FC-1F1EB",
    "flag-ws": "1F1FC-1F1F8",
    "flag-xk": "1F1FD-1F1F0",
    "flag-ye": "1F1FE-1F1EA",
    "flag-yt": "1F1FE-1F1F9",
    "flag-za": "1F1FF-1F1E6",
    "flag-zm": "1F1FF-1F1F2",
    "flag-zw": "1F1FF-1F1FC",
    "koko": "1F201",
    "sa": "1F202-FE0F",
    "u7121": "1F21A",
    "u6307": "1F22F",
    "u7981": "1F232",
    "u7a7a": "1F233",
    "u5408": "1F234",
    "u6e80": "1F235",
    "u6709": "1F236",
    "u6708": "1F237-FE0F",
    "u7533": "1F238",
    "u5272": "1F239",
    "u55b6": "1F23A",
    "ideograph_advantage": "1F250",
    "accept": "1F251",
    "cyclone": "1F300",
    "foggy": "1F301",
    "closed_umbrella": "1F302",
    "night_with_stars": "1F303",
    "sunrise_over_mountains": "1F304",
    "sunrise": "1F305",
    "city_sunset": "1F306",
    "city_sunrise": "1F307",
    "rainbow": "1F308",
    "bridge_at_night": "1F309",
    "ocean": "1F30A",
    "volcano": "1F30B",
    "milky_way": "1F30C",
    "earth_africa": "1F30D",
    "earth_americas": "1F30E",
    "earth_asia": "1F30F",
    "globe_with_meridians": "1F310",
    "new_moon": "1F311",
    "waxing_crescent_moon": "1F312",
    "first_quarter_moon": "1F313",
    "moon": "1F314",
    "full_moon": "1F315",
    "waning_gibbous_moon": "1F316",
    "last_quarter_moon": "1F317",
    "waning_crescent_moon": "1F318",
    "crescent_moon": "1F319",
    "new_moon_with_face": "1F31A",
    "first_quarter_moon_with_face": "1F31B",
    "last_quarter_moon_with_face": "1F31C",
    "full_moon_with_face": "1F31D",
    "sun_with_face": "1F31E",
    "star2": "1F31F",
    "stars": "1F320",
    "thermometer": "1F321-FE0F",
    "mostly_sunny": "1F324-FE0F",
    "barely_sunny": "1F325-FE0F",
    "partly_sunny_rain": "1F326-FE0F",
    "rain_cloud": "1F327-FE0F",
    "snow_cloud": "1F328-FE0F",
    "lightning": "1F329-FE0F",
    "tornado": "1F32A-FE0F",
    "fog": "1F32B-FE0F",
    "wind_blowing_face": "1F32C-FE0F",
    "hotdog": "1F32D",
    "taco": "1F32E",
    "burrito": "1F32F",
    "chestnut": "1F330",
    "seedling": "1F331",
    "evergreen_tree": "1F332",
    "deciduous_tree": "1F333",
    "palm_tree": "1F334",
    "cactus": "1F335",
    "hot_pepper": "1F336-FE0F",
    "tulip": "1F337",
    "cherry_blossom": "1F338",
    "rose": "1F339",
    "hibiscus": "1F33A",
    "sunflower": "1F33B",
    "blossom": "1F33C",
    "corn": "1F33D",
    "ear_of_rice": "1F33E",
    "herb": "1F33F",
    "four_leaf_clover": "1F340",
    "maple_leaf": "1F341",
    "fallen_leaf": "1F342",
    "leaves": "1F343",
    "mushroom": "1F344",
    "tomato": "1F345",
    "eggplant": "1F346",
    "grapes": "1F347",
    "melon": "1F348",
    "watermelon": "1F349",
    "tangerine": "1F34A",
    "lemon": "1F34B",
    "banana": "1F34C",
    "pineapple": "1F34D",
    "apple": "1F34E",
    "green_apple": "1F34F",
    "pear": "1F350",
    "peach": "1F351",
    "cherries": "1F352",
    "strawberry": "1F353",
    "hamburger": "1F354",
    "pizza": "1F355",
    "meat_on_bone": "1F356",
    "poultry_leg": "1F357",
    "rice_cracker": "1F358",
    "rice_ball": "1F359",
    "rice": "1F35A",
    "curry": "1F35B",
    "ramen": "1F35C",
    "spaghetti": "1F35D",
    "bread": "1F35E",
    "fries": "1F35F",
    "sweet_potato": "1F360",
    "dango": "1F361",
    "oden": "1F362",
    "sushi": "1F363",
    "fried_shrimp": "1F364",
    "fish_cake": "1F365",
    "icecream": "1F366",
    "shaved_ice": "1F367",
    "ice_cream": "1F368",
    "doughnut": "1F369",
    "cookie": "1F36A",
    "chocolate_bar": "1F36B",
    "candy": "1F36C",
    "lollipop": "1F36D",
    "custard": "1F36E",
    "honey_pot": "1F36F",
    "cake": "1F370",
    "bento": "1F371",
    "stew": "1F372",
    "fried_egg": "1F373",
    "fork_and_knife": "1F374",
    "tea": "1F375",
    "sake": "1F376",
    "wine_glass": "1F377",
    "cocktail": "1F378",
    "tropical_drink": "1F379",
    "beer": "1F37A",
    "beers": "1F37B",
    "baby_bottle": "1F37C",
    "knife_fork_plate": "1F37D-FE0F",
    "champagne": "1F37E",
    "popcorn": "1F37F",
    "ribbon": "1F380",
    "gift": "1F381",
    "birthday": "1F382",
    "jack_o_lantern": "1F383",
    "christmas_tree": "1F384",
    "santa": "1F385",
    "fireworks": "1F386",
    "sparkler": "1F387",
    "balloon": "1F388",
    "tada": "1F389",
    "confetti_ball": "1F38A",
    "tanabata_tree": "1F38B",
    "crossed_flags": "1F38C",
    "bamboo": "1F38D",
    "dolls": "1F38E",
    "flags": "1F38F",
    "wind_chime": "1F390",
    "rice_scene": "1F391",
    "school_satchel": "1F392",
    "mortar_board": "1F393",
    "medal": "1F396-FE0F",
    "reminder_ribbon": "1F397-FE0F",
    "studio_microphone": "1F399-FE0F",
    "level_slider": "1F39A-FE0F",
    "control_knobs": "1F39B-FE0F",
    "film_frames": "1F39E-FE0F",
    "admission_tickets": "1F39F-FE0F",
    "carousel_horse": "1F3A0",
    "ferris_wheel": "1F3A1",
    "roller_coaster": "1F3A2",
    "fishing_pole_and_fish": "1F3A3",
    "microphone": "1F3A4",
    "movie_camera": "1F3A5",
    "cinema": "1F3A6",
    "headphones": "1F3A7",
    "art": "1F3A8",
    "tophat": "1F3A9",
    "circus_tent": "1F3AA",
    "ticket": "1F3AB",
    "clapper": "1F3AC",
    "performing_arts": "1F3AD",
    "video_game": "1F3AE",
    "dart": "1F3AF",
    "slot_machine": "1F3B0",
    "8ball": "1F3B1",
    "game_die": "1F3B2",
    "bowling": "1F3B3",
    "flower_playing_cards": "1F3B4",
    "musical_note": "1F3B5",
    "notes": "1F3B6",
    "saxophone": "1F3B7",
    "guitar": "1F3B8",
    "musical_keyboard": "1F3B9",
    "trumpet": "1F3BA",
    "violin": "1F3BB",
    "musical_score": "1F3BC",
    "running_shirt_with_sash": "1F3BD",
    "tennis": "1F3BE",
    "ski": "1F3BF",
    "basketball": "1F3C0",
    "checkered_flag": "1F3C1",
    "snowboarder": "1F3C2",
    "woman-running": "1F3C3-200D-2640-FE0F",
    "man-running": "1F3C3-200D-2642-FE0F",
    "runner": "1F3C3-200D-2642-FE0F",
    "woman-surfing": "1F3C4-200D-2640-FE0F",
    "man-surfing": "1F3C4-200D-2642-FE0F",
    "surfer": "1F3C4-200D-2642-FE0F",
    "sports_medal": "1F3C5",
    "trophy": "1F3C6",
    "horse_racing": "1F3C7",
    "football": "1F3C8",
    "rugby_football": "1F3C9",
    "woman-swimming": "1F3CA-200D-2640-FE0F",
    "man-swimming": "1F3CA-200D-2642-FE0F",
    "swimmer": "1F3CA-200D-2642-FE0F",
    "woman-lifting-weights": "1F3CB-FE0F-200D-2640-FE0F",
    "man-lifting-weights": "1F3CB-FE0F-200D-2642-FE0F",
    "weight_lifter": "1F3CB-FE0F-200D-2642-FE0F",
    "woman-golfing": "1F3CC-FE0F-200D-2640-FE0F",
    "man-golfing": "1F3CC-FE0F-200D-2642-FE0F",
    "golfer": "1F3CC-FE0F-200D-2642-FE0F",
    "racing_motorcycle": "1F3CD-FE0F",
    "racing_car": "1F3CE-FE0F",
    "cricket_bat_and_ball": "1F3CF",
    "volleyball": "1F3D0",
    "field_hockey_stick_and_ball": "1F3D1",
    "ice_hockey_stick_and_puck": "1F3D2",
    "table_tennis_paddle_and_ball": "1F3D3",
    "snow_capped_mountain": "1F3D4-FE0F",
    "camping": "1F3D5-FE0F",
    "beach_with_umbrella": "1F3D6-FE0F",
    "building_construction": "1F3D7-FE0F",
    "house_buildings": "1F3D8-FE0F",
    "cityscape": "1F3D9-FE0F",
    "derelict_house_building": "1F3DA-FE0F",
    "classical_building": "1F3DB-FE0F",
    "desert": "1F3DC-FE0F",
    "desert_island": "1F3DD-FE0F",
    "national_park": "1F3DE-FE0F",
    "stadium": "1F3DF-FE0F",
    "house": "1F3E0",
    "house_with_garden": "1F3E1",
    "office": "1F3E2",
    "post_office": "1F3E3",
    "european_post_office": "1F3E4",
    "hospital": "1F3E5",
    "bank": "1F3E6",
    "atm": "1F3E7",
    "hotel": "1F3E8",
    "love_hotel": "1F3E9",
    "convenience_store": "1F3EA",
    "school": "1F3EB",
    "department_store": "1F3EC",
    "factory": "1F3ED",
    "izakaya_lantern": "1F3EE",
    "japanese_castle": "1F3EF",
    "european_castle": "1F3F0",
    "rainbow-flag": "1F3F3-FE0F-200D-1F308",
    "waving_white_flag": "1F3F3-FE0F",
    "flag-england": "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
    "flag-scotland": "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
    "flag-wales": "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
    "waving_black_flag": "1F3F4",
    "rosette": "1F3F5-FE0F",
    "label": "1F3F7-FE0F",
    "badminton_racquet_and_shuttlecock": "1F3F8",
    "bow_and_arrow": "1F3F9",
    "amphora": "1F3FA",
    "skin-tone-2": "1F3FB",
    "skin-tone-3": "1F3FC",
    "skin-tone-4": "1F3FD",
    "skin-tone-5": "1F3FE",
    "skin-tone-6": "1F3FF",
    "rat": "1F400",
    "mouse2": "1F401",
    "ox": "1F402",
    "water_buffalo": "1F403",
    "cow2": "1F404",
    "tiger2": "1F405",
    "leopard": "1F406",
    "rabbit2": "1F407",
    "cat2": "1F408",
    "dragon": "1F409",
    "crocodile": "1F40A",
    "whale2": "1F40B",
    "snail": "1F40C",
    "snake": "1F40D",
    "racehorse": "1F40E",
    "ram": "1F40F",
    "goat": "1F410",
    "sheep": "1F411",
    "monkey": "1F412",
    "rooster": "1F413",
    "chicken": "1F414",
    "dog2": "1F415",
    "pig2": "1F416",
    "boar": "1F417",
    "elephant": "1F418",
    "octopus": "1F419",
    "shell": "1F41A",
    "bug": "1F41B",
    "ant": "1F41C",
    "bee": "1F41D",
    "beetle": "1F41E",
    "fish": "1F41F",
    "tropical_fish": "1F420",
    "blowfish": "1F421",
    "turtle": "1F422",
    "hatching_chick": "1F423",
    "baby_chick": "1F424",
    "hatched_chick": "1F425",
    "bird": "1F426",
    "penguin": "1F427",
    "koala": "1F428",
    "poodle": "1F429",
    "dromedary_camel": "1F42A",
    "camel": "1F42B",
    "dolphin": "1F42C",
    "mouse": "1F42D",
    "cow": "1F42E",
    "tiger": "1F42F",
    "rabbit": "1F430",
    "cat": "1F431",
    "dragon_face": "1F432",
    "whale": "1F433",
    "horse": "1F434",
    "monkey_face": "1F435",
    "dog": "1F436",
    "pig": "1F437",
    "frog": "1F438",
    "hamster": "1F439",
    "wolf": "1F43A",
    "bear": "1F43B",
    "panda_face": "1F43C",
    "pig_nose": "1F43D",
    "feet": "1F43E",
    "chipmunk": "1F43F-FE0F",
    "eyes": "1F440",
    "eye-in-speech-bubble": "1F441-FE0F-200D-1F5E8-FE0F",
    "eye": "1F441-FE0F",
    "ear": "1F442",
    "nose": "1F443",
    "lips": "1F444",
    "tongue": "1F445",
    "point_up_2": "1F446",
    "point_down": "1F447",
    "point_left": "1F448",
    "point_right": "1F449",
    "facepunch": "1F44A",
    "wave": "1F44B",
    "ok_hand": "1F44C",
    "+1": "1F44D",
    "-1": "1F44E",
    "clap": "1F44F",
    "open_hands": "1F450",
    "crown": "1F451",
    "womans_hat": "1F452",
    "eyeglasses": "1F453",
    "necktie": "1F454",
    "shirt": "1F455",
    "jeans": "1F456",
    "dress": "1F457",
    "kimono": "1F458",
    "bikini": "1F459",
    "womans_clothes": "1F45A",
    "purse": "1F45B",
    "handbag": "1F45C",
    "pouch": "1F45D",
    "mans_shoe": "1F45E",
    "athletic_shoe": "1F45F",
    "high_heel": "1F460",
    "sandal": "1F461",
    "boot": "1F462",
    "footprints": "1F463",
    "bust_in_silhouette": "1F464",
    "busts_in_silhouette": "1F465",
    "boy": "1F466",
    "girl": "1F467",
    "male-farmer": "1F468-200D-1F33E",
    "male-cook": "1F468-200D-1F373",
    "male-student": "1F468-200D-1F393",
    "male-singer": "1F468-200D-1F3A4",
    "male-artist": "1F468-200D-1F3A8",
    "male-teacher": "1F468-200D-1F3EB",
    "male-factory-worker": "1F468-200D-1F3ED",
    "man-boy-boy": "1F468-200D-1F466-200D-1F466",
    "man-boy": "1F468-200D-1F466",
    "man-girl-boy": "1F468-200D-1F467-200D-1F466",
    "man-girl-girl": "1F468-200D-1F467-200D-1F467",
    "man-girl": "1F468-200D-1F467",
    "man-man-boy": "1F468-200D-1F468-200D-1F466",
    "man-man-boy-boy": "1F468-200D-1F468-200D-1F466-200D-1F466",
    "man-man-girl": "1F468-200D-1F468-200D-1F467",
    "man-man-girl-boy": "1F468-200D-1F468-200D-1F467-200D-1F466",
    "man-man-girl-girl": "1F468-200D-1F468-200D-1F467-200D-1F467",
    "man-woman-boy": "1F468-200D-1F469-200D-1F466",
    "man-woman-boy-boy": "1F468-200D-1F469-200D-1F466-200D-1F466",
    "man-woman-girl": "1F468-200D-1F469-200D-1F467",
    "man-woman-girl-boy": "1F468-200D-1F469-200D-1F467-200D-1F466",
    "man-woman-girl-girl": "1F468-200D-1F469-200D-1F467-200D-1F467",
    "male-technologist": "1F468-200D-1F4BB",
    "male-office-worker": "1F468-200D-1F4BC",
    "male-mechanic": "1F468-200D-1F527",
    "male-scientist": "1F468-200D-1F52C",
    "male-astronaut": "1F468-200D-1F680",
    "male-firefighter": "1F468-200D-1F692",
    "male-doctor": "1F468-200D-2695-FE0F",
    "male-judge": "1F468-200D-2696-FE0F",
    "male-pilot": "1F468-200D-2708-FE0F",
    "man-heart-man": "1F468-200D-2764-FE0F-200D-1F468",
    "man-kiss-man": "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
    "man": "1F468",
    "female-farmer": "1F469-200D-1F33E",
    "female-cook": "1F469-200D-1F373",
    "female-student": "1F469-200D-1F393",
    "female-singer": "1F469-200D-1F3A4",
    "female-artist": "1F469-200D-1F3A8",
    "female-teacher": "1F469-200D-1F3EB",
    "female-factory-worker": "1F469-200D-1F3ED",
    "woman-boy-boy": "1F469-200D-1F466-200D-1F466",
    "woman-boy": "1F469-200D-1F466",
    "woman-girl-boy": "1F469-200D-1F467-200D-1F466",
    "woman-girl-girl": "1F469-200D-1F467-200D-1F467",
    "woman-girl": "1F469-200D-1F467",
    "woman-woman-boy": "1F469-200D-1F469-200D-1F466",
    "woman-woman-boy-boy": "1F469-200D-1F469-200D-1F466-200D-1F466",
    "woman-woman-girl": "1F469-200D-1F469-200D-1F467",
    "woman-woman-girl-boy": "1F469-200D-1F469-200D-1F467-200D-1F466",
    "woman-woman-girl-girl": "1F469-200D-1F469-200D-1F467-200D-1F467",
    "female-technologist": "1F469-200D-1F4BB",
    "female-office-worker": "1F469-200D-1F4BC",
    "female-mechanic": "1F469-200D-1F527",
    "female-scientist": "1F469-200D-1F52C",
    "female-astronaut": "1F469-200D-1F680",
    "female-firefighter": "1F469-200D-1F692",
    "female-doctor": "1F469-200D-2695-FE0F",
    "female-judge": "1F469-200D-2696-FE0F",
    "female-pilot": "1F469-200D-2708-FE0F",
    "woman-heart-man": "1F469-200D-2764-FE0F-200D-1F468",
    "woman-heart-woman": "1F469-200D-2764-FE0F-200D-1F469",
    "woman-kiss-man": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
    "woman-kiss-woman": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
    "woman": "1F469",
    "family": "1F468-200D-1F469-200D-1F466",
    "couple": "1F46B",
    "two_men_holding_hands": "1F46C",
    "two_women_holding_hands": "1F46D",
    "female-police-officer": "1F46E-200D-2640-FE0F",
    "male-police-officer": "1F46E-200D-2642-FE0F",
    "cop": "1F46E-200D-2642-FE0F",
    "woman-with-bunny-ears-partying": "1F46F-200D-2640-FE0F",
    "man-with-bunny-ears-partying": "1F46F-200D-2642-FE0F",
    "dancers": "1F46F-200D-2640-FE0F",
    "bride_with_veil": "1F470",
    "blond-haired-woman": "1F471-200D-2640-FE0F",
    "blond-haired-man": "1F471-200D-2642-FE0F",
    "person_with_blond_hair": "1F471-200D-2642-FE0F",
    "man_with_gua_pi_mao": "1F472",
    "woman-wearing-turban": "1F473-200D-2640-FE0F",
    "man-wearing-turban": "1F473-200D-2642-FE0F",
    "man_with_turban": "1F473-200D-2642-FE0F",
    "older_man": "1F474",
    "older_woman": "1F475",
    "baby": "1F476",
    "female-construction-worker": "1F477-200D-2640-FE0F",
    "male-construction-worker": "1F477-200D-2642-FE0F",
    "construction_worker": "1F477-200D-2642-FE0F",
    "princess": "1F478",
    "japanese_ogre": "1F479",
    "japanese_goblin": "1F47A",
    "ghost": "1F47B",
    "angel": "1F47C",
    "alien": "1F47D",
    "space_invader": "1F47E",
    "imp": "1F47F",
    "skull": "1F480",
    "woman-tipping-hand": "1F481-200D-2640-FE0F",
    "man-tipping-hand": "1F481-200D-2642-FE0F",
    "information_desk_person": "1F481-200D-2640-FE0F",
    "female-guard": "1F482-200D-2640-FE0F",
    "male-guard": "1F482-200D-2642-FE0F",
    "guardsman": "1F482-200D-2642-FE0F",
    "dancer": "1F483",
    "lipstick": "1F484",
    "nail_care": "1F485",
    "woman-getting-massage": "1F486-200D-2640-FE0F",
    "man-getting-massage": "1F486-200D-2642-FE0F",
    "massage": "1F486-200D-2640-FE0F",
    "woman-getting-haircut": "1F487-200D-2640-FE0F",
    "man-getting-haircut": "1F487-200D-2642-FE0F",
    "haircut": "1F487-200D-2640-FE0F",
    "barber": "1F488",
    "syringe": "1F489",
    "pill": "1F48A",
    "kiss": "1F48B",
    "love_letter": "1F48C",
    "ring": "1F48D",
    "gem": "1F48E",
    "couplekiss": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
    "bouquet": "1F490",
    "couple_with_heart": "1F469-200D-2764-FE0F-200D-1F468",
    "wedding": "1F492",
    "heartbeat": "1F493",
    "broken_heart": "1F494",
    "two_hearts": "1F495",
    "sparkling_heart": "1F496",
    "heartpulse": "1F497",
    "cupid": "1F498",
    "blue_heart": "1F499",
    "green_heart": "1F49A",
    "yellow_heart": "1F49B",
    "purple_heart": "1F49C",
    "gift_heart": "1F49D",
    "revolving_hearts": "1F49E",
    "heart_decoration": "1F49F",
    "diamond_shape_with_a_dot_inside": "1F4A0",
    "bulb": "1F4A1",
    "anger": "1F4A2",
    "bomb": "1F4A3",
    "zzz": "1F4A4",
    "boom": "1F4A5",
    "sweat_drops": "1F4A6",
    "droplet": "1F4A7",
    "dash": "1F4A8",
    "hankey": "1F4A9",
    "muscle": "1F4AA",
    "dizzy": "1F4AB",
    "speech_balloon": "1F4AC",
    "thought_balloon": "1F4AD",
    "white_flower": "1F4AE",
    "100": "1F4AF",
    "moneybag": "1F4B0",
    "currency_exchange": "1F4B1",
    "heavy_dollar_sign": "1F4B2",
    "credit_card": "1F4B3",
    "yen": "1F4B4",
    "dollar": "1F4B5",
    "euro": "1F4B6",
    "pound": "1F4B7",
    "money_with_wings": "1F4B8",
    "chart": "1F4B9",
    "seat": "1F4BA",
    "computer": "1F4BB",
    "briefcase": "1F4BC",
    "minidisc": "1F4BD",
    "floppy_disk": "1F4BE",
    "cd": "1F4BF",
    "dvd": "1F4C0",
    "file_folder": "1F4C1",
    "open_file_folder": "1F4C2",
    "page_with_curl": "1F4C3",
    "page_facing_up": "1F4C4",
    "date": "1F4C5",
    "calendar": "1F4C6",
    "card_index": "1F4C7",
    "chart_with_upwards_trend": "1F4C8",
    "chart_with_downwards_trend": "1F4C9",
    "bar_chart": "1F4CA",
    "clipboard": "1F4CB",
    "pushpin": "1F4CC",
    "round_pushpin": "1F4CD",
    "paperclip": "1F4CE",
    "straight_ruler": "1F4CF",
    "triangular_ruler": "1F4D0",
    "bookmark_tabs": "1F4D1",
    "ledger": "1F4D2",
    "notebook": "1F4D3",
    "notebook_with_decorative_cover": "1F4D4",
    "closed_book": "1F4D5",
    "book": "1F4D6",
    "green_book": "1F4D7",
    "blue_book": "1F4D8",
    "orange_book": "1F4D9",
    "books": "1F4DA",
    "name_badge": "1F4DB",
    "scroll": "1F4DC",
    "memo": "1F4DD",
    "telephone_receiver": "1F4DE",
    "pager": "1F4DF",
    "fax": "1F4E0",
    "satellite_antenna": "1F4E1",
    "loudspeaker": "1F4E2",
    "mega": "1F4E3",
    "outbox_tray": "1F4E4",
    "inbox_tray": "1F4E5",
    "package": "1F4E6",
    "e-mail": "1F4E7",
    "incoming_envelope": "1F4E8",
    "envelope_with_arrow": "1F4E9",
    "mailbox_closed": "1F4EA",
    "mailbox": "1F4EB",
    "mailbox_with_mail": "1F4EC",
    "mailbox_with_no_mail": "1F4ED",
    "postbox": "1F4EE",
    "postal_horn": "1F4EF",
    "newspaper": "1F4F0",
    "iphone": "1F4F1",
    "calling": "1F4F2",
    "vibration_mode": "1F4F3",
    "mobile_phone_off": "1F4F4",
    "no_mobile_phones": "1F4F5",
    "signal_strength": "1F4F6",
    "camera": "1F4F7",
    "camera_with_flash": "1F4F8",
    "video_camera": "1F4F9",
    "tv": "1F4FA",
    "radio": "1F4FB",
    "vhs": "1F4FC",
    "film_projector": "1F4FD-FE0F",
    "prayer_beads": "1F4FF",
    "twisted_rightwards_arrows": "1F500",
    "repeat": "1F501",
    "repeat_one": "1F502",
    "arrows_clockwise": "1F503",
    "arrows_counterclockwise": "1F504",
    "low_brightness": "1F505",
    "high_brightness": "1F506",
    "mute": "1F507",
    "speaker": "1F508",
    "sound": "1F509",
    "loud_sound": "1F50A",
    "battery": "1F50B",
    "electric_plug": "1F50C",
    "mag": "1F50D",
    "mag_right": "1F50E",
    "lock_with_ink_pen": "1F50F",
    "closed_lock_with_key": "1F510",
    "key": "1F511",
    "lock": "1F512",
    "unlock": "1F513",
    "bell": "1F514",
    "no_bell": "1F515",
    "bookmark": "1F516",
    "link": "1F517",
    "radio_button": "1F518",
    "back": "1F519",
    "end": "1F51A",
    "on": "1F51B",
    "soon": "1F51C",
    "top": "1F51D",
    "underage": "1F51E",
    "keycap_ten": "1F51F",
    "capital_abcd": "1F520",
    "abcd": "1F521",
    "1234": "1F522",
    "symbols": "1F523",
    "abc": "1F524",
    "fire": "1F525",
    "flashlight": "1F526",
    "wrench": "1F527",
    "hammer": "1F528",
    "nut_and_bolt": "1F529",
    "hocho": "1F52A",
    "gun": "1F52B",
    "microscope": "1F52C",
    "telescope": "1F52D",
    "crystal_ball": "1F52E",
    "six_pointed_star": "1F52F",
    "beginner": "1F530",
    "trident": "1F531",
    "black_square_button": "1F532",
    "white_square_button": "1F533",
    "red_circle": "1F534",
    "large_blue_circle": "1F535",
    "large_orange_diamond": "1F536",
    "large_blue_diamond": "1F537",
    "small_orange_diamond": "1F538",
    "small_blue_diamond": "1F539",
    "small_red_triangle": "1F53A",
    "small_red_triangle_down": "1F53B",
    "arrow_up_small": "1F53C",
    "arrow_down_small": "1F53D",
    "om_symbol": "1F549-FE0F",
    "dove_of_peace": "1F54A-FE0F",
    "kaaba": "1F54B",
    "mosque": "1F54C",
    "synagogue": "1F54D",
    "menorah_with_nine_branches": "1F54E",
    "clock1": "1F550",
    "clock2": "1F551",
    "clock3": "1F552",
    "clock4": "1F553",
    "clock5": "1F554",
    "clock6": "1F555",
    "clock7": "1F556",
    "clock8": "1F557",
    "clock9": "1F558",
    "clock10": "1F559",
    "clock11": "1F55A",
    "clock12": "1F55B",
    "clock130": "1F55C",
    "clock230": "1F55D",
    "clock330": "1F55E",
    "clock430": "1F55F",
    "clock530": "1F560",
    "clock630": "1F561",
    "clock730": "1F562",
    "clock830": "1F563",
    "clock930": "1F564",
    "clock1030": "1F565",
    "clock1130": "1F566",
    "clock1230": "1F567",
    "candle": "1F56F-FE0F",
    "mantelpiece_clock": "1F570-FE0F",
    "hole": "1F573-FE0F",
    "man_in_business_suit_levitating": "1F574-FE0F",
    "female-detective": "1F575-FE0F-200D-2640-FE0F",
    "male-detective": "1F575-FE0F-200D-2642-FE0F",
    "sleuth_or_spy": "1F575-FE0F-200D-2642-FE0F",
    "dark_sunglasses": "1F576-FE0F",
    "spider": "1F577-FE0F",
    "spider_web": "1F578-FE0F",
    "joystick": "1F579-FE0F",
    "man_dancing": "1F57A",
    "linked_paperclips": "1F587-FE0F",
    "lower_left_ballpoint_pen": "1F58A-FE0F",
    "lower_left_fountain_pen": "1F58B-FE0F",
    "lower_left_paintbrush": "1F58C-FE0F",
    "lower_left_crayon": "1F58D-FE0F",
    "raised_hand_with_fingers_splayed": "1F590-FE0F",
    "middle_finger": "1F595",
    "spock-hand": "1F596",
    "black_heart": "1F5A4",
    "desktop_computer": "1F5A5-FE0F",
    "printer": "1F5A8-FE0F",
    "three_button_mouse": "1F5B1-FE0F",
    "trackball": "1F5B2-FE0F",
    "frame_with_picture": "1F5BC-FE0F",
    "card_index_dividers": "1F5C2-FE0F",
    "card_file_box": "1F5C3-FE0F",
    "file_cabinet": "1F5C4-FE0F",
    "wastebasket": "1F5D1-FE0F",
    "spiral_note_pad": "1F5D2-FE0F",
    "spiral_calendar_pad": "1F5D3-FE0F",
    "compression": "1F5DC-FE0F",
    "old_key": "1F5DD-FE0F",
    "rolled_up_newspaper": "1F5DE-FE0F",
    "dagger_knife": "1F5E1-FE0F",
    "speaking_head_in_silhouette": "1F5E3-FE0F",
    "left_speech_bubble": "1F5E8-FE0F",
    "right_anger_bubble": "1F5EF-FE0F",
    "ballot_box_with_ballot": "1F5F3-FE0F",
    "world_map": "1F5FA-FE0F",
    "mount_fuji": "1F5FB",
    "tokyo_tower": "1F5FC",
    "statue_of_liberty": "1F5FD",
    "japan": "1F5FE",
    "moyai": "1F5FF",
    "grinning": "1F600",
    "grin": "1F601",
    "joy": "1F602",
    "smiley": "1F603",
    "smile": "1F604",
    "sweat_smile": "1F605",
    "laughing": "1F606",
    "innocent": "1F607",
    "smiling_imp": "1F608",
    "wink": "1F609",
    "blush": "1F60A",
    "yum": "1F60B",
    "relieved": "1F60C",
    "heart_eyes": "1F60D",
    "sunglasses": "1F60E",
    "smirk": "1F60F",
    "neutral_face": "1F610",
    "expressionless": "1F611",
    "unamused": "1F612",
    "sweat": "1F613",
    "pensive": "1F614",
    "confused": "1F615",
    "confounded": "1F616",
    "kissing": "1F617",
    "kissing_heart": "1F618",
    "kissing_smiling_eyes": "1F619",
    "kissing_closed_eyes": "1F61A",
    "stuck_out_tongue": "1F61B",
    "stuck_out_tongue_winking_eye": "1F61C",
    "stuck_out_tongue_closed_eyes": "1F61D",
    "disappointed": "1F61E",
    "worried": "1F61F",
    "angry": "1F620",
    "rage": "1F621",
    "cry": "1F622",
    "persevere": "1F623",
    "triumph": "1F624",
    "disappointed_relieved": "1F625",
    "frowning": "1F626",
    "anguished": "1F627",
    "fearful": "1F628",
    "weary": "1F629",
    "sleepy": "1F62A",
    "tired_face": "1F62B",
    "grimacing": "1F62C",
    "sob": "1F62D",
    "open_mouth": "1F62E",
    "hushed": "1F62F",
    "cold_sweat": "1F630",
    "scream": "1F631",
    "astonished": "1F632",
    "flushed": "1F633",
    "sleeping": "1F634",
    "dizzy_face": "1F635",
    "no_mouth": "1F636",
    "mask": "1F637",
    "smile_cat": "1F638",
    "joy_cat": "1F639",
    "smiley_cat": "1F63A",
    "heart_eyes_cat": "1F63B",
    "smirk_cat": "1F63C",
    "kissing_cat": "1F63D",
    "pouting_cat": "1F63E",
    "crying_cat_face": "1F63F",
    "scream_cat": "1F640",
    "slightly_frowning_face": "1F641",
    "slightly_smiling_face": "1F642",
    "upside_down_face": "1F643",
    "face_with_rolling_eyes": "1F644",
    "woman-gesturing-no": "1F645-200D-2640-FE0F",
    "man-gesturing-no": "1F645-200D-2642-FE0F",
    "no_good": "1F645-200D-2640-FE0F",
    "woman-gesturing-ok": "1F646-200D-2640-FE0F",
    "man-gesturing-ok": "1F646-200D-2642-FE0F",
    "ok_woman": "1F646-200D-2640-FE0F",
    "woman-bowing": "1F647-200D-2640-FE0F",
    "man-bowing": "1F647-200D-2642-FE0F",
    "bow": "1F647-200D-2642-FE0F",
    "see_no_evil": "1F648",
    "hear_no_evil": "1F649",
    "speak_no_evil": "1F64A",
    "woman-raising-hand": "1F64B-200D-2640-FE0F",
    "man-raising-hand": "1F64B-200D-2642-FE0F",
    "raising_hand": "1F64B-200D-2640-FE0F",
    "raised_hands": "1F64C",
    "woman-frowning": "1F64D-200D-2640-FE0F",
    "man-frowning": "1F64D-200D-2642-FE0F",
    "person_frowning": "1F64D-200D-2640-FE0F",
    "woman-pouting": "1F64E-200D-2640-FE0F",
    "man-pouting": "1F64E-200D-2642-FE0F",
    "person_with_pouting_face": "1F64E-200D-2640-FE0F",
    "pray": "1F64F",
    "rocket": "1F680",
    "helicopter": "1F681",
    "steam_locomotive": "1F682",
    "railway_car": "1F683",
    "bullettrain_side": "1F684",
    "bullettrain_front": "1F685",
    "train2": "1F686",
    "metro": "1F687",
    "light_rail": "1F688",
    "station": "1F689",
    "tram": "1F68A",
    "train": "1F68B",
    "bus": "1F68C",
    "oncoming_bus": "1F68D",
    "trolleybus": "1F68E",
    "busstop": "1F68F",
    "minibus": "1F690",
    "ambulance": "1F691",
    "fire_engine": "1F692",
    "police_car": "1F693",
    "oncoming_police_car": "1F694",
    "taxi": "1F695",
    "oncoming_taxi": "1F696",
    "car": "1F697",
    "oncoming_automobile": "1F698",
    "blue_car": "1F699",
    "truck": "1F69A",
    "articulated_lorry": "1F69B",
    "tractor": "1F69C",
    "monorail": "1F69D",
    "mountain_railway": "1F69E",
    "suspension_railway": "1F69F",
    "mountain_cableway": "1F6A0",
    "aerial_tramway": "1F6A1",
    "ship": "1F6A2",
    "woman-rowing-boat": "1F6A3-200D-2640-FE0F",
    "man-rowing-boat": "1F6A3-200D-2642-FE0F",
    "rowboat": "1F6A3-200D-2642-FE0F",
    "speedboat": "1F6A4",
    "traffic_light": "1F6A5",
    "vertical_traffic_light": "1F6A6",
    "construction": "1F6A7",
    "rotating_light": "1F6A8",
    "triangular_flag_on_post": "1F6A9",
    "door": "1F6AA",
    "no_entry_sign": "1F6AB",
    "smoking": "1F6AC",
    "no_smoking": "1F6AD",
    "put_litter_in_its_place": "1F6AE",
    "do_not_litter": "1F6AF",
    "potable_water": "1F6B0",
    "non-potable_water": "1F6B1",
    "bike": "1F6B2",
    "no_bicycles": "1F6B3",
    "woman-biking": "1F6B4-200D-2640-FE0F",
    "man-biking": "1F6B4-200D-2642-FE0F",
    "bicyclist": "1F6B4-200D-2642-FE0F",
    "woman-mountain-biking": "1F6B5-200D-2640-FE0F",
    "man-mountain-biking": "1F6B5-200D-2642-FE0F",
    "mountain_bicyclist": "1F6B5-200D-2642-FE0F",
    "woman-walking": "1F6B6-200D-2640-FE0F",
    "man-walking": "1F6B6-200D-2642-FE0F",
    "walking": "1F6B6-200D-2642-FE0F",
    "no_pedestrians": "1F6B7",
    "children_crossing": "1F6B8",
    "mens": "1F6B9",
    "womens": "1F6BA",
    "restroom": "1F6BB",
    "baby_symbol": "1F6BC",
    "toilet": "1F6BD",
    "wc": "1F6BE",
    "shower": "1F6BF",
    "bath": "1F6C0",
    "bathtub": "1F6C1",
    "passport_control": "1F6C2",
    "customs": "1F6C3",
    "baggage_claim": "1F6C4",
    "left_luggage": "1F6C5",
    "couch_and_lamp": "1F6CB-FE0F",
    "sleeping_accommodation": "1F6CC",
    "shopping_bags": "1F6CD-FE0F",
    "bellhop_bell": "1F6CE-FE0F",
    "bed": "1F6CF-FE0F",
    "place_of_worship": "1F6D0",
    "octagonal_sign": "1F6D1",
    "shopping_trolley": "1F6D2",
    "hammer_and_wrench": "1F6E0-FE0F",
    "shield": "1F6E1-FE0F",
    "oil_drum": "1F6E2-FE0F",
    "motorway": "1F6E3-FE0F",
    "railway_track": "1F6E4-FE0F",
    "motor_boat": "1F6E5-FE0F",
    "small_airplane": "1F6E9-FE0F",
    "airplane_departure": "1F6EB",
    "airplane_arriving": "1F6EC",
    "satellite": "1F6F0-FE0F",
    "passenger_ship": "1F6F3-FE0F",
    "scooter": "1F6F4",
    "motor_scooter": "1F6F5",
    "canoe": "1F6F6",
    "sled": "1F6F7",
    "flying_saucer": "1F6F8",
    "zipper_mouth_face": "1F910",
    "money_mouth_face": "1F911",
    "face_with_thermometer": "1F912",
    "nerd_face": "1F913",
    "thinking_face": "1F914",
    "face_with_head_bandage": "1F915",
    "robot_face": "1F916",
    "hugging_face": "1F917",
    "the_horns": "1F918",
    "call_me_hand": "1F919",
    "raised_back_of_hand": "1F91A",
    "left-facing_fist": "1F91B",
    "right-facing_fist": "1F91C",
    "handshake": "1F91D",
    "crossed_fingers": "1F91E",
    "i_love_you_hand_sign": "1F91F",
    "face_with_cowboy_hat": "1F920",
    "clown_face": "1F921",
    "nauseated_face": "1F922",
    "rolling_on_the_floor_laughing": "1F923",
    "drooling_face": "1F924",
    "lying_face": "1F925",
    "woman-facepalming": "1F926-200D-2640-FE0F",
    "man-facepalming": "1F926-200D-2642-FE0F",
    "face_palm": "1F926",
    "sneezing_face": "1F927",
    "face_with_raised_eyebrow": "1F928",
    "star-struck": "1F929",
    "zany_face": "1F92A",
    "shushing_face": "1F92B",
    "face_with_symbols_on_mouth": "1F92C",
    "face_with_hand_over_mouth": "1F92D",
    "face_vomiting": "1F92E",
    "exploding_head": "1F92F",
    "pregnant_woman": "1F930",
    "breast-feeding": "1F931",
    "palms_up_together": "1F932",
    "selfie": "1F933",
    "prince": "1F934",
    "man_in_tuxedo": "1F935",
    "mrs_claus": "1F936",
    "woman-shrugging": "1F937-200D-2640-FE0F",
    "man-shrugging": "1F937-200D-2642-FE0F",
    "shrug": "1F937",
    "woman-cartwheeling": "1F938-200D-2640-FE0F",
    "man-cartwheeling": "1F938-200D-2642-FE0F",
    "person_doing_cartwheel": "1F938",
    "woman-juggling": "1F939-200D-2640-FE0F",
    "man-juggling": "1F939-200D-2642-FE0F",
    "juggling": "1F939",
    "fencer": "1F93A",
    "woman-wrestling": "1F93C-200D-2640-FE0F",
    "man-wrestling": "1F93C-200D-2642-FE0F",
    "wrestlers": "1F93C",
    "woman-playing-water-polo": "1F93D-200D-2640-FE0F",
    "man-playing-water-polo": "1F93D-200D-2642-FE0F",
    "water_polo": "1F93D",
    "woman-playing-handball": "1F93E-200D-2640-FE0F",
    "man-playing-handball": "1F93E-200D-2642-FE0F",
    "handball": "1F93E",
    "wilted_flower": "1F940",
    "drum_with_drumsticks": "1F941",
    "clinking_glasses": "1F942",
    "tumbler_glass": "1F943",
    "spoon": "1F944",
    "goal_net": "1F945",
    "first_place_medal": "1F947",
    "second_place_medal": "1F948",
    "third_place_medal": "1F949",
    "boxing_glove": "1F94A",
    "martial_arts_uniform": "1F94B",
    "curling_stone": "1F94C",
    "croissant": "1F950",
    "avocado": "1F951",
    "cucumber": "1F952",
    "bacon": "1F953",
    "potato": "1F954",
    "carrot": "1F955",
    "baguette_bread": "1F956",
    "green_salad": "1F957",
    "shallow_pan_of_food": "1F958",
    "stuffed_flatbread": "1F959",
    "egg": "1F95A",
    "glass_of_milk": "1F95B",
    "peanuts": "1F95C",
    "kiwifruit": "1F95D",
    "pancakes": "1F95E",
    "dumpling": "1F95F",
    "fortune_cookie": "1F960",
    "takeout_box": "1F961",
    "chopsticks": "1F962",
    "bowl_with_spoon": "1F963",
    "cup_with_straw": "1F964",
    "coconut": "1F965",
    "broccoli": "1F966",
    "pie": "1F967",
    "pretzel": "1F968",
    "cut_of_meat": "1F969",
    "sandwich": "1F96A",
    "canned_food": "1F96B",
    "crab": "1F980",
    "lion_face": "1F981",
    "scorpion": "1F982",
    "turkey": "1F983",
    "unicorn_face": "1F984",
    "eagle": "1F985",
    "duck": "1F986",
    "bat": "1F987",
    "shark": "1F988",
    "owl": "1F989",
    "fox_face": "1F98A",
    "butterfly": "1F98B",
    "deer": "1F98C",
    "gorilla": "1F98D",
    "lizard": "1F98E",
    "rhinoceros": "1F98F",
    "shrimp": "1F990",
    "squid": "1F991",
    "giraffe_face": "1F992",
    "zebra_face": "1F993",
    "hedgehog": "1F994",
    "sauropod": "1F995",
    "t-rex": "1F996",
    "cricket": "1F997",
    "cheese_wedge": "1F9C0",
    "face_with_monocle": "1F9D0",
    "adult": "1F9D1",
    "child": "1F9D2",
    "older_adult": "1F9D3",
    "bearded_person": "1F9D4",
    "person_with_headscarf": "1F9D5",
    "woman_in_steamy_room": "1F9D6-200D-2640-FE0F",
    "man_in_steamy_room": "1F9D6-200D-2642-FE0F",
    "person_in_steamy_room": "1F9D6-200D-2642-FE0F",
    "woman_climbing": "1F9D7-200D-2640-FE0F",
    "man_climbing": "1F9D7-200D-2642-FE0F",
    "person_climbing": "1F9D7-200D-2640-FE0F",
    "woman_in_lotus_position": "1F9D8-200D-2640-FE0F",
    "man_in_lotus_position": "1F9D8-200D-2642-FE0F",
    "person_in_lotus_position": "1F9D8-200D-2640-FE0F",
    "female_mage": "1F9D9-200D-2640-FE0F",
    "male_mage": "1F9D9-200D-2642-FE0F",
    "mage": "1F9D9-200D-2640-FE0F",
    "female_fairy": "1F9DA-200D-2640-FE0F",
    "male_fairy": "1F9DA-200D-2642-FE0F",
    "fairy": "1F9DA-200D-2640-FE0F",
    "female_vampire": "1F9DB-200D-2640-FE0F",
    "male_vampire": "1F9DB-200D-2642-FE0F",
    "vampire": "1F9DB-200D-2640-FE0F",
    "mermaid": "1F9DC-200D-2640-FE0F",
    "merman": "1F9DC-200D-2642-FE0F",
    "merperson": "1F9DC-200D-2642-FE0F",
    "female_elf": "1F9DD-200D-2640-FE0F",
    "male_elf": "1F9DD-200D-2642-FE0F",
    "elf": "1F9DD-200D-2642-FE0F",
    "female_genie": "1F9DE-200D-2640-FE0F",
    "male_genie": "1F9DE-200D-2642-FE0F",
    "genie": "1F9DE-200D-2642-FE0F",
    "female_zombie": "1F9DF-200D-2640-FE0F",
    "male_zombie": "1F9DF-200D-2642-FE0F",
    "zombie": "1F9DF-200D-2642-FE0F",
    "brain": "1F9E0",
    "orange_heart": "1F9E1",
    "billed_cap": "1F9E2",
    "scarf": "1F9E3",
    "gloves": "1F9E4",
    "coat": "1F9E5",
    "socks": "1F9E6",
    "bangbang": "203C-FE0F",
    "interrobang": "2049-FE0F",
    "tm": "2122-FE0F",
    "information_source": "2139-FE0F",
    "left_right_arrow": "2194-FE0F",
    "arrow_up_down": "2195-FE0F",
    "arrow_upper_left": "2196-FE0F",
    "arrow_upper_right": "2197-FE0F",
    "arrow_lower_right": "2198-FE0F",
    "arrow_lower_left": "2199-FE0F",
    "leftwards_arrow_with_hook": "21A9-FE0F",
    "arrow_right_hook": "21AA-FE0F",
    "watch": "231A",
    "hourglass": "231B",
    "keyboard": "2328-FE0F",
    "eject": "23CF-FE0F",
    "fast_forward": "23E9",
    "rewind": "23EA",
    "arrow_double_up": "23EB",
    "arrow_double_down": "23EC",
    "black_right_pointing_double_triangle_with_vertical_bar": "23ED-FE0F",
    "black_left_pointing_double_triangle_with_vertical_bar": "23EE-FE0F",
    "black_right_pointing_triangle_with_double_vertical_bar": "23EF-FE0F",
    "alarm_clock": "23F0",
    "stopwatch": "23F1-FE0F",
    "timer_clock": "23F2-FE0F",
    "hourglass_flowing_sand": "23F3",
    "double_vertical_bar": "23F8-FE0F",
    "black_square_for_stop": "23F9-FE0F",
    "black_circle_for_record": "23FA-FE0F",
    "m": "24C2-FE0F",
    "black_small_square": "25AA-FE0F",
    "white_small_square": "25AB-FE0F",
    "arrow_forward": "25B6-FE0F",
    "arrow_backward": "25C0-FE0F",
    "white_medium_square": "25FB-FE0F",
    "black_medium_square": "25FC-FE0F",
    "white_medium_small_square": "25FD",
    "black_medium_small_square": "25FE",
    "sunny": "2600-FE0F",
    "cloud": "2601-FE0F",
    "umbrella": "2602-FE0F",
    "snowman": "2603-FE0F",
    "comet": "2604-FE0F",
    "phone": "260E-FE0F",
    "ballot_box_with_check": "2611-FE0F",
    "umbrella_with_rain_drops": "2614",
    "coffee": "2615",
    "shamrock": "2618-FE0F",
    "point_up": "261D-FE0F",
    "skull_and_crossbones": "2620-FE0F",
    "radioactive_sign": "2622-FE0F",
    "biohazard_sign": "2623-FE0F",
    "orthodox_cross": "2626-FE0F",
    "star_and_crescent": "262A-FE0F",
    "peace_symbol": "262E-FE0F",
    "yin_yang": "262F-FE0F",
    "wheel_of_dharma": "2638-FE0F",
    "white_frowning_face": "2639-FE0F",
    "relaxed": "263A-FE0F",
    "female_sign": "2640-FE0F",
    "male_sign": "2642-FE0F",
    "aries": "2648",
    "taurus": "2649",
    "gemini": "264A",
    "cancer": "264B",
    "leo": "264C",
    "virgo": "264D",
    "libra": "264E",
    "scorpius": "264F",
    "sagittarius": "2650",
    "capricorn": "2651",
    "aquarius": "2652",
    "pisces": "2653",
    "spades": "2660-FE0F",
    "clubs": "2663-FE0F",
    "hearts": "2665-FE0F",
    "diamonds": "2666-FE0F",
    "hotsprings": "2668-FE0F",
    "recycle": "267B-FE0F",
    "wheelchair": "267F",
    "hammer_and_pick": "2692-FE0F",
    "anchor": "2693",
    "crossed_swords": "2694-FE0F",
    "medical_symbol": "2695-FE0F",
    "scales": "2696-FE0F",
    "alembic": "2697-FE0F",
    "gear": "2699-FE0F",
    "atom_symbol": "269B-FE0F",
    "fleur_de_lis": "269C-FE0F",
    "warning": "26A0-FE0F",
    "zap": "26A1",
    "white_circle": "26AA",
    "black_circle": "26AB",
    "coffin": "26B0-FE0F",
    "funeral_urn": "26B1-FE0F",
    "soccer": "26BD",
    "baseball": "26BE",
    "snowman_without_snow": "26C4",
    "partly_sunny": "26C5",
    "thunder_cloud_and_rain": "26C8-FE0F",
    "ophiuchus": "26CE",
    "pick": "26CF-FE0F",
    "helmet_with_white_cross": "26D1-FE0F",
    "chains": "26D3-FE0F",
    "no_entry": "26D4",
    "shinto_shrine": "26E9-FE0F",
    "church": "26EA",
    "mountain": "26F0-FE0F",
    "umbrella_on_ground": "26F1-FE0F",
    "fountain": "26F2",
    "golf": "26F3",
    "ferry": "26F4-FE0F",
    "boat": "26F5",
    "skier": "26F7-FE0F",
    "ice_skate": "26F8-FE0F",
    "woman-bouncing-ball": "26F9-FE0F-200D-2640-FE0F",
    "man-bouncing-ball": "26F9-FE0F-200D-2642-FE0F",
    "person_with_ball": "26F9-FE0F-200D-2642-FE0F",
    "tent": "26FA",
    "fuelpump": "26FD",
    "scissors": "2702-FE0F",
    "white_check_mark": "2705",
    "airplane": "2708-FE0F",
    "email": "2709-FE0F",
    "fist": "270A",
    "hand": "270B",
    "v": "270C-FE0F",
    "writing_hand": "270D-FE0F",
    "pencil2": "270F-FE0F",
    "black_nib": "2712-FE0F",
    "heavy_check_mark": "2714-FE0F",
    "heavy_multiplication_x": "2716-FE0F",
    "latin_cross": "271D-FE0F",
    "star_of_david": "2721-FE0F",
    "sparkles": "2728",
    "eight_spoked_asterisk": "2733-FE0F",
    "eight_pointed_black_star": "2734-FE0F",
    "snowflake": "2744-FE0F",
    "sparkle": "2747-FE0F",
    "x": "274C",
    "negative_squared_cross_mark": "274E",
    "question": "2753",
    "grey_question": "2754",
    "grey_exclamation": "2755",
    "exclamation": "2757",
    "heavy_heart_exclamation_mark_ornament": "2763-FE0F",
    "heart": "2764-FE0F",
    "heavy_plus_sign": "2795",
    "heavy_minus_sign": "2796",
    "heavy_division_sign": "2797",
    "arrow_right": "27A1-FE0F",
    "curly_loop": "27B0",
    "loop": "27BF",
    "arrow_heading_up": "2934-FE0F",
    "arrow_heading_down": "2935-FE0F",
    "arrow_left": "2B05-FE0F",
    "arrow_up": "2B06-FE0F",
    "arrow_down": "2B07-FE0F",
    "black_large_square": "2B1B",
    "white_large_square": "2B1C",
    "star": "2B50",
    "o": "2B55",
    "wavy_dash": "3030-FE0F",
    "part_alternation_mark": "303D-FE0F",
    "congratulations": "3297-FE0F",
    "secret": "3299-FE0F"
};
